/* Auto-generated: Variant mapping A -> B (by SKU)
   Generated: 2026-07-13 09:45
   Active mappings: 2957 (across 230 products)
   Unmapped Store A variants: 26
   Stores: k1kp02-3c.myshopify.com -> p0i1n5-0k.myshopify.com
*/
const variantMap = {
  // ─── 160x Black (9 variants) ───
  "64899236954461": "57893410275663", // 36  [SKU: 160x-black-36]
  "64899236987229": "57893410308431", // 37  [SKU: 160x-black-37]
  "64899237019997": "57893410341199", // 38  [SKU: 160x-black-38]
  "64899237052765": "57893410373967", // 39  [SKU: 160x-black-39]
  "64899237085533": "57893410406735", // 40  [SKU: 160x-black-40]
  "64899237118301": "57893410439503", // 41  [SKU: 160x-black-41]
  "64899237151069": "57893410472271", // 42  [SKU: 160x-black-42]
  "64899237183837": "57893410505039", // 43  [SKU: 160x-black-43]
  "64899237216605": "57893410537807", // 44  [SKU: 160x-black-44]
  // ─── 160x White Black (9 variants) ───
  "64899238396253": "57893411684687", // 36  [SKU: 160x-white-black-36]
  "64899238429021": "57893411717455", // 37  [SKU: 160x-white-black-37]
  "64899238461789": "57893411750223", // 38  [SKU: 160x-white-black-38]
  "64899238494557": "57893411782991", // 39  [SKU: 160x-white-black-39]
  "64899238527325": "57893411815759", // 40  [SKU: 160x-white-black-40]
  "64899238560093": "57893411848527", // 41  [SKU: 160x-white-black-41]
  "64899238592861": "57893411881295", // 42  [SKU: 160x-white-black-42]
  "64899238625629": "57893411914063", // 43  [SKU: 160x-white-black-43]
  "64899238658397": "57893411946831", // 44  [SKU: 160x-white-black-44]
  // ─── 1917 Black (8 variants) ───
  "64899656810845": "57893274550607", // 38  [SKU: 1917-black-38]
  "64899656843613": "57893274583375", // 39  [SKU: 1917-black-39]
  "64899656876381": "57893274616143", // 40  [SKU: 1917-black-40]
  "64899656909149": "57893274648911", // 41  [SKU: 1917-black-41]
  "64899656941917": "57893274681679", // 42  [SKU: 1917-black-42]
  "64899656974685": "57893274714447", // 43  [SKU: 1917-black-43]
  "64899657007453": "57893274747215", // 44  [SKU: 1917-black-44]
  "64899657040221": "57893274779983", // 45  [SKU: 1917-black-45]
  // ─── 1917 White (8 variants) ───
  "64899239838045": "57893412176207", // 38  [SKU: 1917-white-38]
  "64899239870813": "57893412208975", // 39  [SKU: 1917-white-39]
  "64899239903581": "57893412241743", // 40  [SKU: 1917-white-40]
  "64899239936349": "57893412274511", // 41  [SKU: 1917-white-41]
  "64899239969117": "57893412307279", // 42  [SKU: 1917-white-42]
  "64899240001885": "57893412340047", // 43  [SKU: 1917-white-43]
  "64899240034653": "57893412372815", // 44  [SKU: 1917-white-44]
  "64899240067421": "57893412405583", // 45  [SKU: 1917-white-45]
  // ─── AeroStride Classic (24 variants) ───
  "64899241181533": "57893274943823", // 35  [SKU: aerostride-classic-35-blauw-gaas]
  "64899241214301": "57893274976591", // 35  [SKU: aerostride-classic-35-bruin-gaas]
  "64899241247069": "57893275009359", // 35  [SKU: aerostride-classic-35-blauw-leer]
  "64899241279837": "57893275042127", // 35  [SKU: aerostride-classic-35-bruin-leer]
  "64899241312605": "57893275074895", // 36  [SKU: aerostride-classic-36-blauw-gaas]
  "64899241345373": "57893275107663", // 36  [SKU: aerostride-classic-36-bruin-gaas]
  "64899241378141": "57893275140431", // 36  [SKU: aerostride-classic-36-blauw-leer]
  "64899241410909": "57893275173199", // 36  [SKU: aerostride-classic-36-bruin-leer]
  "64899241443677": "57893275205967", // 37  [SKU: aerostride-classic-37-blauw-gaas]
  "64899241476445": "57893275238735", // 37  [SKU: aerostride-classic-37-bruin-gaas]
  "64899241509213": "57893275271503", // 37  [SKU: aerostride-classic-37-blauw-leer]
  "64899241541981": "57893275304271", // 37  [SKU: aerostride-classic-37-bruin-leer]
  "64899241574749": "57893275337039", // 38  [SKU: aerostride-classic-38-blauw-gaas]
  "64899241607517": "57893275402575", // 38  [SKU: aerostride-classic-38-bruin-gaas]
  "64899241640285": "57893275435343", // 38  [SKU: aerostride-classic-38-blauw-leer]
  "64899241673053": "57893275468111", // 38  [SKU: aerostride-classic-38-bruin-leer]
  "64899241705821": "57893275500879", // 39  [SKU: aerostride-classic-39-blauw-gaas]
  "64899241738589": "57893275533647", // 39  [SKU: aerostride-classic-39-bruin-gaas]
  "64899241771357": "57893275566415", // 39  [SKU: aerostride-classic-39-blauw-leer]
  "64899241804125": "57893275599183", // 39  [SKU: aerostride-classic-39-bruin-leer]
  "64899241836893": "57893275631951", // 40  [SKU: aerostride-classic-40-blauw-gaas]
  "64899241869661": "57893275664719", // 40  [SKU: aerostride-classic-40-bruin-gaas]
  "64899241902429": "57893275697487", // 40  [SKU: aerostride-classic-40-blauw-leer]
  "64899241935197": "57893275730255", // 40  [SKU: aerostride-classic-40-bruin-leer]
  // ─── All Black (10 variants) ───
  "64899247407453": "57893275828559", // 36  [SKU: all-black-36]
  "64899247440221": "57893275861327", // 37  [SKU: all-black-37]
  "64899247472989": "57893275894095", // 38  [SKU: all-black-38]
  "64899247505757": "57893275926863", // 39  [SKU: all-black-39]
  "64899247538525": "57893275959631", // 40  [SKU: all-black-40]
  "64899247571293": "57893275992399", // 41  [SKU: all-black-41]
  "64899247604061": "57893276025167", // 42  [SKU: all-black-42]
  "64899247636829": "57893276057935", // 43  [SKU: all-black-43]
  "64899247669597": "57893276090703", // 44  [SKU: all-black-44]
  "64899247702365": "57893276123471", // 45  [SKU: all-black-45]
  // ─── An20 (10 variants) ───
  "64899247997277": "57893276221775", // 36  [SKU: an20-36]
  "64899248030045": "57893276254543", // 37  [SKU: an20-37]
  "64899248062813": "57893276287311", // 38  [SKU: an20-38]
  "64899248095581": "57893276320079", // 39  [SKU: an20-39]
  "64899248128349": "57893276352847", // 40  [SKU: an20-40]
  "64899248161117": "57893276385615", // 41  [SKU: an20-41]
  "64899248193885": "57893276418383", // 42  [SKU: an20-42]
  "64899248226653": "57893276451151", // 43  [SKU: an20-43]
  "64899248259421": "57893276483919", // 44  [SKU: an20-44]
  "64899248292189": "57893276516687", // 45  [SKU: an20-45]
  // ─── Arctic Blue (11 variants) ───
  "64899248685405": "57893276680527", // 36  [SKU: arctic-blue-36]
  "64899248718173": "57893276713295", // 37  [SKU: arctic-blue-37]
  "64899248750941": "57893276746063", // 38  [SKU: arctic-blue-38]
  "64899248783709": "57893276778831", // 39  [SKU: arctic-blue-39]
  "64899248816477": "57893276811599", // 40  [SKU: arctic-blue-40]
  "64899248849245": "57893276844367", // 41  [SKU: arctic-blue-41]
  "64899248882013": "57893276877135", // 42  [SKU: arctic-blue-42]
  "64899248914781": "57893276909903", // 43  [SKU: arctic-blue-43]
  "64899248947549": "57893276942671", // 44  [SKU: arctic-blue-44]
  "64899248980317": "57893276975439", // 45  [SKU: arctic-blue-45]
  "64899249013085": "57893277008207", // 46  [SKU: arctic-blue-46]
  // ─── Arctic Sky (11 variants) ───
  "64899249373533": "57893277172047", // 36  [SKU: arctic-sky-36]
  "64899249406301": "57893277204815", // 37  [SKU: arctic-sky-37]
  "64899249439069": "57893277237583", // 38  [SKU: arctic-sky-38]
  "64899249471837": "57893277270351", // 39  [SKU: arctic-sky-39]
  "64899249504605": "57893277303119", // 40  [SKU: arctic-sky-40]
  "64899249537373": "57893277335887", // 41  [SKU: arctic-sky-41]
  "64899249570141": "57893277368655", // 42  [SKU: arctic-sky-42]
  "64899249602909": "57893277401423", // 43  [SKU: arctic-sky-43]
  "64899249635677": "57893277434191", // 44  [SKU: arctic-sky-44]
  "64899249668445": "57893277466959", // 45  [SKU: arctic-sky-45]
  "64899249701213": "57893277499727", // 46  [SKU: arctic-sky-46]
  // ─── Armory Blue (10 variants) ───
  "64899250487645": "57893277630799", // 36  [SKU: armory-blue-36]
  "64899250520413": "57893277663567", // 37  [SKU: armory-blue-37]
  "64899250553181": "57893277696335", // 38  [SKU: armory-blue-38]
  "64899250585949": "57893277729103", // 39  [SKU: armory-blue-39]
  "64899250618717": "57893277761871", // 40  [SKU: armory-blue-40]
  "64899250651485": "57893277794639", // 41  [SKU: armory-blue-41]
  "64899250684253": "57893277827407", // 42  [SKU: armory-blue-42]
  "64899250717021": "57893277860175", // 43  [SKU: armory-blue-43]
  "64899250749789": "57893277892943", // 44  [SKU: armory-blue-44]
  "64899250782557": "57893277925711", // 45  [SKU: armory-blue-45]
  // ─── Atmosphere Grey (10 variants) ───
  "64899251929437": "57893278024015", // 36  [SKU: atmosphere-grey-36]
  "64899251962205": "57893278056783", // 37.5  [SKU: atmosphere-grey-375]
  "64899251994973": "57893278089551", // 38  [SKU: atmosphere-grey-38]
  "64899252027741": "57893278122319", // 39  [SKU: atmosphere-grey-39]
  "64899252060509": "57893278155087", // 40  [SKU: atmosphere-grey-40]
  "64899252093277": "57893278187855", // 41  [SKU: atmosphere-grey-41]
  "64899252126045": "57893278220623", // 42  [SKU: atmosphere-grey-42]
  "64899252158813": "57893278253391", // 43  [SKU: atmosphere-grey-43]
  "64899252191581": "57893278286159", // 44  [SKU: atmosphere-grey-44]
  "64899252224349": "57893278318927", // 45  [SKU: atmosphere-grey-45]
  // ─── Base (11 variants) ───
  "64899253240157": "57893278449999", // 36  [SKU: base-36]
  "64899253272925": "57893278482767", // 37.5  [SKU: base-375]
  "64899253305693": "57893278515535", // 38  [SKU: base-38]
  "64899253338461": "57893278548303", // 39  [SKU: base-39]
  "64899253371229": "57893278581071", // 40  [SKU: base-40]
  "64899253403997": "57893278613839", // 41  [SKU: base-41]
  "64899253436765": "57893278646607", // 42  [SKU: base-42]
  "64899253469533": "57893278679375", // 43  [SKU: base-43]
  "64899253502301": "57893278712143", // 44  [SKU: base-44]
  "64899253535069": "57893278744911", // 45  [SKU: base-45]
  "64899253567837": "57893278777679", // 46  [SKU: base-46]
  // ─── Beijing (11 variants) ───
  "64899258188125": "57893279793487", // 36  [SKU: beijing-36]
  "64899258220893": "57893279826255", // 37.5  [SKU: beijing-375]
  "64899258253661": "57893279859023", // 38  [SKU: beijing-38]
  "64899258286429": "57893279891791", // 39  [SKU: beijing-39]
  "64899258319197": "57893279924559", // 40  [SKU: beijing-40]
  "64899258351965": "57893279957327", // 41  [SKU: beijing-41]
  "64899258384733": "57893279990095", // 42  [SKU: beijing-42]
  "64899258417501": "57893280022863", // 43  [SKU: beijing-43]
  "64899258450269": "57893280055631", // 44  [SKU: beijing-44]
  "64899258483037": "57893280088399", // 45  [SKU: beijing-45]
  "64899258515805": "57893280121167", // 46  [SKU: beijing-46]
  // ─── Big Window (13 variants) ───
  "64899259400541": "57893280383311", // 36  [SKU: big-window-36]
  "64899259433309": "57893280416079", // 37  [SKU: big-window-37]
  "64899259466077": "57893280448847", // 38  [SKU: big-window-38]
  "64899259498845": "57893280481615", // 39  [SKU: big-window-39]
  "64899259531613": "57893280514383", // 40  [SKU: big-window-40]
  "64899259564381": "57893280547151", // 41  [SKU: big-window-41]
  "64899259597149": "57893280579919", // 42  [SKU: big-window-42]
  "64899259629917": "57893280612687", // 43  [SKU: big-window-43]
  "64899259662685": "57893280645455", // 44  [SKU: big-window-44]
  "64899259695453": "57893280678223", // 45  [SKU: big-window-45]
  "64899259728221": "57893280710991", // 46  [SKU: big-window-46]
  "64899259826525": "57893280809295", // 49  [SKU: big-window-49]
  "64899259859293": "57893280842063", // 50  [SKU: big-window-50]
  // ─── Black 'n White (11 variants) ───
  "64899260809565": "57893281005903", // 36  [SKU: black-n-white-36]
  "64899260842333": "57893281038671", // 37.5  [SKU: black-n-white-375]
  "64899260875101": "57893281071439", // 38  [SKU: black-n-white-38]
  "64899260907869": "57893281104207", // 39  [SKU: black-n-white-39]
  "64899260940637": "57893281136975", // 40  [SKU: black-n-white-40]
  "64899260973405": "57893281169743", // 41  [SKU: black-n-white-41]
  "64899261006173": "57893281202511", // 42  [SKU: black-n-white-42]
  "64899261038941": "57893281235279", // 43  [SKU: black-n-white-43]
  "64899261071709": "57893281268047", // 44  [SKU: black-n-white-44]
  "64899261104477": "57893281300815", // 45  [SKU: black-n-white-45]
  "64899261137245": "57893281333583", // 46  [SKU: black-n-white-46]
  // ─── Black Bronzine (11 variants) ───
  "64899263365469": "57893281530191", // 36  [SKU: black-bronzine-36]
  "64899263398237": "57893281562959", // 37  [SKU: black-bronzine-37]
  "64899263431005": "57893281595727", // 38  [SKU: black-bronzine-38]
  "64899263463773": "57893281628495", // 39  [SKU: black-bronzine-39]
  "64899263496541": "57893281661263", // 40  [SKU: black-bronzine-40]
  "64899263529309": "57893281694031", // 41  [SKU: black-bronzine-41]
  "64899263562077": "57893281726799", // 42  [SKU: black-bronzine-42]
  "64899263594845": "57893281759567", // 43  [SKU: black-bronzine-43]
  "64899263627613": "57893281792335", // 44  [SKU: black-bronzine-44]
  "64899263660381": "57893281825103", // 45  [SKU: black-bronzine-45]
  "64899263693149": "57893281857871", // 46  [SKU: black-bronzine-46]
  // ─── Black Carrier (11 variants) ───
  "64899264741725": "57893281988943", // 36  [SKU: black-carrier-36]
  "64899264774493": "57893282021711", // 37  [SKU: black-carrier-37]
  "64899264807261": "57893282054479", // 38  [SKU: black-carrier-38]
  "64899264840029": "57893282087247", // 39  [SKU: black-carrier-39]
  "64899264872797": "57893282120015", // 40  [SKU: black-carrier-40]
  "64899264905565": "57893282152783", // 41  [SKU: black-carrier-41]
  "64899264938333": "57893282185551", // 42  [SKU: black-carrier-42]
  "64899264971101": "57893282218319", // 43  [SKU: black-carrier-43]
  "64899265003869": "57893282251087", // 44  [SKU: black-carrier-44]
  "64899265036637": "57893282283855", // 45  [SKU: black-carrier-45]
  "64899265069405": "57893282316623", // 46  [SKU: black-carrier-46]
  // ─── Black Gold (10 variants) ───
  "64899267330397": "57893282513231", // 36  [SKU: black-gold-36]
  "64899267363165": "57893282545999", // 37  [SKU: black-gold-37]
  "64899267395933": "57893282578767", // 38  [SKU: black-gold-38]
  "64899267428701": "57893282611535", // 39  [SKU: black-gold-39]
  "64899267461469": "57893282644303", // 40  [SKU: black-gold-40]
  "64899267494237": "57893282677071", // 41  [SKU: black-gold-41]
  "64899267527005": "57893282709839", // 42  [SKU: black-gold-42]
  "64899267559773": "57893282742607", // 43  [SKU: black-gold-43]
  "64899267592541": "57893282775375", // 44  [SKU: black-gold-44]
  "64899267625309": "57893282808143", // 45  [SKU: black-gold-45]
  // ─── Black Graphite (11 variants) ───
  "64899268936029": "57893283529039", // 36  [SKU: black-graphite-36]
  "64899268968797": "57893283561807", // 37  [SKU: black-graphite-37]
  "64899269001565": "57893283594575", // 38  [SKU: black-graphite-38]
  "64899269034333": "57893283627343", // 39  [SKU: black-graphite-39]
  "64899269067101": "57893283660111", // 40  [SKU: black-graphite-40]
  "64899269099869": "57893283692879", // 41  [SKU: black-graphite-41]
  "64899269132637": "57893283725647", // 42  [SKU: black-graphite-42]
  "64899269165405": "57893283758415", // 43  [SKU: black-graphite-43]
  "64899269198173": "57893283791183", // 44  [SKU: black-graphite-44]
  "64899269230941": "57893283823951", // 45  [SKU: black-graphite-45]
  "64899269263709": "57893283856719", // 46  [SKU: black-graphite-46]
  // ─── Black Gum (11 variants) ───
  "64899271754077": "57893284151631", // 36  [SKU: black-gum-36]
  "64899271786845": "57893284184399", // 37  [SKU: black-gum-37]
  "64899271819613": "57893284217167", // 38  [SKU: black-gum-38]
  "64899271852381": "57893284249935", // 39  [SKU: black-gum-39]
  "64899271885149": "57893284282703", // 40  [SKU: black-gum-40]
  "64899271917917": "57893284315471", // 41  [SKU: black-gum-41]
  "64899271950685": "57893284348239", // 42  [SKU: black-gum-42]
  "64899271983453": "57893284381007", // 43  [SKU: black-gum-43]
  "64899272016221": "57893284413775", // 44  [SKU: black-gum-44]
  "64899272048989": "57893284446543", // 45  [SKU: black-gum-45]
  "64899272081757": "57893284479311", // 46  [SKU: black-gum-46]
  // ─── Black Metallic (11 variants) ───
  "64899273294173": "57893284970831", // 36  [SKU: black-metallic-36]
  "64899273326941": "57893285003599", // 37.5  [SKU: black-metallic-375]
  "64899273359709": "57893285036367", // 38  [SKU: black-metallic-38]
  "64899273392477": "57893285069135", // 39  [SKU: black-metallic-39]
  "64899273425245": "57893285101903", // 40  [SKU: black-metallic-40]
  "64899273458013": "57893285134671", // 41  [SKU: black-metallic-41]
  "64899273490781": "57893285167439", // 42  [SKU: black-metallic-42]
  "64899273523549": "57893285200207", // 43  [SKU: black-metallic-43]
  "64899273556317": "57893285232975", // 44  [SKU: black-metallic-44]
  "64899273589085": "57893285265743", // 45  [SKU: black-metallic-45]
  "64899273621853": "57893285298511", // 46  [SKU: black-metallic-46]
  // ─── Black Obsidian (10 variants) ───
  "64899274342749": "57893285364047", // 36  [SKU: black-obsidian-36]
  "64899274375517": "57893285396815", // 37.5  [SKU: black-obsidian-375]
  "64899274408285": "57893285429583", // 38  [SKU: black-obsidian-38]
  "64899274441053": "57893285462351", // 39  [SKU: black-obsidian-39]
  "64899274473821": "57893285495119", // 40  [SKU: black-obsidian-40]
  "64899274506589": "57893285527887", // 41  [SKU: black-obsidian-41]
  "64899274539357": "57893285560655", // 42  [SKU: black-obsidian-42]
  "64899274572125": "57893285593423", // 43  [SKU: black-obsidian-43]
  "64899274604893": "57893285626191", // 44  [SKU: black-obsidian-44]
  "64899274637661": "57893285658959", // 45  [SKU: black-obsidian-45]
  // ─── Black Pepper (11 variants) ───
  "64899275882845": "57893285724495", // 36  [SKU: black-pepper-36]
  "64899275915613": "57893285757263", // 37  [SKU: black-pepper-37]
  "64899275948381": "57893285790031", // 38  [SKU: black-pepper-38]
  "64899275981149": "57893285822799", // 39  [SKU: black-pepper-39]
  "64899276013917": "57893285855567", // 40  [SKU: black-pepper-40]
  "64899276046685": "57893285888335", // 41  [SKU: black-pepper-41]
  "64899276079453": "57893285921103", // 42  [SKU: black-pepper-42]
  "64899276112221": "57893285953871", // 43  [SKU: black-pepper-43]
  "64899276144989": "57893285986639", // 44  [SKU: black-pepper-44]
  "64899276177757": "57893286019407", // 45  [SKU: black-pepper-45]
  "64899276210525": "57893286052175", // 46  [SKU: black-pepper-46]
  // ─── Black Royal (11 variants) ───
  "64899278897501": "57893286183247", // 36  [SKU: black-royal-36]
  "64899278930269": "57893286216015", // 37.5  [SKU: black-royal-375]
  "64899278963037": "57893286248783", // 38  [SKU: black-royal-38]
  "64899278995805": "57893286281551", // 39  [SKU: black-royal-39]
  "64899279028573": "57893286314319", // 40  [SKU: black-royal-40]
  "64899279061341": "57893286347087", // 41  [SKU: black-royal-41]
  "64899279094109": "57893286379855", // 42  [SKU: black-royal-42]
  "64899279126877": "57893286412623", // 43  [SKU: black-royal-43]
  "64899279159645": "57893286445391", // 44  [SKU: black-royal-44]
  "64899279192413": "57893286478159", // 45  [SKU: black-royal-45]
  "64899279225181": "57893286510927", // 46  [SKU: black-royal-46]
  // ─── Black Violet (11 variants) ───
  "64899280732509": "57893287035215", // 36  [SKU: black-violet-36]
  "64899280765277": "57893287067983", // 37.5  [SKU: black-violet-375]
  "64899280798045": "57893287100751", // 38  [SKU: black-violet-38]
  "64899280830813": "57893287133519", // 39  [SKU: black-violet-39]
  "64899280863581": "57893287166287", // 40  [SKU: black-violet-40]
  "64899280896349": "57893287199055", // 41  [SKU: black-violet-41]
  "64899280929117": "57893287231823", // 42  [SKU: black-violet-42]
  "64899280961885": "57893287264591", // 43  [SKU: black-violet-43]
  "64899280994653": "57893287297359", // 44  [SKU: black-violet-44]
  "64899281027421": "57893287330127", // 45  [SKU: black-violet-45]
  "64899281060189": "57893287362895", // 46  [SKU: black-violet-46]
  // ─── Bloem (24 variants) ───
  "64899281715549": "57893225070927", // Blauw  [SKU: bloem-blauw-36]
  "64899281748317": "57893225103695", // Blauw  [SKU: bloem-blauw-37]
  "64899281781085": "57893225136463", // Blauw  [SKU: bloem-blauw-38]
  "64899281813853": "57893225169231", // Blauw  [SKU: bloem-blauw-39]
  "64899281846621": "57893225201999", // Blauw  [SKU: bloem-blauw-40]
  "64899281879389": "57893225234767", // Blauw  [SKU: bloem-blauw-41]
  "64899281912157": "57893225267535", // Blauw  [SKU: bloem-blauw-42]
  "64899281944925": "57893225300303", // Blauw  [SKU: bloem-blauw-43]
  "64899281977693": "57893225333071", // roze  [SKU: bloem-roze-36]
  "64899282010461": "57893225365839", // roze  [SKU: bloem-roze-37]
  "64899282043229": "57893225398607", // roze  [SKU: bloem-roze-38]
  "64899282075997": "57893225431375", // roze  [SKU: bloem-roze-39]
  "64899282108765": "57893225464143", // roze  [SKU: bloem-roze-40]
  "64899282141533": "57893225496911", // roze  [SKU: bloem-roze-41]
  "64899282174301": "57893225529679", // roze  [SKU: bloem-roze-42]
  "64899282207069": "57893225562447", // roze  [SKU: bloem-roze-43]
  "64899282239837": "57893225595215", // geel  [SKU: bloem-geel-36]
  "64899282272605": "57893225627983", // geel  [SKU: bloem-geel-37]
  "64899282305373": "57893225660751", // geel  [SKU: bloem-geel-38]
  "64899282338141": "57893225693519", // geel  [SKU: bloem-geel-39]
  "64899282370909": "57893225726287", // geel  [SKU: bloem-geel-40]
  "64899282403677": "57893225759055", // geel  [SKU: bloem-geel-41]
  "64899282436445": "57893225791823", // geel  [SKU: bloem-geel-42]
  "64899282469213": "57893225824591", // geel  [SKU: bloem-geel-43]
  // ─── Blue Running (5 variants) ───
  "64899285352797": "57893288477007", // 36  [SKU: blue-running-36]
  "64899285385565": "57893288509775", // 37  [SKU: blue-running-37]
  "64899285418333": "57893288542543", // 38  [SKU: blue-running-38]
  "64899285451101": "57893288575311", // 39  [SKU: blue-running-39]
  "64899285483869": "57893288608079", // 40  [SKU: blue-running-40]
  // ─── Bmeirui Running (54 variants) ───
  "64899286106461": "57893288804687", // 36  [SKU: bmeirui-running-36-zwart-wit]
  "64899286139229": "57893288837455", // 36  [SKU: bmeirui-running-36-zwart]
  "64899286171997": "57893288870223", // 36  [SKU: bmeirui-running-36-grijs]
  "64899286204765": "57893288902991", // 36  [SKU: bmeirui-running-36-lichtblauw]
  "64899286237533": "57893288935759", // 36  [SKU: bmeirui-running-36-grijs-roze]
  "64899286270301": "57893288968527", // 36  [SKU: bmeirui-running-36-roze]
  "64899286303069": "57893289001295", // 37  [SKU: bmeirui-running-37-zwart-wit]
  "64899286335837": "57893289132367", // 37  [SKU: bmeirui-running-37-zwart]
  "64899286368605": "57893289165135", // 37  [SKU: bmeirui-running-37-grijs]
  "64899286401373": "57893289197903", // 37  [SKU: bmeirui-running-37-lichtblauw]
  "64899286434141": "57893289230671", // 37  [SKU: bmeirui-running-37-grijs-roze]
  "64899286466909": "57893289263439", // 37  [SKU: bmeirui-running-37-roze]
  "64899286499677": "57893289296207", // 38  [SKU: bmeirui-running-38-zwart-wit]
  "64899286532445": "57893289328975", // 38  [SKU: bmeirui-running-38-zwart]
  "64899286565213": "57893289361743", // 38  [SKU: bmeirui-running-38-grijs]
  "64899286597981": "57893289394511", // 38  [SKU: bmeirui-running-38-lichtblauw]
  "64899286630749": "57893289427279", // 38  [SKU: bmeirui-running-38-grijs-roze]
  "64899286663517": "57893289460047", // 38  [SKU: bmeirui-running-38-roze]
  "64899286696285": "57893289492815", // 39  [SKU: bmeirui-running-39-zwart-wit]
  "64899286729053": "57893289525583", // 39  [SKU: bmeirui-running-39-zwart]
  "64899286761821": "57893289558351", // 39  [SKU: bmeirui-running-39-grijs]
  "64899286794589": "57893289591119", // 39  [SKU: bmeirui-running-39-lichtblauw]
  "64899286827357": "57893289623887", // 39  [SKU: bmeirui-running-39-grijs-roze]
  "64899286860125": "57893289656655", // 39  [SKU: bmeirui-running-39-roze]
  "64899286892893": "57893289689423", // 40  [SKU: bmeirui-running-40-zwart-wit]
  "64899286925661": "57893289722191", // 40  [SKU: bmeirui-running-40-zwart]
  "64899286958429": "57893289754959", // 40  [SKU: bmeirui-running-40-grijs]
  "64899286991197": "57893289787727", // 40  [SKU: bmeirui-running-40-lichtblauw]
  "64899287023965": "57893289820495", // 40  [SKU: bmeirui-running-40-grijs-roze]
  "64899287056733": "57893289853263", // 40  [SKU: bmeirui-running-40-roze]
  "64899287089501": "57893289886031", // 41  [SKU: bmeirui-running-41-zwart-wit]
  "64899287122269": "57893289918799", // 41  [SKU: bmeirui-running-41-zwart]
  "64899287155037": "57893289951567", // 41  [SKU: bmeirui-running-41-grijs]
  "64899287187805": "57893289984335", // 41  [SKU: bmeirui-running-41-lichtblauw]
  "64899287220573": "57893290017103", // 41  [SKU: bmeirui-running-41-grijs-roze]
  "64899287253341": "57893290049871", // 41  [SKU: bmeirui-running-41-roze]
  "64899287286109": "57893290082639", // 42  [SKU: bmeirui-running-42-zwart-wit]
  "64899287318877": "57893290115407", // 42  [SKU: bmeirui-running-42-zwart]
  "64899287351645": "57893290148175", // 42  [SKU: bmeirui-running-42-grijs]
  "64899287384413": "57893290180943", // 42  [SKU: bmeirui-running-42-lichtblauw]
  "64899287417181": "57893290213711", // 42  [SKU: bmeirui-running-42-grijs-roze]
  "64899287449949": "57893290246479", // 42  [SKU: bmeirui-running-42-roze]
  "64899287482717": "57893290279247", // 43  [SKU: bmeirui-running-43-zwart-wit]
  "64899287515485": "57893290312015", // 43  [SKU: bmeirui-running-43-zwart]
  "64899287548253": "57893290344783", // 43  [SKU: bmeirui-running-43-grijs]
  "64899287581021": "57893290377551", // 43  [SKU: bmeirui-running-43-lichtblauw]
  "64899287613789": "57893290410319", // 43  [SKU: bmeirui-running-43-grijs-roze]
  "64899287646557": "57893290443087", // 43  [SKU: bmeirui-running-43-roze]
  "64899287679325": "57893290475855", // 44  [SKU: bmeirui-running-44-zwart-wit]
  "64899287712093": "57893290508623", // 44  [SKU: bmeirui-running-44-zwart]
  "64899287744861": "57893290541391", // 44  [SKU: bmeirui-running-44-grijs]
  "64899287777629": "57893290574159", // 44  [SKU: bmeirui-running-44-lichtblauw]
  "64899287810397": "57893290606927", // 44  [SKU: bmeirui-running-44-grijs-roze]
  "64899287843165": "57893290639695", // 44  [SKU: bmeirui-running-44-roze]
  // ─── Bomberjack (12 variants) ───
  "64899657072989": "57893291393359", // Zwart  [SKU: windjack-bomberjack-zwart-m]
  "64899657105757": "57893291426127", // Zwart  [SKU: windjack-bomberjack-zwart-l]
  "64899657138525": "57893291458895", // Zwart  [SKU: windjack-bomberjack-zwart-xl]
  "64899657302365": "57893290705231", // Blauw  [SKU: windjack-bomberjack-blauw-m]
  "64899657335133": "57893290737999", // Blauw  [SKU: windjack-bomberjack-blauw-l]
  "64899657367901": "57893290770767", // Blauw  [SKU: windjack-bomberjack-blauw-xl]
  "64899657531741": "57893291163983", // Groen  [SKU: windjack-bomberjack-groen-m]
  "64899657564509": "57893291196751", // Groen  [SKU: windjack-bomberjack-groen-l]
  "64899657597277": "57893291229519", // Groen  [SKU: windjack-bomberjack-groen-xl]
  "64899657761117": "57893290934607", // Wit  [SKU: windjack-bomberjack-wit-m]
  "64899657793885": "57893290967375", // Wit  [SKU: windjack-bomberjack-wit-l]
  "64899657826653": "57893291000143", // Wit  [SKU: windjack-bomberjack-wit-xl]
  // ─── Bone (11 variants) ───
  "64899287974237": "57893291852111", // 36  [SKU: bone-36]
  "64899288007005": "57893291884879", // 37  [SKU: bone-37]
  "64899288039773": "57893291917647", // 38  [SKU: bone-38]
  "64899288072541": "57893291950415", // 39  [SKU: bone-39]
  "64899288105309": "57893291983183", // 40  [SKU: bone-40]
  "64899288138077": "57893292015951", // 41  [SKU: bone-41]
  "64899288170845": "57893292048719", // 42  [SKU: bone-42]
  "64899288203613": "57893292081487", // 43  [SKU: bone-43]
  "64899288236381": "57893292114255", // 44  [SKU: bone-44]
  "64899288269149": "57893292147023", // 45  [SKU: bone-45]
  "64899288301917": "57893292179791", // 46  [SKU: bone-46]
  // ─── Bone Sparrow (11 variants) ───
  "64899288465757": "57893292441935", // 36  [SKU: bone-sparrow-36]
  "64899288498525": "57893292474703", // 37  [SKU: bone-sparrow-37]
  "64899288531293": "57893292507471", // 38  [SKU: bone-sparrow-38]
  "64899288564061": "57893292540239", // 39.5  [SKU: bone-sparrow-395]
  "64899288596829": "57893292573007", // 40  [SKU: bone-sparrow-40]
  "64899288629597": "57893292605775", // 41.5  [SKU: bone-sparrow-415]
  "64899288662365": "57893292638543", // 42  [SKU: bone-sparrow-42]
  "64899288695133": "57893292671311", // 43  [SKU: bone-sparrow-43]
  "64899288727901": "57893292704079", // 44  [SKU: bone-sparrow-44]
  "64899288760669": "57893292736847", // 45  [SKU: bone-sparrow-45]
  "64899288793437": "57893292769615", // 46.5  [SKU: bone-sparrow-465]
  // ─── Breathable Mesh (24 variants) ───
  "64899291480413": "57893292867919", // 38  [SKU: breathable-mesh-38-sterrenhemel-zwart]
  "64899291513181": "57893292835151", // 38  [SKU: breathable-mesh-38-wit-zwart]
  "64899291545949": "57893292900687", // 38  [SKU: breathable-mesh-38-grijs]
  "64899291578717": "57893292933455", // 39  [SKU: breathable-mesh-39-sterrenhemel-zwart]
  "64899291611485": "57893292966223", // 39  [SKU: breathable-mesh-39-wit-zwart]
  "64899291644253": "57893292998991", // 39  [SKU: breathable-mesh-39-grijs]
  "64899291677021": "57893293031759", // 40  [SKU: breathable-mesh-40-sterrenhemel-zwart]
  "64899291709789": "57893293064527", // 40  [SKU: breathable-mesh-40-wit-zwart]
  "64899291742557": "57893293097295", // 40  [SKU: breathable-mesh-40-grijs]
  "64899291775325": "57893293130063", // 41  [SKU: breathable-mesh-41-sterrenhemel-zwart]
  "64899291808093": "57893293162831", // 41  [SKU: breathable-mesh-41-wit-zwart]
  "64899291840861": "57893293195599", // 41  [SKU: breathable-mesh-41-grijs]
  "64899291873629": "57893293228367", // 42  [SKU: breathable-mesh-42-sterrenhemel-zwart]
  "64899291906397": "57893293261135", // 42  [SKU: breathable-mesh-42-wit-zwart]
  "64899291939165": "57893293293903", // 42  [SKU: breathable-mesh-42-grijs]
  "64899291971933": "57893293326671", // 43  [SKU: breathable-mesh-43-sterrenhemel-zwart]
  "64899292004701": "57893293359439", // 43  [SKU: breathable-mesh-43-wit-zwart]
  "64899292037469": "57893293392207", // 43  [SKU: breathable-mesh-43-grijs]
  "64899292070237": "57893293424975", // 44  [SKU: breathable-mesh-44-sterrenhemel-zwart]
  "64899292103005": "57893293457743", // 44  [SKU: breathable-mesh-44-wit-zwart]
  "64899292135773": "57893293490511", // 44  [SKU: breathable-mesh-44-grijs]
  "64899292168541": "57893293523279", // 45  [SKU: breathable-mesh-45-sterrenhemel-zwart]
  "64899292201309": "57893293556047", // 45  [SKU: breathable-mesh-45-wit-zwart]
  "64899292234077": "57893293588815", // 45  [SKU: breathable-mesh-45-grijs]
  // ─── Brown Running (5 variants) ───
  "64899297345885": "57893295522127", // 36  [SKU: brown-running-36]
  "64899297378653": "57893295554895", // 37  [SKU: brown-running-37]
  "64899297411421": "57893295587663", // 38  [SKU: brown-running-38]
  "64899297444189": "57893295620431", // 39  [SKU: brown-running-39]
  "64899297476957": "57893295653199", // 40  [SKU: brown-running-40]
  // ─── Burgundy Crush (11 variants) ───
  "64899299115357": "57893296341327", // 36  [SKU: burgundy-crush-36]
  "64899299148125": "57893296374095", // 37  [SKU: burgundy-crush-37]
  "64899299180893": "57893296406863", // 38  [SKU: burgundy-crush-38]
  "64899299213661": "57893296439631", // 39  [SKU: burgundy-crush-39]
  "64899299246429": "57893296472399", // 40  [SKU: burgundy-crush-40]
  "64899299279197": "57893296505167", // 41  [SKU: burgundy-crush-41]
  "64899299311965": "57893296537935", // 42  [SKU: burgundy-crush-42]
  "64899299344733": "57893296570703", // 43  [SKU: burgundy-crush-43]
  "64899299377501": "57893296603471", // 44  [SKU: burgundy-crush-44]
  "64899299410269": "57893296636239", // 45  [SKU: burgundy-crush-45]
  "64899299443037": "57893296669007", // 46  [SKU: burgundy-crush-46]
  // ─── Camowabb (11 variants) ───
  "64899302162781": "57893297357135", // 36  [SKU: camowabb-36]
  "64899302195549": "57893297389903", // 37.5  [SKU: camowabb-375]
  "64899302228317": "57893297422671", // 38  [SKU: camowabb-38]
  "64899302261085": "57893297455439", // 39  [SKU: camowabb-39]
  "64899302293853": "57893297488207", // 40  [SKU: camowabb-40]
  "64899302326621": "57893297520975", // 41  [SKU: camowabb-41]
  "64899302359389": "57893297553743", // 42  [SKU: camowabb-42]
  "64899302392157": "57893297586511", // 43  [SKU: camowabb-43]
  "64899302424925": "57893297619279", // 44  [SKU: camowabb-44]
  "64899302457693": "57893297652047", // 45  [SKU: camowabb-45]
  "64899302490461": "57893297684815", // 46  [SKU: camowabb-46]
  // ─── Caspar (33 variants) ───
  "64899302785373": "57893225922895", // Zwart  [SKU: caspar-zwart-38.5]
  "64899302818141": "57893225955663", // Zwart  [SKU: caspar-zwart-39]
  "64899302850909": "57893225988431", // Zwart  [SKU: caspar-zwart-40]
  "64899302883677": "57893226021199", // Zwart  [SKU: caspar-zwart-41]
  "64899302916445": "57893226053967", // Zwart  [SKU: caspar-zwart-41.5]
  "64899302949213": "57893226086735", // Zwart  [SKU: caspar-zwart-42]
  "64899302981981": "57893226119503", // Zwart  [SKU: caspar-zwart-42.5]
  "64899303014749": "57893226152271", // Zwart  [SKU: caspar-zwart-43]
  "64899303047517": "57893226185039", // Zwart  [SKU: caspar-zwart-44]
  "64899303080285": "57893226217807", // Zwart  [SKU: caspar-zwart-45]
  "64899303113053": "57893226250575", // Zwart  [SKU: caspar-zwart-46]
  "64899303178589": "57893226316111", // Wit  [SKU: caspar-wit-38.5]
  "64899303211357": "57893226348879", // Wit  [SKU: caspar-wit-39]
  "64899303244125": "57893226381647", // Wit  [SKU: caspar-wit-40]
  "64899303276893": "57893226414415", // Wit  [SKU: caspar-wit-41]
  "64899303309661": "57893226447183", // Wit  [SKU: caspar-wit-41.5]
  "64899303342429": "57893226479951", // Wit  [SKU: caspar-wit-42]
  "64899303375197": "57893226512719", // Wit  [SKU: caspar-wit-42.5]
  "64899303407965": "57893226545487", // Wit  [SKU: caspar-wit-43]
  "64899303440733": "57893226578255", // Wit  [SKU: caspar-wit-44]
  "64899303473501": "57893226611023", // Wit  [SKU: caspar-wit-45]
  "64899303506269": "57893226643791", // Wit  [SKU: caspar-wit-46]
  "64899303571805": "57893226709327", // Bruin  [SKU: caspar-bruin-38.5]
  "64899303604573": "57893226742095", // Bruin  [SKU: caspar-bruin-39]
  "64899303637341": "57893226774863", // Bruin  [SKU: caspar-bruin-40]
  "64899303670109": "57893226807631", // Bruin  [SKU: caspar-bruin-41]
  "64899303702877": "57893226840399", // Bruin  [SKU: caspar-bruin-41.5]
  "64899303735645": "57893226873167", // Bruin  [SKU: caspar-bruin-42]
  "64899303768413": "57893226905935", // Bruin  [SKU: caspar-bruin-42.5]
  "64899303801181": "57893226938703", // Bruin  [SKU: caspar-bruin-43]
  "64899303833949": "57893226971471", // Bruin  [SKU: caspar-bruin-44]
  "64899303866717": "57893227004239", // Bruin  [SKU: caspar-bruin-45]
  "64899303899485": "57893227037007", // Bruin  [SKU: caspar-bruin-46]
  // ─── Castlerock (11 variants) ───
  "64899304063325": "57893297914191", // 36  [SKU: castlerock-36]
  "64899304096093": "57893297946959", // 37  [SKU: castlerock-37]
  "64899304128861": "57893297979727", // 38  [SKU: castlerock-38]
  "64899304161629": "57893298012495", // 39.5  [SKU: castlerock-395]
  "64899304194397": "57893298045263", // 40  [SKU: castlerock-40]
  "64899304227165": "57893298078031", // 41.5  [SKU: castlerock-415]
  "64899304259933": "57893298110799", // 42  [SKU: castlerock-42]
  "64899304292701": "57893298143567", // 43  [SKU: castlerock-43]
  "64899304325469": "57893298176335", // 44  [SKU: castlerock-44]
  "64899304358237": "57893298209103", // 45  [SKU: castlerock-45]
  "64899304391005": "57893298241871", // 46.5  [SKU: castlerock-465]
  // ─── Celery (10 variants) ───
  "64899305046365": "57893298995535", // 36  [SKU: celery-36]
  "64899305079133": "57893299028303", // 37.5  [SKU: celery-375]
  "64899305111901": "57893299061071", // 38  [SKU: celery-38]
  "64899305144669": "57893299093839", // 39  [SKU: celery-39]
  "64899305177437": "57893299126607", // 40  [SKU: celery-40]
  "64899305210205": "57893299159375", // 41  [SKU: celery-41]
  "64899305242973": "57893299192143", // 42  [SKU: celery-42]
  "64899305275741": "57893299224911", // 43  [SKU: celery-43]
  "64899305308509": "57893299257679", // 44  [SKU: celery-44]
  "64899305341277": "57893299290447", // 45  [SKU: celery-45]
  // ─── Celie (24 variants) ───
  "64899306062173": "57893227626831", // Blauw  [SKU: celie-blauw-36]
  "64899306094941": "57893227659599", // Blauw  [SKU: celie-blauw-37]
  "64899306127709": "57893227692367", // Blauw  [SKU: celie-blauw-38]
  "64899306160477": "57893227725135", // Blauw  [SKU: celie-blauw-39]
  "64899306193245": "57893227757903", // Blauw  [SKU: celie-blauw-40]
  "64899306226013": "57893227790671", // Blauw  [SKU: celie-blauw-41]
  "64899306258781": "57893227823439", // Blauw  [SKU: celie-blauw-42]
  "64899306291549": "57893227856207", // Blauw  [SKU: celie-blauw-43]
  "64899306324317": "57893227888975", // Zwart  [SKU: celie-zwart-36]
  "64899306357085": "57893227921743", // Zwart  [SKU: celie-zwart-37]
  "64899306389853": "57893227954511", // Zwart  [SKU: celie-zwart-38]
  "64899306422621": "57893227987279", // Zwart  [SKU: celie-zwart-39]
  "64899306455389": "57893228020047", // Zwart  [SKU: celie-zwart-40]
  "64899306488157": "57893228052815", // Zwart  [SKU: celie-zwart-41]
  "64899306520925": "57893228085583", // Zwart  [SKU: celie-zwart-42]
  "64899306553693": "57893228118351", // Zwart  [SKU: celie-zwart-43]
  "64899306586461": "57893228151119", // Grijs  [SKU: celie-grijs-36]
  "64899306619229": "57893228183887", // Grijs  [SKU: celie-grijs-37]
  "64899306651997": "57893228216655", // Grijs  [SKU: celie-grijs-38]
  "64899306684765": "57893228249423", // Grijs  [SKU: celie-grijs-39]
  "64899306717533": "57893228282191", // Grijs  [SKU: celie-grijs-40]
  "64899306750301": "57893228314959", // Grijs  [SKU: celie-grijs-41]
  "64899306783069": "57893228347727", // Grijs  [SKU: celie-grijs-42]
  "64899306815837": "57893228380495", // Grijs  [SKU: celie-grijs-43]
  // ─── Charcoal White (13 variants) ───
  "64899310649693": "57893300470095", // 36  [SKU: charcoal-white-36]
  "64899310682461": "57893300502863", // 37  [SKU: charcoal-white-37]
  "64899310715229": "57893300535631", // 38  [SKU: charcoal-white-38]
  "64899310747997": "57893300568399", // 39  [SKU: charcoal-white-39]
  "64899310780765": "57893300601167", // 40  [SKU: charcoal-white-40]
  "64899310813533": "57893300633935", // 41  [SKU: charcoal-white-41]
  "64899310846301": "57893300666703", // 42  [SKU: charcoal-white-42]
  "64899310879069": "57893300699471", // 43  [SKU: charcoal-white-43]
  "64899310911837": "57893300732239", // 44  [SKU: charcoal-white-44]
  "64899310944605": "57893300765007", // 45  [SKU: charcoal-white-45]
  "64899310977373": "57893300797775", // 46  [SKU: charcoal-white-46]
  "64899311075677": "57893300896079", // 49  [SKU: charcoal-white-49]
  "64899311108445": "57893300928847", // 50  [SKU: charcoal-white-50]
  // ─── Chelsea Leren Laarzen (11 variants) ───
  "64899311599965": "57893301027151", // 35  [SKU: chelsea-leren-laarzen-35]
  "64899311632733": "57893301059919", // 36  [SKU: chelsea-leren-laarzen-36]
  "64899311665501": "57893301092687", // 37  [SKU: chelsea-leren-laarzen-37]
  "64899311698269": "57893301125455", // 38  [SKU: chelsea-leren-laarzen-38]
  "64899311731037": "57893301158223", // 39  [SKU: chelsea-leren-laarzen-39]
  "64899311763805": "57893301190991", // 40  [SKU: chelsea-leren-laarzen-40]
  "64899311796573": "57893301223759", // 41  [SKU: chelsea-leren-laarzen-41]
  "64899311829341": "57893301256527", // 42  [SKU: chelsea-leren-laarzen-42]
  "64899311862109": "57893301289295", // 43  [SKU: chelsea-leren-laarzen-43]
  "64899311894877": "57893301322063", // 44  [SKU: chelsea-leren-laarzen-44]
  "64899311927645": "57893301354831", // 45  [SKU: chelsea-leren-laarzen-45]
  // ─── Clara (27 variants) ───
  "64899312091485": "57893229658447", // Bruin  [SKU: clara-bruin-35]
  "64899312124253": "57893229691215", // Bruin  [SKU: clara-bruin-36]
  "64899312157021": "57893229723983", // Bruin  [SKU: clara-bruin-37]
  "64899312189789": "57893229756751", // Bruin  [SKU: clara-bruin-38]
  "64899312222557": "57893229789519", // Bruin  [SKU: clara-bruin-39]
  "64899312255325": "57893229822287", // Bruin  [SKU: clara-bruin-40]
  "64899312288093": "57893229855055", // Bruin  [SKU: clara-bruin-41]
  "64899312320861": "57893229887823", // Bruin  [SKU: clara-bruin-42]
  "64899312353629": "57893229920591", // Bruin  [SKU: clara-bruin-43]
  "64899312386397": "57893229953359", // Zwart  [SKU: clara-zwart-35]
  "64899312419165": "57893229986127", // Zwart  [SKU: clara-zwart-36]
  "64899312451933": "57893230018895", // Zwart  [SKU: clara-zwart-37]
  "64899312484701": "57893230051663", // Zwart  [SKU: clara-zwart-38]
  "64899312517469": "57893230084431", // Zwart  [SKU: clara-zwart-39]
  "64899312550237": "57893230117199", // Zwart  [SKU: clara-zwart-40]
  "64899312583005": "57893230149967", // Zwart  [SKU: clara-zwart-41]
  "64899312615773": "57893230182735", // Zwart  [SKU: clara-zwart-42]
  "64899312648541": "57893230215503", // Zwart  [SKU: clara-zwart-43]
  "64899312681309": "57893230248271", // Wit  [SKU: clara-wit-35]
  "64899312714077": "57893230281039", // Wit  [SKU: clara-wit-36]
  "64899312746845": "57893230313807", // Wit  [SKU: clara-wit-37]
  "64899312779613": "57893230346575", // Wit  [SKU: clara-wit-38]
  "64899312812381": "57893230379343", // Wit  [SKU: clara-wit-39]
  "64899312845149": "57893230412111", // Wit  [SKU: clara-wit-40]
  "64899312877917": "57893230444879", // Wit  [SKU: clara-wit-41]
  "64899312910685": "57893230477647", // Wit  [SKU: clara-wit-42]
  "64899312943453": "57893230510415", // Wit  [SKU: clara-wit-43]
  // ─── Classic (11 variants) ───
  "64899313172829": "57893301584207", // 36  [SKU: classic-36]
  "64899313205597": "57893301616975", // 37.5  [SKU: classic-375]
  "64899313238365": "57893301649743", // 38  [SKU: classic-38]
  "64899313271133": "57893301682511", // 39  [SKU: classic-39]
  "64899313303901": "57893301715279", // 40  [SKU: classic-40]
  "64899313336669": "57893301748047", // 41  [SKU: classic-41]
  "64899313369437": "57893301780815", // 42  [SKU: classic-42]
  "64899313402205": "57893301813583", // 43  [SKU: classic-43]
  "64899313434973": "57893301846351", // 44  [SKU: classic-44]
  "64899313467741": "57893301879119", // 45  [SKU: classic-45]
  "64899313500509": "57893301911887", // 46  [SKU: classic-46]
  // ─── Classic Red (11 variants) ───
  "64899314680157": "57893303615823", // 36  [SKU: classic-red-36]
  "64899314712925": "57893303648591", // 37  [SKU: classic-red-37]
  "64899314745693": "57893303681359", // 38  [SKU: classic-red-38]
  "64899314778461": "57893303714127", // 39  [SKU: classic-red-39]
  "64899314811229": "57893303746895", // 40  [SKU: classic-red-40]
  "64899314843997": "57893303779663", // 41  [SKU: classic-red-41]
  "64899314876765": "57893303812431", // 42  [SKU: classic-red-42]
  "64899314909533": "57893303845199", // 43  [SKU: classic-red-43]
  "64899314942301": "57893303877967", // 44  [SKU: classic-red-44]
  "64899314975069": "57893303910735", // 45  [SKU: classic-red-45]
  "64899315007837": "57893303943503", // 46  [SKU: classic-red-46]
  // ─── Classic White (11 variants) ───
  "64899315171677": "57893304074575", // 35  [SKU: classic-white-35]
  "64899315204445": "57893304107343", // 36  [SKU: classic-white-36]
  "64899315237213": "57893304140111", // 37  [SKU: classic-white-37]
  "64899315269981": "57893304172879", // 38  [SKU: classic-white-38]
  "64899315302749": "57893304205647", // 39  [SKU: classic-white-39]
  "64899315335517": "57893304238415", // 40  [SKU: classic-white-40]
  "64899315368285": "57893304271183", // 41  [SKU: classic-white-41]
  "64899315401053": "57893304303951", // 42  [SKU: classic-white-42]
  "64899315433821": "57893304336719", // 43  [SKU: classic-white-43]
  "64899315466589": "57893304369487", // 44  [SKU: classic-white-44]
  "64899315499357": "57893304402255", // 45  [SKU: classic-white-45]
  // ─── Classico (9 variants) ───
  "64899315564893": "57893230739791", // 35  [SKU: classico-35]
  "64899315597661": "57893230772559", // 36  [SKU: classico-36]
  "64899315630429": "57893230805327", // 37  [SKU: classico-37]
  "64899315663197": "57893230838095", // 38  [SKU: classico-38]
  "64899315695965": "57893230870863", // 39  [SKU: classico-39]
  "64899315728733": "57893230903631", // 40  [SKU: classico-40]
  "64899315761501": "57893230936399", // 41  [SKU: classico-41]
  "64899315794269": "57893230969167", // 42  [SKU: classico-42]
  "64899315827037": "57893231001935", // 43  [SKU: classico-43]
  // ─── College Pack (10 variants) ───
  "64899323035997": "57893304467791", // 36  [SKU: college-pack-36]
  "64899323068765": "57893304500559", // 37  [SKU: college-pack-37]
  "64899323101533": "57893304533327", // 38  [SKU: college-pack-38]
  "64899323134301": "57893304566095", // 39  [SKU: college-pack-39]
  "64899323167069": "57893304598863", // 40  [SKU: college-pack-40]
  "64899323199837": "57893304631631", // 41  [SKU: college-pack-41]
  "64899323232605": "57893304664399", // 42  [SKU: college-pack-42]
  "64899323265373": "57893304697167", // 43  [SKU: college-pack-43]
  "64899323298141": "57893304729935", // 44  [SKU: college-pack-44]
  "64899323330909": "57893304762703", // 45  [SKU: college-pack-45]
  // ─── Contrast Black (10 variants) ───
  "64899323494749": "57893305516367", // 36  [SKU: contrast-black-36]
  "64899323527517": "57893305549135", // 37  [SKU: contrast-black-37]
  "64899323560285": "57893305581903", // 38  [SKU: contrast-black-38]
  "64899323593053": "57893305614671", // 39  [SKU: contrast-black-39]
  "64899323625821": "57893305647439", // 40  [SKU: contrast-black-40]
  "64899323658589": "57893305680207", // 41  [SKU: contrast-black-41]
  "64899323691357": "57893305712975", // 42  [SKU: contrast-black-42]
  "64899323724125": "57893305745743", // 43  [SKU: contrast-black-43]
  "64899323756893": "57893305778511", // 44  [SKU: contrast-black-44]
  "64899323789661": "57893305811279", // 45  [SKU: contrast-black-45]
  // ─── Cool Grey (13 variants) ───
  "64899323855197": "57893305876815", // 36  [SKU: cool-grey-36]
  "64899323887965": "57893305909583", // 37  [SKU: cool-grey-37]
  "64899323920733": "57893305942351", // 38  [SKU: cool-grey-38]
  "64899323953501": "57893305975119", // 39  [SKU: cool-grey-39]
  "64899323986269": "57893306007887", // 40  [SKU: cool-grey-40]
  "64899324019037": "57893306040655", // 41  [SKU: cool-grey-41]
  "64899324051805": "57893306073423", // 42  [SKU: cool-grey-42]
  "64899324084573": "57893306106191", // 43  [SKU: cool-grey-43]
  "64899324117341": "57893306138959", // 44  [SKU: cool-grey-44]
  "64899324150109": "57893306171727", // 45  [SKU: cool-grey-45]
  "64899324182877": "57893306204495", // 46  [SKU: cool-grey-46]
  "64899324281181": "57893306302799", // 49  [SKU: cool-grey-49]
  "64899324313949": "57893306335567", // 50  [SKU: cool-grey-50]
  // ─── Coral (5 variants) ───
  "64899324772701": "57893306368335", // 36  [SKU: coral-36]
  "64899324805469": "57893306401103", // 37.5  [SKU: coral-37.5]
  "64899324838237": "57893306433871", // 38  [SKU: coral-38]
  "64899324871005": "57893306466639", // 39  [SKU: coral-39]
  "64899324903773": "57893306499407", // 40  [SKU: coral-40]
  // ─── Cotton Candy (10 variants) ───
  "64899325198685": "57893306728783", // 36  [SKU: cotton-candy-36]
  "64899325231453": "57893306761551", // 37  [SKU: cotton-candy-37]
  "64899325264221": "57893306794319", // 38  [SKU: cotton-candy-38]
  "64899325296989": "57893306827087", // 39  [SKU: cotton-candy-39]
  "64899325329757": "57893306859855", // 40  [SKU: cotton-candy-40]
  "64899325362525": "57893306892623", // 41  [SKU: cotton-candy-41]
  "64899325395293": "57893306925391", // 42  [SKU: cotton-candy-42]
  "64899325428061": "57893306958159", // 43  [SKU: cotton-candy-43]
  "64899325460829": "57893306990927", // 44  [SKU: cotton-candy-44]
  "64899325493597": "57893307023695", // 45  [SKU: cotton-candy-45]
  // ─── Crim White (10 variants) ───
  "64899328672093": "57893307744591", // 36  [SKU: crim-white-36]
  "64899328704861": "57893307777359", // 37.5  [SKU: crim-white-375]
  "64899328737629": "57893307810127", // 38  [SKU: crim-white-38]
  "64899328770397": "57893307842895", // 39  [SKU: crim-white-39]
  "64899328803165": "57893307875663", // 40  [SKU: crim-white-40]
  "64899328835933": "57893307908431", // 41  [SKU: crim-white-41]
  "64899328868701": "57893307941199", // 42  [SKU: crim-white-42]
  "64899328901469": "57893307973967", // 43  [SKU: crim-white-43]
  "64899328934237": "57893308006735", // 44  [SKU: crim-white-44]
  "64899328967005": "57893308039503", // 45  [SKU: crim-white-45]
  // ─── Dark Pewter (11 variants) ───
  "64899331981661": "57893311447375", // 36  [SKU: dark-pewter-36]
  "64899332014429": "57893311480143", // 37  [SKU: dark-pewter-37]
  "64899332047197": "57893311512911", // 38  [SKU: dark-pewter-38]
  "64899332079965": "57893311545679", // 39  [SKU: dark-pewter-39]
  "64899332112733": "57893311578447", // 40  [SKU: dark-pewter-40]
  "64899332145501": "57893311611215", // 41  [SKU: dark-pewter-41]
  "64899332178269": "57893311643983", // 42  [SKU: dark-pewter-42]
  "64899332211037": "57893311676751", // 43  [SKU: dark-pewter-43]
  "64899332243805": "57893311709519", // 44  [SKU: dark-pewter-44]
  "64899332276573": "57893311742287", // 45  [SKU: dark-pewter-45]
  "64899332309341": "57893311775055", // 46  [SKU: dark-pewter-46]
  // ─── Easy Grey (7 variants) ───
  "64899332407645": "57893311807823", // 40  [SKU: easy-grey-40]
  "64899332440413": "57893311840591", // 41  [SKU: easy-grey-41]
  "64899332473181": "57893311873359", // 42  [SKU: easy-grey-42]
  "64899332505949": "57893311906127", // 43  [SKU: easy-grey-43]
  "64899332538717": "57893311938895", // 44  [SKU: easy-grey-44]
  "64899332571485": "57893311971663", // 45  [SKU: easy-grey-45]
  "64899332604253": "57893312004431", // 46  [SKU: easy-grey-46]
  // ─── Eclipse Navy (11 variants) ───
  "64899332866397": "57893313053007", // 36  [SKU: eclipse-navy-36]
  "64899332899165": "57893313085775", // 37  [SKU: eclipse-navy-37]
  "64899332931933": "57893313118543", // 38  [SKU: eclipse-navy-38]
  "64899332964701": "57893313151311", // 39.5  [SKU: eclipse-navy-395]
  "64899332997469": "57893313184079", // 40  [SKU: eclipse-navy-40]
  "64899333030237": "57893313216847", // 41.5  [SKU: eclipse-navy-415]
  "64899333063005": "57893313249615", // 42  [SKU: eclipse-navy-42]
  "64899333095773": "57893313282383", // 43  [SKU: eclipse-navy-43]
  "64899333128541": "57893313315151", // 44  [SKU: eclipse-navy-44]
  "64899333161309": "57893313347919", // 45  [SKU: eclipse-navy-45]
  "64899333194077": "57893313380687", // 46.5  [SKU: eclipse-navy-465]
  // ─── Essentials (10 variants) ───
  "64899336175965": "57893313511759", // 36  [SKU: essentials-36]
  "64899336208733": "57893313544527", // 37  [SKU: essentials-37]
  "64899336241501": "57893313577295", // 38  [SKU: essentials-38]
  "64899336274269": "57893313610063", // 39  [SKU: essentials-39]
  "64899336307037": "57893313642831", // 40  [SKU: essentials-40]
  "64899336339805": "57893313675599", // 41  [SKU: essentials-41]
  "64899336372573": "57893313708367", // 42  [SKU: essentials-42]
  "64899336405341": "57893313741135", // 43  [SKU: essentials-43]
  "64899336438109": "57893313773903", // 44  [SKU: essentials-44]
  "64899336470877": "57893313806671", // 45  [SKU: essentials-45]
  // ─── Factor (18 variants) ───
  "64899341353309": "57893234475343", // Wit  [SKU: factor-wit-39]
  "64899341386077": "57893234508111", // Wit  [SKU: factor-wit-40]
  "64899341418845": "57893234540879", // Wit  [SKU: factor-wit-41]
  "64899341451613": "57893234573647", // Wit  [SKU: factor-wit-42]
  "64899341484381": "57893234606415", // Wit  [SKU: factor-wit-43]
  "64899341517149": "57893234639183", // Wit  [SKU: factor-wit-44]
  "64899341549917": "57893234671951", // Groen  [SKU: factor-groen-39]
  "64899341582685": "57893234704719", // Groen  [SKU: factor-groen-40]
  "64899341615453": "57893234737487", // Groen  [SKU: factor-groen-41]
  "64899341648221": "57893234770255", // Groen  [SKU: factor-groen-42]
  "64899341680989": "57893234803023", // Groen  [SKU: factor-groen-43]
  "64899341713757": "57893234835791", // Groen  [SKU: factor-groen-44]
  "64899341746525": "57893234868559", // Zwart  [SKU: factor-zwart-39]
  "64899341779293": "57893234901327", // Zwart  [SKU: factor-zwart-40]
  "64899341812061": "57893234934095", // Zwart  [SKU: factor-zwart-41]
  "64899341844829": "57893234966863", // Zwart  [SKU: factor-zwart-42]
  "64899341877597": "57893234999631", // Zwart  [SKU: factor-zwart-43]
  "64899341910365": "57893235032399", // Zwart  [SKU: factor-zwart-44]
  // ─── Flax (10 variants) ───
  "64899342795101": "57893315019087", // 36  [SKU: flax-36]
  "64899342827869": "57893315051855", // 37  [SKU: flax-37]
  "64899342860637": "57893315084623", // 38  [SKU: flax-38]
  "64899342893405": "57893315117391", // 39  [SKU: flax-39]
  "64899342926173": "57893315150159", // 40  [SKU: flax-40]
  "64899342958941": "57893315182927", // 41  [SKU: flax-41]
  "64899342991709": "57893315215695", // 42  [SKU: flax-42]
  "64899343024477": "57893315248463", // 43  [SKU: flax-43]
  "64899343057245": "57893315281231", // 44  [SKU: flax-44]
  "64899343090013": "57893315313999", // 45  [SKU: flax-45]
  // ─── Flying Mesh (50 variants) ───
  "64899343253853": "57893316133199", // 36  [SKU: flying-mesh-36-grijs]
  "64899343286621": "57893316165967", // 36  [SKU: flying-mesh-36-grijs-blauw]
  "64899343319389": "57893316198735", // 36  [SKU: flying-mesh-36-groente]
  "64899343352157": "57893316231503", // 36  [SKU: flying-mesh-36-oranje]
  "64899343384925": "57893316264271", // 36  [SKU: flying-mesh-36-ijsblauw]
  "64899343417693": "57893316297039", // 37  [SKU: flying-mesh-37-grijs]
  "64899343450461": "57893316329807", // 37  [SKU: flying-mesh-37-grijs-blauw]
  "64899343483229": "57893316100431", // 37  [SKU: flying-mesh-37-groente]
  "64899343515997": "57893316362575", // 37  [SKU: flying-mesh-37-oranje]
  "64899343548765": "57893316395343", // 37  [SKU: flying-mesh-37-ijsblauw]
  "64899343581533": "57893316428111", // 38  [SKU: flying-mesh-38-grijs]
  "64899343614301": "57893316460879", // 38  [SKU: flying-mesh-38-grijs-blauw]
  "64899343647069": "57893316493647", // 38  [SKU: flying-mesh-38-groente]
  "64899343679837": "57893316526415", // 38  [SKU: flying-mesh-38-oranje]
  "64899343712605": "57893316559183", // 38  [SKU: flying-mesh-38-ijsblauw]
  "64899343745373": "57893316591951", // 39  [SKU: flying-mesh-39-grijs]
  "64899343778141": "57893316624719", // 39  [SKU: flying-mesh-39-grijs-blauw]
  "64899343810909": "57893316657487", // 39  [SKU: flying-mesh-39-groente]
  "64899343843677": "57893316690255", // 39  [SKU: flying-mesh-39-oranje]
  "64899343876445": "57893316723023", // 39  [SKU: flying-mesh-39-ijsblauw]
  "64899343909213": "57893316755791", // 40  [SKU: flying-mesh-40-grijs]
  "64899343941981": "57893316788559", // 40  [SKU: flying-mesh-40-grijs-blauw]
  "64899343974749": "57893316821327", // 40  [SKU: flying-mesh-40-groente]
  "64899344007517": "57893316854095", // 40  [SKU: flying-mesh-40-oranje]
  "64899344040285": "57893316886863", // 40  [SKU: flying-mesh-40-ijsblauw]
  "64899344073053": "57893316919631", // 41  [SKU: flying-mesh-41-grijs]
  "64899344105821": "57893316952399", // 41  [SKU: flying-mesh-41-grijs-blauw]
  "64899344138589": "57893316985167", // 41  [SKU: flying-mesh-41-groente]
  "64899344171357": "57893317017935", // 41  [SKU: flying-mesh-41-oranje]
  "64899344204125": "57893317050703", // 41  [SKU: flying-mesh-41-ijsblauw]
  "64899344236893": "57893317083471", // 42  [SKU: flying-mesh-42-grijs]
  "64899344269661": "57893317116239", // 42  [SKU: flying-mesh-42-grijs-blauw]
  "64899344302429": "57893317149007", // 42  [SKU: flying-mesh-42-groente]
  "64899344335197": "57893317181775", // 42  [SKU: flying-mesh-42-oranje]
  "64899344367965": "57893317214543", // 42  [SKU: flying-mesh-42-ijsblauw]
  "64899344400733": "57893317247311", // 43  [SKU: flying-mesh-43-grijs]
  "64899344433501": "57893317280079", // 43  [SKU: flying-mesh-43-grijs-blauw]
  "64899344466269": "57893317345615", // 43  [SKU: flying-mesh-43-groente]
  "64899344499037": "57893317378383", // 43  [SKU: flying-mesh-43-oranje]
  "64899344531805": "57893317411151", // 43  [SKU: flying-mesh-43-ijsblauw]
  "64899344564573": "57893317443919", // 44  [SKU: flying-mesh-44-grijs]
  "64899344597341": "57893317476687", // 44  [SKU: flying-mesh-44-grijs-blauw]
  "64899344630109": "57893317509455", // 44  [SKU: flying-mesh-44-groente]
  "64899344662877": "57893317542223", // 44  [SKU: flying-mesh-44-oranje]
  "64899344695645": "57893317574991", // 44  [SKU: flying-mesh-44-ijsblauw]
  "64899344728413": "57893317607759", // 45  [SKU: flying-mesh-45-grijs]
  "64899344761181": "57893317640527", // 45  [SKU: flying-mesh-45-grijs-blauw]
  "64899344793949": "57893317673295", // 45  [SKU: flying-mesh-45-groente]
  "64899344826717": "57893317706063", // 45  [SKU: flying-mesh-45-oranje]
  "64899344859485": "57893317738831", // 45  [SKU: flying-mesh-45-ijsblauw]
  // ─── Fresh Mint (11 variants) ───
  "64899346170205": "57893318295887", // 36  [SKU: fresh-mint-36]
  "64899346202973": "57893318328655", // 37  [SKU: fresh-mint-37]
  "64899346235741": "57893318361423", // 38  [SKU: fresh-mint-38]
  "64899346268509": "57893318394191", // 39  [SKU: fresh-mint-39]
  "64899346301277": "57893318426959", // 40  [SKU: fresh-mint-40]
  "64899346334045": "57893318459727", // 41  [SKU: fresh-mint-41]
  "64899346366813": "57893318492495", // 42  [SKU: fresh-mint-42]
  "64899346399581": "57893318525263", // 43  [SKU: fresh-mint-43]
  "64899346432349": "57893318558031", // 44  [SKU: fresh-mint-44]
  "64899346465117": "57893318590799", // 45  [SKU: fresh-mint-45]
  "64899346497885": "57893318623567", // 46  [SKU: fresh-mint-46]
  // ─── Future (11 variants) ───
  "64899346694493": "57893318787407", // 36  [SKU: future-36]
  "64899346727261": "57893318820175", // 37.5  [SKU: future-37.5]
  "64899346760029": "57893318852943", // 38  [SKU: future-38]
  "64899346792797": "57893318885711", // 39  [SKU: future-39]
  "64899346825565": "57893318918479", // 40  [SKU: future-40]
  "64899346858333": "57893318951247", // 41  [SKU: future-41]
  "64899346891101": "57893318984015", // 42  [SKU: future-42]
  "64899346923869": "57893319016783", // 43  [SKU: future-43]
  "64899346956637": "57893318754639", // 44  [SKU: future-44]
  "64899346989405": "57893319049551", // 45  [SKU: future-45]
  "64899347022173": "57893319082319", // 46  [SKU: future-46]
  // ─── Galaxy (11 variants) ───
  "64899347120477": "57893319147855", // 36  [SKU: galaxy-36]
  "64899347153245": "57893319180623", // 37.5  [SKU: galaxy-37.5]
  "64899347186013": "57893319213391", // 38  [SKU: galaxy-38]
  "64899347218781": "57893319246159", // 39  [SKU: galaxy-39]
  "64899347251549": "57893319278927", // 40  [SKU: galaxy-40]
  "64899347284317": "57893319311695", // 41  [SKU: galaxy-41]
  "64899347317085": "57893319344463", // 42  [SKU: galaxy-42]
  "64899347349853": "57893319377231", // 43  [SKU: galaxy-43]
  "64899347382621": "57893319409999", // 44  [SKU: galaxy-44]
  "64899347415389": "57893319442767", // 45  [SKU: galaxy-45]
  "64899347448157": "57893319475535", // 46  [SKU: galaxy-46]
  // ─── Gattuso (24 variants) ───
  "64899349021021": "57893238473039", // Wit  [SKU: gattuso-wit-39]
  "64899349053789": "57893238505807", // Wit  [SKU: gattuso-wit-40]
  "64899349086557": "57893238538575", // Wit  [SKU: gattuso-wit-41]
  "64899349119325": "57893238571343", // Wit  [SKU: gattuso-wit-42]
  "64899349152093": "57893238604111", // Wit  [SKU: gattuso-wit-43]
  "64899349184861": "57893238636879", // Wit  [SKU: gattuso-wit-44]
  "64899349217629": "57893238669647", // Wit  [SKU: gattuso-wit-45]
  "64899349250397": "57893238702415", // Wit  [SKU: gattuso-wit-46]
  "64899349348701": "57893238800719", // Zwart  [SKU: gattuso-zwart-39]
  "64899349381469": "57893238833487", // Zwart  [SKU: gattuso-zwart-40]
  "64899349414237": "57893238866255", // Zwart  [SKU: gattuso-zwart-41]
  "64899349447005": "57893238899023", // Zwart  [SKU: gattuso-zwart-42]
  "64899349479773": "57893238931791", // Zwart  [SKU: gattuso-zwart-43]
  "64899349512541": "57893238964559", // Zwart  [SKU: gattuso-zwart-44]
  "64899349545309": "57893238997327", // Zwart  [SKU: gattuso-zwart-45]
  "64899349578077": "57893239030095", // Zwart  [SKU: gattuso-zwart-46]
  "64899349676381": "57893239128399", // Donkerblauw  [SKU: gattuso-donkerblauw-39]
  "64899349709149": "57893239161167", // Donkerblauw  [SKU: gattuso-donkerblauw-40]
  "64899349741917": "57893239193935", // Donkerblauw  [SKU: gattuso-donkerblauw-41]
  "64899349774685": "57893239226703", // Donkerblauw  [SKU: gattuso-donkerblauw-42]
  "64899349807453": "57893239259471", // Donkerblauw  [SKU: gattuso-donkerblauw-43]
  "64899349840221": "57893239292239", // Donkerblauw  [SKU: gattuso-donkerblauw-44]
  "64899349872989": "57893239325007", // Donkerblauw  [SKU: gattuso-donkerblauw-45]
  "64899349905757": "57893239357775", // Donkerblauw  [SKU: gattuso-donkerblauw-46]
  // ─── Gleame (32 variants) ───
  "64899350135133": "57893239619919", // Wit  [SKU: gleame-wit-35]
  "64899350167901": "57893239652687", // Wit  [SKU: gleame-wit-36]
  "64899350200669": "57893239685455", // Wit  [SKU: gleame-wit-37]
  "64899350233437": "57893239718223", // Wit  [SKU: gleame-wit-38]
  "64899350266205": "57893239750991", // Wit  [SKU: gleame-wit-39]
  "64899350298973": "57893239783759", // Wit  [SKU: gleame-wit-40]
  "64899350331741": "57893239816527", // Wit  [SKU: gleame-wit-41]
  "64899350364509": "57893239849295", // Wit  [SKU: gleame-wit-42]
  "64899350397277": "57893239882063", // Zwart  [SKU: gleame-zwart-35]
  "64899350430045": "57893239914831", // Zwart  [SKU: gleame-zwart-36]
  "64899350462813": "57893239947599", // Zwart  [SKU: gleame-zwart-37]
  "64899350495581": "57893239980367", // Zwart  [SKU: gleame-zwart-38]
  "64899350528349": "57893240013135", // Zwart  [SKU: gleame-zwart-39]
  "64899350561117": "57893240045903", // Zwart  [SKU: gleame-zwart-40]
  "64899350593885": "57893240078671", // Zwart  [SKU: gleame-zwart-41]
  "64899350626653": "57893240111439", // Zwart  [SKU: gleame-zwart-42]
  "64899350659421": "57893240144207", // Roze  [SKU: gleame-roze-35]
  "64899350692189": "57893240176975", // Roze  [SKU: gleame-roze-36]
  "64899350724957": "57893240209743", // Roze  [SKU: gleame-roze-37]
  "64899350757725": "57893240242511", // Roze  [SKU: gleame-roze-38]
  "64899350790493": "57893240275279", // Roze  [SKU: gleame-roze-39]
  "64899350823261": "57893240308047", // Roze  [SKU: gleame-roze-40]
  "64899350856029": "57893240340815", // Roze  [SKU: gleame-roze-41]
  "64899350888797": "57893240373583", // Roze  [SKU: gleame-roze-42]
  "64899350921565": "57893240406351", // Regenbogen  [SKU: gleame-regenbogen-35]
  "64899350954333": "57893240439119", // Regenbogen  [SKU: gleame-regenbogen-36]
  "64899350987101": "57893240471887", // Regenbogen  [SKU: gleame-regenbogen-37]
  "64899351019869": "57893240504655", // Regenbogen  [SKU: gleame-regenbogen-38]
  "64899351052637": "57893240537423", // Regenbogen  [SKU: gleame-regenbogen-39]
  "64899351085405": "57893240570191", // Regenbogen  [SKU: gleame-regenbogen-40]
  "64899351118173": "57893240602959", // Regenbogen  [SKU: gleame-regenbogen-41]
  "64899351150941": "57893240635727", // Regenbogen  [SKU: gleame-regenbogen-42]
  // ─── Glitter (16 variants) ───
  "64899351445853": "57893241225551", // Zwart  [SKU: glitter-zwart-36]
  "64899351478621": "57893241258319", // Zwart  [SKU: glitter-zwart-37]
  "64899351511389": "57893241291087", // Zwart  [SKU: glitter-zwart-38]
  "64899351544157": "57893241323855", // Zwart  [SKU: glitter-zwart-39]
  "64899351576925": "57893241356623", // Zwart  [SKU: glitter-zwart-40]
  "64899351609693": "57893241389391", // Zwart  [SKU: glitter-zwart-41]
  "64899351642461": "57893241422159", // Zwart  [SKU: glitter-zwart-42]
  "64899351675229": "57893241454927", // Zwart  [SKU: glitter-zwart-43]
  "64899351707997": "57893241487695", // Silver  [SKU: glitter-silver-36]
  "64899351740765": "57893241520463", // Silver  [SKU: glitter-silver-37]
  "64899351773533": "57893241553231", // Silver  [SKU: glitter-silver-38]
  "64899351806301": "57893241585999", // Silver  [SKU: glitter-silver-39]
  "64899351839069": "57893241618767", // Silver  [SKU: glitter-silver-40]
  "64899351871837": "57893241651535", // Silver  [SKU: glitter-silver-41]
  "64899351904605": "57893241684303", // Silver  [SKU: glitter-silver-42]
  "64899351937373": "57893241717071", // Silver  [SKU: glitter-silver-43]
  // ─── Golden Swoosh (10 variants) ───
  "64899352199517": "57893320622415", // 36  [SKU: golden-swoosh-36]
  "64899352232285": "57893320655183", // 37  [SKU: golden-swoosh-37]
  "64899352265053": "57893320687951", // 38  [SKU: golden-swoosh-38]
  "64899352297821": "57893320720719", // 39  [SKU: golden-swoosh-39]
  "64899352330589": "57893320753487", // 40  [SKU: golden-swoosh-40]
  "64899352363357": "57893320786255", // 41  [SKU: golden-swoosh-41]
  "64899352396125": "57893320819023", // 42  [SKU: golden-swoosh-42]
  "64899352428893": "57893320851791", // 43  [SKU: golden-swoosh-43]
  "64899352461661": "57893320884559", // 44  [SKU: golden-swoosh-44]
  "64899352494429": "57893320917327", // 45  [SKU: golden-swoosh-45]
  // ─── Good Game (10 variants) ───
  "64899352985949": "57893321015631", // 36  [SKU: good-game-36]
  "64899353018717": "57893321048399", // 37  [SKU: good-game-37]
  "64899353051485": "57893321081167", // 38  [SKU: good-game-38]
  "64899353084253": "57893321113935", // 39  [SKU: good-game-39]
  "64899353117021": "57893321146703", // 40  [SKU: good-game-40]
  "64899353149789": "57893321179471", // 41  [SKU: good-game-41]
  "64899353182557": "57893321212239", // 42  [SKU: good-game-42]
  "64899353215325": "57893320982863", // 43  [SKU: good-game-43]
  "64899353248093": "57893321245007", // 44  [SKU: good-game-44]
  "64899353280861": "57893321277775", // 45  [SKU: good-game-45]
  // ─── Grape (11 variants) ───
  "64899353608541": "57893321310543", // 36  [SKU: grape-36]
  "64899353641309": "57893321343311", // 37.5  [SKU: grape-37.5]
  "64899353674077": "57893321376079", // 38  [SKU: grape-38]
  "64899353706845": "57893321408847", // 39  [SKU: grape-39]
  "64899353739613": "57893321441615", // 40  [SKU: grape-40]
  "64899353772381": "57893321474383", // 41  [SKU: grape-41]
  "64899353805149": "57893321507151", // 42  [SKU: grape-42]
  "64899353837917": "57893321539919", // 43  [SKU: grape-43]
  "64899353870685": "57893321572687", // 44  [SKU: grape-44]
  "64899353903453": "57893321605455", // 45  [SKU: grape-45]
  "64899353936221": "57893321638223", // 46  [SKU: grape-46]
  // ─── Greyscale (11 variants) ───
  "64899354722653": "57893321900367", // 36  [SKU: greyscale-36]
  "64899354755421": "57893321933135", // 37  [SKU: greyscale-37]
  "64899354788189": "57893321965903", // 38  [SKU: greyscale-38]
  "64899354820957": "57893321998671", // 39  [SKU: greyscale-39]
  "64899354853725": "57893322031439", // 40  [SKU: greyscale-40]
  "64899354886493": "57893322064207", // 41  [SKU: greyscale-41]
  "64899354919261": "57893322096975", // 42  [SKU: greyscale-42]
  "64899354952029": "57893322129743", // 43  [SKU: greyscale-43]
  "64899354984797": "57893322162511", // 44  [SKU: greyscale-44]
  "64899355017565": "57893322195279", // 45  [SKU: greyscale-45]
  "64899355050333": "57893322228047", // 46  [SKU: greyscale-46]
  // ─── Grijs Lila (11 variants) ───
  "64899355443549": "57893322359119", // 36  [SKU: grijs-lila-36]
  "64899355476317": "57893322391887", // 37  [SKU: grijs-lila-37]
  "64899355509085": "57893322424655", // 38  [SKU: grijs-lila-38]
  "64899355541853": "57893322457423", // 39.5  [SKU: grijs-lila-395]
  "64899355574621": "57893322490191", // 40  [SKU: grijs-lila-40]
  "64899355607389": "57893322522959", // 41.5  [SKU: grijs-lila-415]
  "64899355640157": "57893322555727", // 42  [SKU: grijs-lila-42]
  "64899355672925": "57893322588495", // 43  [SKU: grijs-lila-43]
  "64899355705693": "57893322621263", // 44  [SKU: grijs-lila-44]
  "64899355738461": "57893322654031", // 45  [SKU: grijs-lila-45]
  "64899355771229": "57893322686799", // 46.5  [SKU: grijs-lila-465]
  // ─── Grijs Maanstraal (11 variants) ───
  "64899355935069": "57893322785103", // 36  [SKU: grijs-maanstraal-36]
  "64899355967837": "57893322817871", // 37  [SKU: grijs-maanstraal-37]
  "64899356000605": "57893322850639", // 38  [SKU: grijs-maanstraal-38]
  "64899356033373": "57893322883407", // 39.5  [SKU: grijs-maanstraal-395]
  "64899356066141": "57893322916175", // 40  [SKU: grijs-maanstraal-40]
  "64899356098909": "57893322948943", // 41.5  [SKU: grijs-maanstraal-415]
  "64899356131677": "57893322981711", // 42  [SKU: grijs-maanstraal-42]
  "64899356164445": "57893323014479", // 43  [SKU: grijs-maanstraal-43]
  "64899356197213": "57893323047247", // 44  [SKU: grijs-maanstraal-44]
  "64899356229981": "57893323080015", // 45  [SKU: grijs-maanstraal-45]
  "64899356262749": "57893323112783", // 46.5  [SKU: grijs-maanstraal-465]
  // ─── Halloween (11 variants) ───
  "64899356393821": "57893325504847", // 36  [SKU: halloween-36]
  "64899356426589": "57893325537615", // 37  [SKU: halloween-37]
  "64899356459357": "57893325570383", // 38  [SKU: halloween-38]
  "64899356492125": "57893325603151", // 39  [SKU: halloween-39]
  "64899356524893": "57893325635919", // 40  [SKU: halloween-40]
  "64899356557661": "57893325668687", // 41  [SKU: halloween-41]
  "64899356590429": "57893325701455", // 42  [SKU: halloween-42]
  "64899356623197": "57893325734223", // 43  [SKU: halloween-43]
  "64899356655965": "57893325766991", // 44  [SKU: halloween-44]
  "64899356688733": "57893325799759", // 45  [SKU: halloween-45]
  "64899356721501": "57893325832527", // 46  [SKU: halloween-46]
  // ─── Hemp (11 variants) ───
  "64899356918109": "57893326127439", // 36  [SKU: hemp-36]
  "64899356950877": "57893326160207", // 37  [SKU: hemp-37]
  "64899356983645": "57893326192975", // 38  [SKU: hemp-38]
  "64899357016413": "57893326225743", // 39  [SKU: hemp-39]
  "64899357049181": "57893326258511", // 40  [SKU: hemp-40]
  "64899357081949": "57893326291279", // 41  [SKU: hemp-41]
  "64899357114717": "57893326324047", // 42  [SKU: hemp-42]
  "64899357147485": "57893326356815", // 43  [SKU: hemp-43]
  "64899357180253": "57893326389583", // 44  [SKU: hemp-44]
  "64899357213021": "57893326422351", // 45  [SKU: hemp-45]
  "64899357245789": "57893326455119", // 46  [SKU: hemp-46]
  // ─── Hemp Cream (6 variants) ───
  "64899357409629": "57893326684495", // 36  [SKU: hemp-cream-36]
  "64899357442397": "57893326717263", // 37.5  [SKU: hemp-cream-375]
  "64899357475165": "57893326750031", // 38  [SKU: hemp-cream-38]
  "64899357507933": "57893326782799", // 39  [SKU: hemp-cream-39]
  "64899357540701": "57893326815567", // 40  [SKU: hemp-cream-40]
  "64899357573469": "57893326848335", // 41  [SKU: hemp-cream-41]
  // ─── Hero (11 variants) ───
  "64899357901149": "57893327438159", // 36  [SKU: hero-36]
  "64899357933917": "57893327470927", // 37.5  [SKU: hero-37.5]
  "64899357966685": "57893327503695", // 38  [SKU: hero-38]
  "64899357999453": "57893327536463", // 39  [SKU: hero-39]
  "64899358032221": "57893327569231", // 40  [SKU: hero-40]
  "64899358064989": "57893327601999", // 41  [SKU: hero-41]
  "64899358097757": "57893327634767", // 42  [SKU: hero-42]
  "64899358130525": "57893327667535", // 43  [SKU: hero-43]
  "64899358163293": "57893327700303", // 44  [SKU: hero-44]
  "64899358196061": "57893327733071", // 45  [SKU: hero-45]
  "64899358228829": "57893327765839", // 46  [SKU: hero-46]
  // ─── Home (10 variants) ───
  "64899358359901": "57893328191823", // 36  [SKU: home-36]
  "64899358392669": "57893328224591", // 37.5  [SKU: home-37.5]
  "64899358425437": "57893328257359", // 38  [SKU: home-38]
  "64899358458205": "57893328290127", // 39  [SKU: home-39]
  "64899358490973": "57893328322895", // 40  [SKU: home-40]
  "64899358523741": "57893328355663", // 41  [SKU: home-41]
  "64899358556509": "57893328388431", // 42  [SKU: home-42]
  "64899358589277": "57893328159055", // 43  [SKU: home-43]
  "64899358622045": "57893328421199", // 44  [SKU: home-44]
  "64899358654813": "57893328453967", // 45  [SKU: home-45]
  // ─── Hot Coral (11 variants) ───
  "64899658580317": "57893328552271", // 36  [SKU: hot-coral-36]
  "64899658613085": "57893328585039", // 37  [SKU: hot-coral-37]
  "64899658645853": "57893328617807", // 38  [SKU: hot-coral-38]
  "64899658678621": "57893328650575", // 39  [SKU: hot-coral-39]
  "64899658711389": "57893328683343", // 40  [SKU: hot-coral-40]
  "64899658744157": "57893328716111", // 41  [SKU: hot-coral-41]
  "64899658776925": "57893328748879", // 42  [SKU: hot-coral-42]
  "64899658809693": "57893328781647", // 43  [SKU: hot-coral-43]
  "64899658842461": "57893328814415", // 44  [SKU: hot-coral-44]
  "64899658875229": "57893328847183", // 45  [SKU: hot-coral-45]
  "64899658907997": "57893328879951", // 46  [SKU: hot-coral-46]
  // ─── Hunter (11 variants) ───
  "64899358884189": "57893329011023", // 36  [SKU: hunter-36]
  "64899358916957": "57893329043791", // 37.5  [SKU: hunter-37.5]
  "64899358949725": "57893329076559", // 38  [SKU: hunter-38]
  "64899358982493": "57893329109327", // 39  [SKU: hunter-39]
  "64899359015261": "57893329142095", // 40  [SKU: hunter-40]
  "64899359048029": "57893329174863", // 41  [SKU: hunter-41]
  "64899359080797": "57893329207631", // 42  [SKU: hunter-42]
  "64899359113565": "57893329240399", // 43  [SKU: hunter-43]
  "64899359146333": "57893329273167", // 44  [SKU: hunter-44]
  "64899359179101": "57893329305935", // 45  [SKU: hunter-45]
  "64899359211869": "57893329338703", // 46  [SKU: hunter-46]
  // ─── Hype (11 variants) ───
  "64899360129373": "57893330223439", // 36  [SKU: hype-36]
  "64899360162141": "57893330256207", // 37.5  [SKU: hype-37.5]
  "64899360194909": "57893330288975", // 38  [SKU: hype-38]
  "64899360227677": "57893330321743", // 39  [SKU: hype-39]
  "64899360260445": "57893330354511", // 40  [SKU: hype-40]
  "64899360293213": "57893330387279", // 41  [SKU: hype-41]
  "64899360325981": "57893330420047", // 42  [SKU: hype-42]
  "64899360358749": "57893330452815", // 43  [SKU: hype-43]
  "64899360391517": "57893330485583", // 44  [SKU: hype-44]
  "64899360424285": "57893330518351", // 45  [SKU: hype-45]
  "64899360457053": "57893330551119", // 46  [SKU: hype-46]
  // ─── Iron Grey (11 variants) ───
  "64899361472861": "57893330747727", // 36  [SKU: iron-grey-36]
  "64899361505629": "57893330780495", // 37  [SKU: iron-grey-37]
  "64899361538397": "57893330813263", // 38  [SKU: iron-grey-38]
  "64899361571165": "57893330846031", // 39  [SKU: iron-grey-39]
  "64899361603933": "57893330878799", // 40  [SKU: iron-grey-40]
  "64899361636701": "57893330911567", // 41  [SKU: iron-grey-41]
  "64899361669469": "57893330944335", // 42  [SKU: iron-grey-42]
  "64899361702237": "57893330977103", // 43  [SKU: iron-grey-43]
  "64899361735005": "57893331009871", // 44  [SKU: iron-grey-44]
  "64899361767773": "57893331042639", // 45  [SKU: iron-grey-45]
  "64899361800541": "57893331075407", // 46  [SKU: iron-grey-46]
  // ─── Ivory Glide (27 variants) ───
  "64899362685277": "57893331206479", // 36  [SKU: ivory-glide-36-zwart]
  "64899362718045": "57893331239247", // 36  [SKU: ivory-glide-36-wit]
  "64899362750813": "57893331272015", // 36  [SKU: ivory-glide-36-beige]
  "64899362783581": "57893331173711", // 37  [SKU: ivory-glide-37-zwart]
  "64899362816349": "57893331304783", // 37  [SKU: ivory-glide-37-wit]
  "64899362849117": "57893331337551", // 37  [SKU: ivory-glide-37-beige]
  "64899362881885": "57893331370319", // 38  [SKU: ivory-glide-38-zwart]
  "64899362914653": "57893331403087", // 38  [SKU: ivory-glide-38-wit]
  "64899362947421": "57893331435855", // 38  [SKU: ivory-glide-38-beige]
  "64899362980189": "57893331468623", // 39  [SKU: ivory-glide-39-zwart]
  "64899363012957": "57893331501391", // 39  [SKU: ivory-glide-39-wit]
  "64899363045725": "57893331534159", // 39  [SKU: ivory-glide-39-beige]
  "64899363078493": "57893331566927", // 40  [SKU: ivory-glide-40-zwart]
  "64899363111261": "57893331599695", // 40  [SKU: ivory-glide-40-wit]
  "64899363144029": "57893331632463", // 40  [SKU: ivory-glide-40-beige]
  "64899363176797": "57893331665231", // 41  [SKU: ivory-glide-41-zwart]
  "64899363209565": "57893331697999", // 41  [SKU: ivory-glide-41-wit]
  "64899363242333": "57893331730767", // 41  [SKU: ivory-glide-41-beige]
  "64899363275101": "57893331763535", // 42  [SKU: ivory-glide-42-zwart]
  "64899363307869": "57893331796303", // 42  [SKU: ivory-glide-42-wit]
  "64899363340637": "57893331829071", // 42  [SKU: ivory-glide-42-beige]
  "64899363373405": "57893331861839", // 43  [SKU: ivory-glide-43-zwart]
  "64899363406173": "57893331894607", // 43  [SKU: ivory-glide-43-wit]
  "64899363438941": "57893331927375", // 43  [SKU: ivory-glide-43-beige]
  "64899363471709": "57893331960143", // 44  [SKU: ivory-glide-44-zwart]
  "64899363504477": "57893331992911", // 44  [SKU: ivory-glide-44-wit]
  "64899363537245": "57893332025679", // 44  [SKU: ivory-glide-44-beige]
  // ─── Judie (18 variants) ───
  "64899659039069": "57893242077519", // Oranje  [SKU: judie-oranje-36]
  "64899659071837": "57893242110287", // Oranje  [SKU: judie-oranje-37]
  "64899659104605": "57893242143055", // Oranje  [SKU: judie-oranje-38]
  "64899659137373": "57893242175823", // Oranje  [SKU: judie-oranje-39]
  "64899659170141": "57893242208591", // Oranje  [SKU: judie-oranje-40]
  "64899659202909": "57893242241359", // Oranje  [SKU: judie-oranje-41]
  "64899659235677": "57893242274127", // Beige  [SKU: judie-beige-36]
  "64899659268445": "57893242306895", // Beige  [SKU: judie-beige-37]
  "64899659301213": "57893242339663", // Beige  [SKU: judie-beige-38]
  "64899659333981": "57893242372431", // Beige  [SKU: judie-beige-39]
  "64899659366749": "57893242405199", // Beige  [SKU: judie-beige-40]
  "64899659399517": "57893242437967", // Beige  [SKU: judie-beige-41]
  "64899659432285": "57893242470735", // Blauw  [SKU: judie-blauw-36]
  "64899659465053": "57893242503503", // Blauw  [SKU: judie-blauw-37]
  "64899659497821": "57893242536271", // Blauw  [SKU: judie-blauw-38]
  "64899659530589": "57893242569039", // Blauw  [SKU: judie-blauw-39]
  "64899659563357": "57893242601807", // Blauw  [SKU: judie-blauw-40]
  "64899659596125": "57893242634575", // Blauw  [SKU: judie-blauw-41]
  // ─── Judith (8 variants) ───
  "64899364061533": "57893242962255", // Luipaard  [SKU: judith-luipaard-36]
  "64899364094301": "57893242995023", // Luipaard  [SKU: judith-luipaard-37]
  "64899364127069": "57893243027791", // Luipaard  [SKU: judith-luipaard-38]
  "64899364159837": "57893243060559", // Luipaard  [SKU: judith-luipaard-39]
  "64899364192605": "57893243093327", // Luipaard  [SKU: judith-luipaard-40]
  "64899364225373": "57893243126095", // Luipaard  [SKU: judith-luipaard-41]
  "64899364258141": "57893243158863", // Luipaard  [SKU: judith-luipaard-42]
  "64899364290909": "57893243191631", // Luipaard  [SKU: judith-luipaard-43]
  // ─── LV1 (10 variants) ───
  "64899372286301": "57893341266255", // 36  [SKU: lv1-36]
  "64899372319069": "57893341299023", // 37.5  [SKU: lv1-375]
  "64899372351837": "57893341331791", // 38  [SKU: lv1-38]
  "64899372384605": "57893341364559", // 39  [SKU: lv1-39]
  "64899372417373": "57893341397327", // 40  [SKU: lv1-40]
  "64899372450141": "57893341430095", // 41  [SKU: lv1-41]
  "64899372482909": "57893341462863", // 42  [SKU: lv1-42]
  "64899372515677": "57893341495631", // 43  [SKU: lv1-43]
  "64899372548445": "57893341528399", // 44  [SKU: lv1-44]
  "64899372581213": "57893341561167", // 45  [SKU: lv1-45]
  // ─── Laarzen 1462 (16 variants) ───
  "64899364618589": "57893334712655", // Zwart  [SKU: laarzen-1462-zwart-35]
  "64899364651357": "57893334745423", // Zwart  [SKU: laarzen-1462-zwart-36]
  "64899364684125": "57893334778191", // Zwart  [SKU: laarzen-1462-zwart-37]
  "64899364716893": "57893334810959", // Zwart  [SKU: laarzen-1462-zwart-38]
  "64899364749661": "57893334843727", // Zwart  [SKU: laarzen-1462-zwart-39]
  "64899364782429": "57893334876495", // Zwart  [SKU: laarzen-1462-zwart-40]
  "64899364815197": "57893334909263", // Zwart  [SKU: laarzen-1462-zwart-41]
  "64899364847965": "57893334942031", // Zwart  [SKU: laarzen-1462-zwart-42]
  "64899364880733": "57893334450511", // Wit  [SKU: laarzen-1462-wit-35]
  "64899364913501": "57893334483279", // Wit  [SKU: laarzen-1462-wit-36]
  "64899364946269": "57893334516047", // Wit  [SKU: laarzen-1462-wit-37]
  "64899364979037": "57893334548815", // Wit  [SKU: laarzen-1462-wit-38]
  "64899365011805": "57893334581583", // Wit  [SKU: laarzen-1462-wit-39]
  "64899365044573": "57893334614351", // Wit  [SKU: laarzen-1462-wit-40]
  "64899365077341": "57893334647119", // Wit  [SKU: laarzen-1462-wit-41]
  "64899365110109": "57893334679887", // Wit  [SKU: laarzen-1462-wit-42]
  // ─── Laser (11 variants) ───
  "64899365273949": "57893335007567", // 36  [SKU: laser-36]
  "64899365306717": "57893335040335", // 37.5  [SKU: laser-37.5]
  "64899365339485": "57893335073103", // 38  [SKU: laser-38]
  "64899365372253": "57893335105871", // 39  [SKU: laser-39]
  "64899365405021": "57893335138639", // 40  [SKU: laser-40]
  "64899365437789": "57893335171407", // 41  [SKU: laser-41]
  "64899365470557": "57893335204175", // 42  [SKU: laser-42]
  "64899365503325": "57893335236943", // 43  [SKU: laser-43]
  "64899365536093": "57893335269711", // 44  [SKU: laser-44]
  "64899365568861": "57893335302479", // 45  [SKU: laser-45]
  "64899365601629": "57893335335247", // 46  [SKU: laser-46]
  // ─── Lavender (11 variants) ───
  "64899366945117": "57893335400783", // 36  [SKU: lavender-36]
  "64899366977885": "57893335433551", // 37  [SKU: lavender-37]
  "64899367010653": "57893335466319", // 38  [SKU: lavender-38]
  "64899367043421": "57893335499087", // 39  [SKU: lavender-39]
  "64899367076189": "57893335531855", // 40  [SKU: lavender-40]
  "64899367108957": "57893335564623", // 41  [SKU: lavender-41]
  "64899367141725": "57893335597391", // 42  [SKU: lavender-42]
  "64899367174493": "57893335630159", // 43  [SKU: lavender-43]
  "64899367207261": "57893335662927", // 44  [SKU: lavender-44]
  "64899367240029": "57893335695695", // 45  [SKU: lavender-45]
  "64899367272797": "57893335728463", // 46  [SKU: lavender-46]
  // ─── Leopard Pink (5 variants) ───
  "64899367993693": "57893336645967", // 36  [SKU: leopard-pink-36]
  "64899368026461": "57893336678735", // 37  [SKU: leopard-pink-37]
  "64899368059229": "57893336711503", // 38  [SKU: leopard-pink-38]
  "64899368091997": "57893336744271", // 39  [SKU: leopard-pink-39]
  "64899368124765": "57893336777039", // 40  [SKU: leopard-pink-40]
  // ─── Libre (11 variants) ───
  "64899368386909": "57893337235791", // 36  [SKU: libre-36]
  "64899368419677": "57893337268559", // 37.5  [SKU: libre-375]
  "64899368452445": "57893337301327", // 38  [SKU: libre-38]
  "64899368485213": "57893337334095", // 39  [SKU: libre-39]
  "64899368517981": "57893337366863", // 40  [SKU: libre-40]
  "64899368550749": "57893337399631", // 41  [SKU: libre-41]
  "64899368583517": "57893337432399", // 42  [SKU: libre-42]
  "64899368616285": "57893337465167", // 43  [SKU: libre-43]
  "64899368649053": "57893337497935", // 44  [SKU: libre-44]
  "64899368681821": "57893337530703", // 45  [SKU: libre-45]
  "64899368714589": "57893337563471", // 46  [SKU: libre-46]
  // ─── Light Bone (10 variants) ───
  "64899368747357": "57893338939727", // 36  [SKU: light-bone-36]
  "64899368780125": "57893338972495", // 37.5  [SKU: light-bone-375]
  "64899368812893": "57893339005263", // 38  [SKU: light-bone-38]
  "64899368845661": "57893339038031", // 39  [SKU: light-bone-39]
  "64899368878429": "57893339070799", // 40  [SKU: light-bone-40]
  "64899368911197": "57893339103567", // 41  [SKU: light-bone-41]
  "64899368943965": "57893339201871", // 42  [SKU: light-bone-42]
  "64899368976733": "57893339234639", // 43  [SKU: light-bone-43]
  "64899369009501": "57893339267407", // 44  [SKU: light-bone-44]
  "64899369042269": "57893339300175", // 45  [SKU: light-bone-45]
  // ─── London (16 variants) ───
  "64899370058077": "57893243289935", // Blauw  [SKU: london-blauw-36]
  "64899370090845": "57893243322703", // Blauw  [SKU: london-blauw-37]
  "64899370123613": "57893243355471", // Blauw  [SKU: london-blauw-38]
  "64899370156381": "57893243388239", // Blauw  [SKU: london-blauw-39]
  "64899370189149": "57893243421007", // Blauw  [SKU: london-blauw-40]
  "64899370221917": "57893243453775", // Blauw  [SKU: london-blauw-41]
  "64899370254685": "57893243486543", // Blauw  [SKU: london-blauw-42]
  "64899370287453": "57893243519311", // Blauw  [SKU: london-blauw-43]
  "64899370320221": "57893243552079", // Zwart  [SKU: london-zwart-36]
  "64899370352989": "57893243584847", // Zwart  [SKU: london-zwart-37]
  "64899370385757": "57893243617615", // Zwart  [SKU: london-zwart-38]
  "64899370418525": "57893243650383", // Zwart  [SKU: london-zwart-39]
  "64899370451293": "57893243683151", // Zwart  [SKU: london-zwart-40]
  "64899370484061": "57893243715919", // Zwart  [SKU: london-zwart-41]
  "64899370516829": "57893243748687", // Zwart  [SKU: london-zwart-42]
  "64899370549597": "57893243781455", // Zwart  [SKU: london-zwart-43]
  // ─── Los Angeles (13 variants) ───
  "64899370713437": "57893340250447", // 36  [SKU: los-angeles-36]
  "64899370746205": "57893340283215", // 37  [SKU: los-angeles-37]
  "64899370778973": "57893340315983", // 38  [SKU: los-angeles-38]
  "64899370811741": "57893340348751", // 39  [SKU: los-angeles-39]
  "64899370844509": "57893340381519", // 40  [SKU: los-angeles-40]
  "64899370877277": "57893340414287", // 41  [SKU: los-angeles-41]
  "64899370910045": "57893340447055", // 42  [SKU: los-angeles-42]
  "64899370942813": "57893340479823", // 43  [SKU: los-angeles-43]
  "64899370975581": "57893340512591", // 44  [SKU: los-angeles-44]
  "64899371008349": "57893340545359", // 45  [SKU: los-angeles-45]
  "64899371041117": "57893340578127", // 46  [SKU: los-angeles-46]
  "64899371139421": "57893340676431", // 49  [SKU: los-angeles-49]
  "64899371172189": "57893340709199", // 50  [SKU: los-angeles-50]
  // ─── Luxe (14 variants) ───
  "64899371303261": "57893243814223", // Goud  [SKU: luxe-goud-36]
  "64899371336029": "57893243846991", // Goud  [SKU: luxe-goud-37]
  "64899371368797": "57893243879759", // Goud  [SKU: luxe-goud-38]
  "64899371401565": "57893243912527", // Goud  [SKU: luxe-goud-39]
  "64899371434333": "57893243945295", // Goud  [SKU: luxe-goud-40]
  "64899371467101": "57893243978063", // Goud  [SKU: luxe-goud-41]
  "64899371499869": "57893244010831", // Goud  [SKU: luxe-goud-42]
  "64899371532637": "57893244043599", // Silver  [SKU: luxe-silver-36]
  "64899371565405": "57893244076367", // Silver  [SKU: luxe-silver-37]
  "64899371598173": "57893244109135", // Silver  [SKU: luxe-silver-38]
  "64899371630941": "57893244141903", // Silver  [SKU: luxe-silver-39]
  "64899371663709": "57893244174671", // Silver  [SKU: luxe-silver-40]
  "64899371696477": "57893244207439", // Silver  [SKU: luxe-silver-41]
  "64899371729245": "57893244240207", // Silver  [SKU: luxe-silver-42]
  // ─── Luxe Pearl (10 variants) ───
  "64899371925853": "57893340905807", // 36  [SKU: luxe-pearl-36]
  "64899371958621": "57893340938575", // 37.5  [SKU: luxe-pearl-375]
  "64899371991389": "57893340971343", // 38  [SKU: luxe-pearl-38]
  "64899372024157": "57893341004111", // 39  [SKU: luxe-pearl-39]
  "64899372056925": "57893341036879", // 40  [SKU: luxe-pearl-40]
  "64899372089693": "57893341069647", // 41  [SKU: luxe-pearl-41]
  "64899372122461": "57893341102415", // 42  [SKU: luxe-pearl-42]
  "64899372155229": "57893341135183", // 43  [SKU: luxe-pearl-43]
  "64899372187997": "57893341167951", // 44  [SKU: luxe-pearl-44]
  "64899372220765": "57893341200719", // 45  [SKU: luxe-pearl-45]
  // ─── MK (32 variants) ───
  "64899382051165": "57893347852623", // 36  [SKU: mk-36-zwart]
  "64899382083933": "57893347885391", // 36  [SKU: mk-36-abrikoos]
  "64899382116701": "57893347918159", // 36  [SKU: mk-36-bruin]
  "64899382149469": "57893347950927", // 36  [SKU: mk-36-roze]
  "64899382182237": "57893347983695", // 37  [SKU: mk-37-zwart]
  "64899382215005": "57893348016463", // 37  [SKU: mk-37-abrikoos]
  "64899382247773": "57893348049231", // 37  [SKU: mk-37-bruin]
  "64899382280541": "57893348081999", // 37  [SKU: mk-37-roze]
  "64899382313309": "57893348114767", // 38  [SKU: mk-38-zwart]
  "64899382346077": "57893348147535", // 38  [SKU: mk-38-abrikoos]
  "64899382378845": "57893348180303", // 38  [SKU: mk-38-bruin]
  "64899382411613": "57893348213071", // 38  [SKU: mk-38-roze]
  "64899382444381": "57893348245839", // 39  [SKU: mk-39-zwart]
  "64899382477149": "57893348278607", // 39  [SKU: mk-39-abrikoos]
  "64899382509917": "57893348311375", // 39  [SKU: mk-39-bruin]
  "64899382542685": "57893348344143", // 39  [SKU: mk-39-roze]
  "64899382575453": "57893348376911", // 40  [SKU: mk-40-zwart]
  "64899382608221": "57893348409679", // 40  [SKU: mk-40-abrikoos]
  "64899382640989": "57893348442447", // 40  [SKU: mk-40-bruin]
  "64899382673757": "57893348475215", // 40  [SKU: mk-40-roze]
  "64899382706525": "57893348507983", // 41  [SKU: mk-41-zwart]
  "64899382739293": "57893348540751", // 41  [SKU: mk-41-abrikoos]
  "64899382772061": "57893348573519", // 41  [SKU: mk-41-bruin]
  "64899382804829": "57893348606287", // 41  [SKU: mk-41-roze]
  "64899382837597": "57893348639055", // 42  [SKU: mk-42-zwart]
  "64899382870365": "57893348671823", // 42  [SKU: mk-42-abrikoos]
  "64899382903133": "57893348704591", // 42  [SKU: mk-42-bruin]
  "64899382935901": "57893348737359", // 42  [SKU: mk-42-roze]
  "64899382968669": "57893348770127", // 43  [SKU: mk-43-zwart]
  "64899383001437": "57893348802895", // 43  [SKU: mk-43-abrikoos]
  "64899383034205": "57893348835663", // 43  [SKU: mk-43-bruin]
  "64899383066973": "57893348868431", // 43  [SKU: mk-43-roze]
  // ─── Maddy MK (36 variants) ───
  "64899373138269": "57893343101263", // 35  [SKU: maddy-mk-35-zwart]
  "64899373171037": "57893343134031", // 35  [SKU: maddy-mk-35-wit]
  "64899373203805": "57893343166799", // 35  [SKU: maddy-mk-35-bruin]
  "64899373236573": "57893343199567", // 35  [SKU: maddy-mk-35-roze]
  "64899373269341": "57893343232335", // 36  [SKU: maddy-mk-36-zwart]
  "64899373302109": "57893343265103", // 36  [SKU: maddy-mk-36-wit]
  "64899373334877": "57893343297871", // 36  [SKU: maddy-mk-36-bruin]
  "64899373367645": "57893343330639", // 36  [SKU: maddy-mk-36-roze]
  "64899373400413": "57893343363407", // 37  [SKU: maddy-mk-37-zwart]
  "64899373433181": "57893343396175", // 37  [SKU: maddy-mk-37-wit]
  "64899373465949": "57893343428943", // 37  [SKU: maddy-mk-37-bruin]
  "64899373498717": "57893343461711", // 37  [SKU: maddy-mk-37-roze]
  "64899373531485": "57893343494479", // 38  [SKU: maddy-mk-38-zwart]
  "64899373564253": "57893343527247", // 38  [SKU: maddy-mk-38-wit]
  "64899373597021": "57893343560015", // 38  [SKU: maddy-mk-38-bruin]
  "64899373629789": "57893343592783", // 38  [SKU: maddy-mk-38-roze]
  "64899373662557": "57893343625551", // 39  [SKU: maddy-mk-39-zwart]
  "64899373695325": "57893343658319", // 39  [SKU: maddy-mk-39-wit]
  "64899373728093": "57893343691087", // 39  [SKU: maddy-mk-39-bruin]
  "64899373760861": "57893343723855", // 39  [SKU: maddy-mk-39-roze]
  "64899373793629": "57893343756623", // 40  [SKU: maddy-mk-40-zwart]
  "64899373826397": "57893343789391", // 40  [SKU: maddy-mk-40-wit]
  "64899373859165": "57893343822159", // 40  [SKU: maddy-mk-40-bruin]
  "64899373891933": "57893343854927", // 40  [SKU: maddy-mk-40-roze]
  "64899373924701": "57893343887695", // 41  [SKU: maddy-mk-41-zwart]
  "64899373957469": "57893343920463", // 41  [SKU: maddy-mk-41-wit]
  "64899373990237": "57893343953231", // 41  [SKU: maddy-mk-41-bruin]
  "64899374023005": "57893343985999", // 41  [SKU: maddy-mk-41-roze]
  "64899374055773": "57893344018767", // 42  [SKU: maddy-mk-42-zwart]
  "64899374088541": "57893344051535", // 42  [SKU: maddy-mk-42-wit]
  "64899374121309": "57893344084303", // 42  [SKU: maddy-mk-42-bruin]
  "64899374154077": "57893344117071", // 42  [SKU: maddy-mk-42-roze]
  "64899374186845": "57893344149839", // 43  [SKU: maddy-mk-43-zwart]
  "64899374219613": "57893344182607", // 43  [SKU: maddy-mk-43-wit]
  "64899374252381": "57893344215375", // 43  [SKU: maddy-mk-43-bruin]
  "64899374285149": "57893344248143", // 43  [SKU: maddy-mk-43-roze]
  // ─── Manara (10 variants) ───
  "64899374448989": "57893244698959", // Wit  [SKU: manara-wit-35]
  "64899374481757": "57893244731727", // Wit  [SKU: manara-wit-36]
  "64899374514525": "57893244764495", // Wit  [SKU: manara-wit-37]
  "64899374547293": "57893244797263", // Wit  [SKU: manara-wit-38]
  "64899374580061": "57893244830031", // Wit  [SKU: manara-wit-39]
  "64899374612829": "57893244862799", // Wit  [SKU: manara-wit-40]
  "64899374645597": "57893244895567", // Wit  [SKU: manara-wit-41]
  "64899374678365": "57893244928335", // Wit  [SKU: manara-wit-42]
  "64899374711133": "57893244961103", // Wit  [SKU: manara-wit-43]
  "64899374743901": "57893244993871", // Wit  [SKU: manara-wit-44]
  // ─── McQueen (10 variants) ───
  "64899375006045": "57893344379215", // 35  [SKU: mcqueen-35]
  "64899375038813": "57893344411983", // 36  [SKU: mcqueen-36]
  "64899375071581": "57893344444751", // 37  [SKU: mcqueen-37]
  "64899375104349": "57893344477519", // 38  [SKU: mcqueen-38]
  "64899375137117": "57893344510287", // 39  [SKU: mcqueen-39]
  "64899375169885": "57893344543055", // 40  [SKU: mcqueen-40]
  "64899375202653": "57893344346447", // 41  [SKU: mcqueen-41]
  "64899375235421": "57893344575823", // 42  [SKU: mcqueen-42]
  "64899375268189": "57893344608591", // 43  [SKU: mcqueen-43]
  "64899375300957": "57893344641359", // 44  [SKU: mcqueen-44]
  // ─── Medium Olive (13 variants) ───
  "64899376316765": "57893344674127", // 36  [SKU: medium-olive-36]
  "64899376349533": "57893344706895", // 37  [SKU: medium-olive-37]
  "64899376382301": "57893344739663", // 38  [SKU: medium-olive-38]
  "64899376415069": "57893344772431", // 39  [SKU: medium-olive-39]
  "64899376447837": "57893344805199", // 40  [SKU: medium-olive-40]
  "64899376480605": "57893344837967", // 41  [SKU: medium-olive-41]
  "64899376513373": "57893344870735", // 42  [SKU: medium-olive-42]
  "64899376546141": "57893344903503", // 43  [SKU: medium-olive-43]
  "64899376578909": "57893344936271", // 44  [SKU: medium-olive-44]
  "64899376611677": "57893344969039", // 45  [SKU: medium-olive-45]
  "64899376644445": "57893345001807", // 46  [SKU: medium-olive-46]
  "64899376742749": "57893345100111", // 49  [SKU: medium-olive-49]
  "64899376775517": "57893345132879", // 50  [SKU: medium-olive-50]
  // ─── Metallic (10 variants) ───
  "64899377135965": "57893345263951", // 36  [SKU: metallic-gold-36]
  "64899377168733": "57893345296719", // 37  [SKU: metallic-gold-37]
  "64899377201501": "57893345329487", // 38  [SKU: metallic-gold-38]
  "64899377234269": "57893345362255", // 39  [SKU: metallic-gold-39]
  "64899377267037": "57893345395023", // 40  [SKU: metallic-gold-40]
  "64899377299805": "57893345427791", // 41  [SKU: metallic-gold-41]
  "64899377332573": "57893345460559", // 42  [SKU: metallic-gold-42]
  "64899377365341": "57893345493327", // 43  [SKU: metallic-gold-43]
  "64899377398109": "57893345526095", // 44  [SKU: metallic-gold-44]
  "64899377430877": "57893345558863", // 45  [SKU: metallic-gold-45]
  // ─── Metallic Plum (11 variants) ───
  "64899378119005": "57893345624399", // 36  [SKU: metallic-plum-36]
  "64899378151773": "57893345657167", // 37  [SKU: metallic-plum-37]
  "64899378184541": "57893345689935", // 38  [SKU: metallic-plum-38]
  "64899378217309": "57893345722703", // 39  [SKU: metallic-plum-39]
  "64899378250077": "57893345755471", // 40  [SKU: metallic-plum-40]
  "64899378282845": "57893345788239", // 41  [SKU: metallic-plum-41]
  "64899378315613": "57893345821007", // 42  [SKU: metallic-plum-42]
  "64899378348381": "57893345853775", // 43  [SKU: metallic-plum-43]
  "64899378381149": "57893345886543", // 44  [SKU: metallic-plum-44]
  "64899378413917": "57893345919311", // 45  [SKU: metallic-plum-45]
  "64899378446685": "57893345952079", // 46  [SKU: metallic-plum-46]
  // ─── Metallic White (10 variants) ───
  "64899378512221": "57893346148687", // 36  [SKU: metallic-white-36]
  "64899378544989": "57893346181455", // 37.5  [SKU: metallic-white-375]
  "64899378577757": "57893346214223", // 38  [SKU: metallic-white-38]
  "64899378610525": "57893346246991", // 39  [SKU: metallic-white-39]
  "64899378643293": "57893346279759", // 40  [SKU: metallic-white-40]
  "64899378676061": "57893346312527", // 41  [SKU: metallic-white-41]
  "64899378708829": "57893346115919", // 42  [SKU: metallic-white-42]
  "64899378741597": "57893346345295", // 43  [SKU: metallic-white-43]
  "64899378774365": "57893346378063", // 44  [SKU: metallic-white-44]
  "64899378807133": "57893346410831", // 45  [SKU: metallic-white-45]
  // ─── Metropolis (11 variants) ───
  "64899378839901": "57893346574671", // 36  [SKU: metropolis-36]
  "64899378872669": "57893346607439", // 37  [SKU: metropolis-37]
  "64899378905437": "57893346640207", // 38  [SKU: metropolis-38]
  "64899378938205": "57893346672975", // 39  [SKU: metropolis-39]
  "64899378970973": "57893346705743", // 40  [SKU: metropolis-40]
  "64899379003741": "57893346738511", // 41  [SKU: metropolis-41]
  "64899379036509": "57893346771279", // 42  [SKU: metropolis-42]
  "64899379069277": "57893346804047", // 43  [SKU: metropolis-43]
  "64899379102045": "57893346836815", // 44  [SKU: metropolis-44]
  "64899379134813": "57893346869583", // 45  [SKU: metropolis-45]
  "64899379167581": "57893346902351", // 46  [SKU: metropolis-46]
  // ─── Miami Dolphins (10 variants) ───
  "64899379233117": "57893347000655", // 36  [SKU: miami-dolphins-36]
  "64899379265885": "57893347033423", // 37  [SKU: miami-dolphins-37]
  "64899379298653": "57893347066191", // 38  [SKU: miami-dolphins-38]
  "64899379331421": "57893347098959", // 39  [SKU: miami-dolphins-39]
  "64899379364189": "57893347131727", // 40  [SKU: miami-dolphins-40]
  "64899379396957": "57893347164495", // 41  [SKU: miami-dolphins-41]
  "64899379429725": "57893347197263", // 42  [SKU: miami-dolphins-42]
  "64899379462493": "57893347230031", // 43  [SKU: miami-dolphins-43]
  "64899379495261": "57893347262799", // 44  [SKU: miami-dolphins-44]
  "64899379528029": "57893347295567", // 45  [SKU: miami-dolphins-45]
  // ─── Millennium (11 variants) ───
  "64899381297501": "57893347393871", // 36  [SKU: millennium-36]
  "64899381330269": "57893347426639", // 37.5  [SKU: millennium-375]
  "64899381363037": "57893347459407", // 38  [SKU: millennium-38]
  "64899381395805": "57893347492175", // 39  [SKU: millennium-39]
  "64899381428573": "57893347524943", // 40  [SKU: millennium-40]
  "64899381461341": "57893347557711", // 41  [SKU: millennium-41]
  "64899381494109": "57893347590479", // 42  [SKU: millennium-42]
  "64899381526877": "57893347623247", // 43  [SKU: millennium-43]
  "64899381559645": "57893347656015", // 44  [SKU: millennium-44]
  "64899381592413": "57893347688783", // 45  [SKU: millennium-45]
  "64899381625181": "57893347721551", // 46  [SKU: millennium-46]
  // ─── Monaco (22 variants) ───
  "64899383263581": "57893245681999", // Zwart  [SKU: monaco-zwart-39]
  "64899383296349": "57893245714767", // Zwart  [SKU: monaco-zwart-40]
  "64899383329117": "57893245747535", // Zwart  [SKU: monaco-zwart-41]
  "64899383361885": "57893245780303", // Zwart  [SKU: monaco-zwart-41.5]
  "64899383394653": "57893245813071", // Zwart  [SKU: monaco-zwart-42]
  "64899383427421": "57893245845839", // Zwart  [SKU: monaco-zwart-42.5]
  "64899383460189": "57893245878607", // Zwart  [SKU: monaco-zwart-43]
  "64899383492957": "57893245911375", // Zwart  [SKU: monaco-zwart-44]
  "64899383525725": "57893245944143", // Zwart  [SKU: monaco-zwart-45]
  "64899383558493": "57893245976911", // Zwart  [SKU: monaco-zwart-45.5]
  "64899383591261": "57893246009679", // Zwart  [SKU: monaco-zwart-46]
  "64899383656797": "57893246075215", // Wit  [SKU: monaco-wit-39]
  "64899383689565": "57893246107983", // Wit  [SKU: monaco-wit-40]
  "64899383722333": "57893246140751", // Wit  [SKU: monaco-wit-41]
  "64899383755101": "57893246173519", // Wit  [SKU: monaco-wit-41.5]
  "64899383787869": "57893246206287", // Wit  [SKU: monaco-wit-42]
  "64899383820637": "57893246239055", // Wit  [SKU: monaco-wit-42.5]
  "64899383853405": "57893246271823", // Wit  [SKU: monaco-wit-43]
  "64899383886173": "57893246304591", // Wit  [SKU: monaco-wit-44]
  "64899383918941": "57893246337359", // Wit  [SKU: monaco-wit-45]
  "64899383951709": "57893246370127", // Wit  [SKU: monaco-wit-45.5]
  "64899383984477": "57893246402895", // Wit  [SKU: monaco-wit-46]
  // ─── Monaco Blue (11 variants) ───
  "64899384050013": "57893348933967", // 36  [SKU: monaco-blue-36]
  "64899384082781": "57893348966735", // 37  [SKU: monaco-blue-37]
  "64899384115549": "57893348999503", // 38  [SKU: monaco-blue-38]
  "64899384148317": "57893349032271", // 39  [SKU: monaco-blue-39]
  "64899384181085": "57893349065039", // 40  [SKU: monaco-blue-40]
  "64899384213853": "57893349097807", // 41  [SKU: monaco-blue-41]
  "64899384246621": "57893349130575", // 42  [SKU: monaco-blue-42]
  "64899384279389": "57893349163343", // 43  [SKU: monaco-blue-43]
  "64899384312157": "57893349196111", // 44  [SKU: monaco-blue-44]
  "64899384344925": "57893349228879", // 45  [SKU: monaco-blue-45]
  "64899384377693": "57893349261647", // 46  [SKU: monaco-blue-46]
  // ─── NB 530 (30 variants) ───
  "64899394797917": "57893350932815", // Wit Zwart  [SKU: nb-530-36-wit-zwart]
  "64899394830685": "57893351031119", // Wit Zwart  [SKU: nb-530-37-wit-zwart]
  "64899394863453": "57893351129423", // Wit Zwart  [SKU: nb-530-38-wit-zwart]
  "64899394896221": "57893351227727", // Wit Zwart  [SKU: nb-530-39-wit-zwart]
  "64899394928989": "57893351326031", // Wit Zwart  [SKU: nb-530-40-wit-zwart]
  "64899394961757": "57893351424335", // Wit Zwart  [SKU: nb-530-41-wit-zwart]
  "64899394994525": "57893351522639", // Wit Zwart  [SKU: nb-530-42-wit-zwart]
  "64899395027293": "57893351620943", // Wit Zwart  [SKU: nb-530-43-wit-zwart]
  "64899395060061": "57893351719247", // Wit Zwart  [SKU: nb-530-44-wit-zwart]
  "64899395092829": "57893351817551", // Wit Zwart  [SKU: nb-530-45-wit-zwart]
  "64899395125597": "57893350965583", // Wit Blauw  [SKU: nb-530-36-wit-blauw]
  "64899395158365": "57893351063887", // Wit Blauw  [SKU: nb-530-37-wit-blauw]
  "64899395191133": "57893351162191", // Wit Blauw  [SKU: nb-530-38-wit-blauw]
  "64899395223901": "57893351260495", // Wit Blauw  [SKU: nb-530-39-wit-blauw]
  "64899395256669": "57893351358799", // Wit Blauw  [SKU: nb-530-40-wit-blauw]
  "64899395289437": "57893351457103", // Wit Blauw  [SKU: nb-530-41-wit-blauw]
  "64899395322205": "57893351555407", // Wit Blauw  [SKU: nb-530-42-wit-blauw]
  "64899395354973": "57893351653711", // Wit Blauw  [SKU: nb-530-43-wit-blauw]
  "64899395387741": "57893351752015", // Wit Blauw  [SKU: nb-530-44-wit-blauw]
  "64899395420509": "57893351850319", // Wit Blauw  [SKU: nb-530-45-wit-blauw]
  "64899395453277": "57893350998351", // Olifant Grijs  [SKU: nb-530-36-olifant-grijs]
  "64899395486045": "57893351096655", // Olifant Grijs  [SKU: nb-530-37-olifant-grijs]
  "64899395518813": "57893351194959", // Olifant Grijs  [SKU: nb-530-38-olifant-grijs]
  "64899395551581": "57893351293263", // Olifant Grijs  [SKU: nb-530-39-olifant-grijs]
  "64899395584349": "57893351391567", // Olifant Grijs  [SKU: nb-530-40-olifant-grijs]
  "64899395617117": "57893351489871", // Olifant Grijs  [SKU: nb-530-41-olifant-grijs]
  "64899395649885": "57893351588175", // Olifant Grijs  [SKU: nb-530-42-olifant-grijs]
  "64899395682653": "57893351686479", // Olifant Grijs  [SKU: nb-530-43-olifant-grijs]
  "64899395715421": "57893351784783", // Olifant Grijs  [SKU: nb-530-44-olifant-grijs]
  "64899395748189": "57893351883087", // Olifant Grijs  [SKU: nb-530-45-olifant-grijs]
  // ─── NB 530 SJ (10 variants) ───
  "64996716085597": "57957081874767", // 36  [SKU: nb-530-sj-36]
  "64996716118365": "57957081907535", // 37  [SKU: nb-530-sj-37]
  "64996716151133": "57957081940303", // 38  [SKU: nb-530-sj-38]
  "64996716183901": "57957081973071", // 39  [SKU: nb-530-sj-39]
  "64996716216669": "57957082005839", // 40  [SKU: nb-530-sj-40]
  "64996716249437": "57957082038607", // 41  [SKU: nb-530-sj-41]
  "64996716282205": "57957082071375", // 42  [SKU: nb-530-sj-42]
  "64996716314973": "57957082104143", // 43  [SKU: nb-530-sj-43]
  "64996716347741": "57957082136911", // 44  [SKU: nb-530-sj-44]
  "64996716380509": "57957082169679", // 45  [SKU: nb-530-sj-45]
  // ─── NB 574 Beauty Team (9 variants) ───
  "64899255304541": "57893278908751", // 36  [SKU: beauty-team-36]
  "64899255337309": "57893278941519", // 37  [SKU: beauty-team-37]
  "64899255370077": "57893278974287", // 38  [SKU: beauty-team-38]
  "64899255402845": "57893279007055", // 39  [SKU: beauty-team-39]
  "64899255435613": "57893279039823", // 40  [SKU: beauty-team-40]
  "64899255468381": "57893279072591", // 41  [SKU: beauty-team-41]
  "64899255501149": "57893279105359", // 42  [SKU: beauty-team-42]
  "64899255533917": "57893279138127", // 43  [SKU: beauty-team-43]
  "64899255566685": "57893279170895", // 44  [SKU: beauty-team-44]
  // ─── NB 574 Beige Grey Blue (9 variants) ───
  "64899256516957": "57893279367503", // 36  [SKU: beige-grey-blue-36]
  "64899256549725": "57893279400271", // 37  [SKU: beige-grey-blue-37]
  "64899256582493": "57893279433039", // 38  [SKU: beige-grey-blue-38]
  "64899256615261": "57893279465807", // 39  [SKU: beige-grey-blue-39]
  "64899256648029": "57893279498575", // 40  [SKU: beige-grey-blue-40]
  "64899256680797": "57893279531343", // 41  [SKU: beige-grey-blue-41]
  "64899256713565": "57893279564111", // 42  [SKU: beige-grey-blue-42]
  "64899256746333": "57893279596879", // 43  [SKU: beige-grey-blue-43]
  "64899256779101": "57893279629647", // 44  [SKU: beige-grey-blue-44]
  // ─── NB 574 Blue Grey Green (9 variants) ───
  "64899282534749": "57893288182095", // 36  [SKU: blue-grey-green-36]
  "64899282567517": "57893288214863", // 37  [SKU: blue-grey-green-37]
  "64899282600285": "57893288247631", // 38  [SKU: blue-grey-green-38]
  "64899282633053": "57893288280399", // 39  [SKU: blue-grey-green-39]
  "64899282665821": "57893288313167", // 40  [SKU: blue-grey-green-40]
  "64899282698589": "57893288345935", // 41  [SKU: blue-grey-green-41]
  "64899282731357": "57893288378703", // 42  [SKU: blue-grey-green-42]
  "64899282764125": "57893288411471", // 43  [SKU: blue-grey-green-43]
  "64899282796893": "57893288444239", // 44  [SKU: blue-grey-green-44]
  // ─── NB 574 Brown (9 variants) ───
  "64899293577565": "57893295161679", // 36  [SKU: brown-36]
  "64899293610333": "57893295194447", // 37  [SKU: brown-37]
  "64899293643101": "57893295227215", // 38  [SKU: brown-38]
  "64899293675869": "57893295259983", // 39  [SKU: brown-39]
  "64899293708637": "57893295292751", // 40  [SKU: brown-40]
  "64899293741405": "57893295325519", // 41  [SKU: brown-41]
  "64899293774173": "57893295358287", // 42  [SKU: brown-42]
  "64899293806941": "57893295391055", // 43  [SKU: brown-43]
  "64899293839709": "57893295423823", // 44  [SKU: brown-44]
  // ─── NB 574 Charcoal Gold (10 variants) ───
  "64899307143517": "57893299585359", // 36  [SKU: charcoal-gold-36]
  "64899307176285": "57893299618127", // 37  [SKU: charcoal-gold-37]
  "64899307209053": "57893299552591", // 38  [SKU: charcoal-gold-38]
  "64899307241821": "57893299650895", // 39  [SKU: charcoal-gold-39]
  "64899307274589": "57893299683663", // 40  [SKU: charcoal-gold-40]
  "64899307307357": "57893299716431", // 41  [SKU: charcoal-gold-41]
  "64899307340125": "57893299749199", // 42  [SKU: charcoal-gold-42]
  "64899307372893": "57893299781967", // 43  [SKU: charcoal-gold-43]
  "64899307405661": "57893299814735", // 44  [SKU: charcoal-gold-44]
  "64899307438429": "57893299847503", // 45  [SKU: charcoal-gold-45]
  // ─── NB 574 Charcoal Red (10 variants) ───
  "64899307700573": "57893299945807", // 36  [SKU: charcoal-red-36]
  "64899307733341": "57893299978575", // 37  [SKU: charcoal-red-37]
  "64899307766109": "57893300011343", // 38  [SKU: charcoal-red-38]
  "64899307798877": "57893300044111", // 39  [SKU: charcoal-red-39]
  "64899307831645": "57893300076879", // 40  [SKU: charcoal-red-40]
  "64899307864413": "57893300109647", // 41  [SKU: charcoal-red-41]
  "64899307897181": "57893300142415", // 42  [SKU: charcoal-red-42]
  "64899307929949": "57893300175183", // 43  [SKU: charcoal-red-43]
  "64899307962717": "57893300207951", // 44  [SKU: charcoal-red-44]
  "64899307995485": "57893300240719", // 45  [SKU: charcoal-red-45]
  // ─── NB 574 Cream Orange (9 variants) ───
  "64899325755741": "57893307416911", // 36  [SKU: cream-orange-36]
  "64899325788509": "57893307449679", // 37  [SKU: cream-orange-37]
  "64899325821277": "57893307482447", // 38  [SKU: cream-orange-38]
  "64899325854045": "57893307515215", // 39  [SKU: cream-orange-39]
  "64899325886813": "57893307547983", // 40  [SKU: cream-orange-40]
  "64899325919581": "57893307580751", // 41  [SKU: cream-orange-41]
  "64899325952349": "57893307613519", // 42  [SKU: cream-orange-42]
  "64899325985117": "57893307646287", // 43  [SKU: cream-orange-43]
  "64899326017885": "57893307679055", // 44  [SKU: cream-orange-44]
  // ─── NB 574 Dark Blue (5 variants) ───
  "64899329196381": "57893308105039", // 40  [SKU: dark-blue-40]
  "64899329229149": "57893308137807", // 41  [SKU: dark-blue-41]
  "64899329261917": "57893308170575", // 42  [SKU: dark-blue-42]
  "64899329294685": "57893308203343", // 43  [SKU: dark-blue-43]
  "64899329327453": "57893308072271", // 44  [SKU: dark-blue-44]
  // ─── NB 574 Dark Blue White (9 variants) ───
  "64899329589597": "57893309677903", // 36  [SKU: dark-blue-white-36]
  "64899329622365": "57893309710671", // 37  [SKU: dark-blue-white-37]
  "64899329655133": "57893309743439", // 38  [SKU: dark-blue-white-38]
  "64899329687901": "57893309776207", // 39  [SKU: dark-blue-white-39]
  "64899329720669": "57893309808975", // 40  [SKU: dark-blue-white-40]
  "64899329753437": "57893309841743", // 41  [SKU: dark-blue-white-41]
  "64899329786205": "57893309874511", // 42  [SKU: dark-blue-white-42]
  "64899329818973": "57893309907279", // 43  [SKU: dark-blue-white-43]
  "64899329851741": "57893309940047", // 44  [SKU: dark-blue-white-44]
  // ─── NB 574 Dark Grey (10 variants) ───
  "64899330343261": "57893310234959", // 36  [SKU: dark-grey-36]
  "64899330376029": "57893310267727", // 37  [SKU: dark-grey-37]
  "64899330408797": "57893310300495", // 38  [SKU: dark-grey-38]
  "64899330441565": "57893310333263", // 39  [SKU: dark-grey-39]
  "64899330474333": "57893310366031", // 40  [SKU: dark-grey-40]
  "64899330507101": "57893310398799", // 41  [SKU: dark-grey-41]
  "64899330539869": "57893310431567", // 42  [SKU: dark-grey-42]
  "64899330572637": "57893310464335", // 43  [SKU: dark-grey-43]
  "64899330605405": "57893310497103", // 44  [SKU: dark-grey-44]
  "64899330638173": "57893310529871", // 45  [SKU: dark-grey-45]
  // ─── NB 574 Dark Grey Black (9 variants) ───
  "64899330867549": "57893310595407", // 36  [SKU: dark-grey-black-36]
  "64899330900317": "57893310628175", // 37  [SKU: dark-grey-black-37]
  "64899330933085": "57893310660943", // 38  [SKU: dark-grey-black-38]
  "64899330965853": "57893310693711", // 39  [SKU: dark-grey-black-39]
  "64899330998621": "57893310726479", // 40  [SKU: dark-grey-black-40]
  "64899331031389": "57893310759247", // 41  [SKU: dark-grey-black-41]
  "64899331064157": "57893310792015", // 42  [SKU: dark-grey-black-42]
  "64899331096925": "57893310824783", // 43  [SKU: dark-grey-black-43]
  "64899331129693": "57893310857551", // 44  [SKU: dark-grey-black-44]
  // ─── NB 574 Dark Grey Wine Red (9 variants) ───
  "64899331621213": "57893311054159", // 36  [SKU: dark-grey-wine-red-36]
  "64899331653981": "57893311086927", // 37  [SKU: dark-grey-wine-red-37]
  "64899331686749": "57893311119695", // 38  [SKU: dark-grey-wine-red-38]
  "64899331719517": "57893311152463", // 39  [SKU: dark-grey-wine-red-39]
  "64899331752285": "57893311185231", // 40  [SKU: dark-grey-wine-red-40]
  "64899331785053": "57893311217999", // 41  [SKU: dark-grey-wine-red-41]
  "64899331817821": "57893311250767", // 42  [SKU: dark-grey-wine-red-42]
  "64899331850589": "57893311283535", // 43  [SKU: dark-grey-wine-red-43]
  "64899331883357": "57893311316303", // 44  [SKU: dark-grey-wine-red-44]
  // ─── NB 574 Five Rings (10 variants) ───
  "64899342008669": "57893314298191", // 36  [SKU: five-rings-36]
  "64899342041437": "57893314330959", // 37  [SKU: five-rings-37]
  "64899342074205": "57893314363727", // 38  [SKU: five-rings-38]
  "64899342106973": "57893314396495", // 39  [SKU: five-rings-39]
  "64899342139741": "57893314429263", // 40  [SKU: five-rings-40]
  "64899342172509": "57893314462031", // 41  [SKU: five-rings-41]
  "64899342205277": "57893314494799", // 42  [SKU: five-rings-42]
  "64899342238045": "57893314527567", // 43  [SKU: five-rings-43]
  "64899342270813": "57893314560335", // 44  [SKU: five-rings-44]
  "64899342303581": "57893314593103", // 45  [SKU: five-rings-45]
  // ─── NB 574 Flamingo Pink (5 variants) ───
  "64899342401885": "57893314658639", // 36  [SKU: flamingo-pink-36]
  "64899342434653": "57893314691407", // 37  [SKU: flamingo-pink-37]
  "64899342467421": "57893314724175", // 38  [SKU: flamingo-pink-38]
  "64899342500189": "57893314756943", // 39  [SKU: flamingo-pink-39]
  "64899342532957": "57893314789711", // 40  [SKU: flamingo-pink-40]
  // ─── NB 574 Forest Green (10 variants) ───
  "64899345318237": "57893317968207", // 36  [SKU: forest-green-36]
  "64899345351005": "57893318000975", // 37  [SKU: forest-green-37]
  "64899345383773": "57893318033743", // 38  [SKU: forest-green-38]
  "64899345416541": "57893318066511", // 39  [SKU: forest-green-39]
  "64899345449309": "57893318099279", // 40  [SKU: forest-green-40]
  "64899345482077": "57893318132047", // 41  [SKU: forest-green-41]
  "64899345514845": "57893318164815", // 42  [SKU: forest-green-42]
  "64899345547613": "57893318197583", // 43  [SKU: forest-green-43]
  "64899345580381": "57893318230351", // 44  [SKU: forest-green-44]
  "64899345613149": "57893318263119", // 45  [SKU: forest-green-45]
  // ─── NB 574 Grey Pink (5 variants) ───
  "64899354493277": "57893321703759", // 36  [SKU: grey-pink-36]
  "64899354526045": "57893321736527", // 37  [SKU: grey-pink-37]
  "64899354558813": "57893321769295", // 38  [SKU: grey-pink-38]
  "64899354591581": "57893321802063", // 39  [SKU: grey-pink-39]
  "64899354624349": "57893321834831", // 40  [SKU: grey-pink-40]
  // ─── NB 574 Lemon Yellow (10 variants) ───
  "64899367403869": "57893336023375", // 36  [SKU: lemon-yellow-36]
  "64899367436637": "57893336056143", // 37  [SKU: lemon-yellow-37]
  "64899367469405": "57893336088911", // 38  [SKU: lemon-yellow-38]
  "64899367502173": "57893336121679", // 39  [SKU: lemon-yellow-39]
  "64899367534941": "57893336154447", // 40  [SKU: lemon-yellow-40]
  "64899367567709": "57893336187215", // 41  [SKU: lemon-yellow-41]
  "64899367600477": "57893336219983", // 42  [SKU: lemon-yellow-42]
  "64899367633245": "57893336252751", // 43  [SKU: lemon-yellow-43]
  "64899367666013": "57893336285519", // 44  [SKU: lemon-yellow-44]
  "64899367698781": "57893336318287", // 45  [SKU: lemon-yellow-45]
  // ─── NB 574 Light Grey Navy Blue (5 variants) ───
  "64899369468253": "57893339431247", // 40  [SKU: light-grey-navy-blue-40]
  "64899369501021": "57893339464015", // 41  [SKU: light-grey-navy-blue-41]
  "64899369533789": "57893339496783", // 42  [SKU: light-grey-navy-blue-42]
  "64899369566557": "57893339529551", // 43  [SKU: light-grey-navy-blue-43]
  "64899369599325": "57893339562319", // 44  [SKU: light-grey-navy-blue-44]
  // ─── NB 574 Light Rice Grey (5 variants) ───
  "64899369664861": "57893340021071", // 36  [SKU: light-rice-grey-36]
  "64899369697629": "57893340053839", // 37  [SKU: light-rice-grey-37]
  "64899369730397": "57893340086607", // 38  [SKU: light-rice-grey-38]
  "64899369763165": "57893340119375", // 39  [SKU: light-rice-grey-39]
  "64899369795933": "57893340152143", // 40  [SKU: light-rice-grey-40]
  // ─── NB 574 Multicolored (9 variants) ───
  "64899385688413": "57893349327183", // 36  [SKU: multicolored-36]
  "64899385721181": "57893349359951", // 37  [SKU: multicolored-37]
  "64899385753949": "57893349392719", // 38  [SKU: multicolored-38]
  "64899385786717": "57893349425487", // 39  [SKU: multicolored-39]
  "64899385819485": "57893349458255", // 40  [SKU: multicolored-40]
  "64899385852253": "57893349491023", // 41  [SKU: multicolored-41]
  "64899385885021": "57893349523791", // 42  [SKU: multicolored-42]
  "64899385917789": "57893349556559", // 43  [SKU: multicolored-43]
  "64899385950557": "57893349589327", // 44  [SKU: multicolored-44]
  // ─── NB 574 Original Grey (10 variants) ───
  "64899445162333": "57893357486415", // 36  [SKU: original-grey-36]
  "64899445195101": "57893357519183", // 37  [SKU: original-grey-37]
  "64899445227869": "57893357551951", // 38  [SKU: original-grey-38]
  "64899445260637": "57893357584719", // 39  [SKU: original-grey-39]
  "64899445293405": "57893357617487", // 40  [SKU: original-grey-40]
  "64899445326173": "57893357650255", // 41  [SKU: original-grey-41]
  "64899445358941": "57893357683023", // 42  [SKU: original-grey-42]
  "64899445391709": "57893357715791", // 43  [SKU: original-grey-43]
  "64899445424477": "57893357748559", // 44  [SKU: original-grey-44]
  "64899445457245": "57893357781327", // 45  [SKU: original-grey-45]
  // ─── NB 574 Pastel Green Violet (5 variants) ───
  "64899449815389": "57893360206159", // 36  [SKU: pastel-green-violet-36]
  "64899449848157": "57893360238927", // 37  [SKU: pastel-green-violet-37]
  "64899449880925": "57893360271695", // 38  [SKU: pastel-green-violet-38]
  "64899449913693": "57893360304463", // 39  [SKU: pastel-green-violet-39]
  "64899449946461": "57893360337231", // 40  [SKU: pastel-green-violet-40]
  // ─── NB 574 Purple Orchid (5 variants) ───
  "64899456434525": "57893370167631", // 36  [SKU: purple-orchid-36]
  "64899456467293": "57893370200399", // 37  [SKU: purple-orchid-37]
  "64899456500061": "57893370233167", // 38  [SKU: purple-orchid-38]
  "64899456532829": "57893370265935", // 39  [SKU: purple-orchid-39]
  "64899456565597": "57893370298703", // 40  [SKU: purple-orchid-40]
  // ─── NB 574 Red Rabbit (10 variants) ───
  "64899463381341": "57893371380047", // 36  [SKU: red-rabbit-36]
  "64899463414109": "57893371412815", // 37  [SKU: red-rabbit-37]
  "64899463446877": "57893371445583", // 38  [SKU: red-rabbit-38]
  "64899463479645": "57893371478351", // 39  [SKU: red-rabbit-39]
  "64899463512413": "57893371511119", // 40  [SKU: red-rabbit-40]
  "64899463545181": "57893371543887", // 41  [SKU: red-rabbit-41]
  "64899463577949": "57893371576655", // 42  [SKU: red-rabbit-42]
  "64899463610717": "57893371609423", // 43  [SKU: red-rabbit-43]
  "64899463643485": "57893371642191", // 44  [SKU: red-rabbit-44]
  "64899463676253": "57893371674959", // 45  [SKU: red-rabbit-45]
  // ─── NB 574 Seaweed Green (10 variants) ───
  "64899480027485": "57893379178831", // 36  [SKU: seaweed-green-36]
  "64899480060253": "57893379211599", // 37  [SKU: seaweed-green-37]
  "64899480093021": "57893379244367", // 38  [SKU: seaweed-green-38]
  "64899480125789": "57893379277135", // 39  [SKU: seaweed-green-39]
  "64899480158557": "57893379309903", // 40  [SKU: seaweed-green-40]
  "64899480191325": "57893379342671", // 41  [SKU: seaweed-green-41]
  "64899480224093": "57893379375439", // 42  [SKU: seaweed-green-42]
  "64899480256861": "57893379408207", // 43  [SKU: seaweed-green-43]
  "64899480289629": "57893379440975", // 44  [SKU: seaweed-green-44]
  "64899480322397": "57893379473743", // 45  [SKU: seaweed-green-45]
  // ─── NB 574 Ultra Dark Grey (9 variants) ───
  "64899545891165": "57893391434063", // 36  [SKU: ultra-dark-grey-36]
  "64899545923933": "57893391466831", // 37  [SKU: ultra-dark-grey-37]
  "64899545956701": "57893391499599", // 38  [SKU: ultra-dark-grey-38]
  "64899545989469": "57893391532367", // 39  [SKU: ultra-dark-grey-39]
  "64899546022237": "57893391565135", // 40  [SKU: ultra-dark-grey-40]
  "64899546055005": "57893391597903", // 41  [SKU: ultra-dark-grey-41]
  "64899546087773": "57893391630671", // 42  [SKU: ultra-dark-grey-42]
  "64899546120541": "57893391663439", // 43  [SKU: ultra-dark-grey-43]
  "64899546153309": "57893391696207", // 44  [SKU: ultra-dark-grey-44]
  // ─── NB 574 Yuanzu Grey (9 variants) ───
  "64899645342045": "57893406441807", // 36  [SKU: yuanzu-grey-36]
  "64899645374813": "57893406474575", // 37  [SKU: yuanzu-grey-37]
  "64899645407581": "57893406507343", // 38  [SKU: yuanzu-grey-38]
  "64899645440349": "57893406540111", // 39  [SKU: yuanzu-grey-39]
  "64899645473117": "57893406572879", // 40  [SKU: yuanzu-grey-40]
  "64899645505885": "57893406605647", // 41  [SKU: yuanzu-grey-41]
  "64899645538653": "57893406638415", // 42  [SKU: yuanzu-grey-42]
  "64899645571421": "57893406671183", // 43  [SKU: yuanzu-grey-43]
  "64899645604189": "57893406703951", // 44  [SKU: yuanzu-grey-44]
  // ─── NB-530 Classic Metallic (10 variants) ───
  "64996844798301": "57957082333519", // 36  [SKU: nb-530-classic-metallic-36]
  "64996844831069": "57957082366287", // 37  [SKU: nb-530-classic-metallic-37]
  "64996844863837": "57957082399055", // 38  [SKU: nb-530-classic-metallic-38]
  "64996844896605": "57957082431823", // 39  [SKU: nb-530-classic-metallic-39]
  "64996844929373": "57957082464591", // 40  [SKU: nb-530-classic-metallic-40]
  "64996844962141": "57957082497359", // 41  [SKU: nb-530-classic-metallic-41]
  "64996844994909": "57957082530127", // 42  [SKU: nb-530-classic-metallic-42]
  "64996845027677": "57957082562895", // 43  [SKU: nb-530-classic-metallic-43]
  "64996845060445": "57957082595663", // 44  [SKU: nb-530-classic-metallic-44]
  "64996845093213": "57957082628431", // 45  [SKU: nb-530-classic-metallic-45]
  // ─── Navy Crimson (11 variants) ───
  "64899387982173": "57893350015311", // 36  [SKU: navy-crimson-36]
  "64899388014941": "57893350048079", // 37  [SKU: navy-crimson-37]
  "64899388047709": "57893350080847", // 38  [SKU: navy-crimson-38]
  "64899388080477": "57893350113615", // 39  [SKU: navy-crimson-39]
  "64899388113245": "57893350146383", // 40  [SKU: navy-crimson-40]
  "64899388146013": "57893350179151", // 41  [SKU: navy-crimson-41]
  "64899388178781": "57893350211919", // 42  [SKU: navy-crimson-42]
  "64899388211549": "57893350244687", // 43  [SKU: navy-crimson-43]
  "64899388244317": "57893350277455", // 44  [SKU: navy-crimson-44]
  "64899388277085": "57893350310223", // 45  [SKU: navy-crimson-45]
  "64899388309853": "57893350342991", // 46  [SKU: navy-crimson-46]
  // ─── Navy Red (11 variants) ───
  "64899660022109": "57893350506831", // 36  [SKU: navy-red-36]
  "64899660054877": "57893350539599", // 37  [SKU: navy-red-37]
  "64899660087645": "57893350572367", // 38  [SKU: navy-red-38]
  "64899660120413": "57893350605135", // 39  [SKU: navy-red-39]
  "64899660153181": "57893350637903", // 40  [SKU: navy-red-40]
  "64899660185949": "57893350670671", // 41  [SKU: navy-red-41]
  "64899660218717": "57893350703439", // 42  [SKU: navy-red-42]
  "64899660251485": "57893350736207", // 43  [SKU: navy-red-43]
  "64899660284253": "57893350768975", // 44  [SKU: navy-red-44]
  "64899660317021": "57893350474063", // 45  [SKU: navy-red-45]
  "64899660349789": "57893350801743", // 46  [SKU: navy-red-46]
  // ─── Neapolitan (9 variants) ───
  "64899397058909": "57893351948623", // 36  [SKU: neapolitan-36]
  "64899397091677": "57893351981391", // 37.5  [SKU: neapolitan-37.5]
  "64899397124445": "57893352014159", // 38  [SKU: neapolitan-38]
  "64899397157213": "57893352046927", // 39  [SKU: neapolitan-39]
  "64899397189981": "57893352079695", // 40  [SKU: neapolitan-40]
  "64899397222749": "57893352112463", // 41  [SKU: neapolitan-41]
  "64899397255517": "57893352145231", // 42  [SKU: neapolitan-42]
  "64899397288285": "57893352177999", // 43  [SKU: neapolitan-43]
  "64899397321053": "57893352210767", // 44  [SKU: neapolitan-44]
  // ─── Nero (32 variants) ───
  "64899401777501": "57893251547471", // Groen  [SKU: nero-groen-40]
  "64899401810269": "57893251580239", // Groen  [SKU: nero-groen-41]
  "64899401843037": "57893251613007", // Groen  [SKU: nero-groen-42]
  "64899401875805": "57893251645775", // Groen  [SKU: nero-groen-43]
  "64899401908573": "57893251678543", // Groen  [SKU: nero-groen-44]
  "64899401941341": "57893251711311", // Groen  [SKU: nero-groen-45]
  "64899401974109": "57893251744079", // Groen  [SKU: nero-groen-46]
  "64899402072413": "57893251842383", // Groen  [SKU: nero-groen-49]
  "64899402105181": "57893251875151", // Zwart  [SKU: nero-zwart-40]
  "64899402137949": "57893251907919", // Zwart  [SKU: nero-zwart-41]
  "64899402170717": "57893251940687", // Zwart  [SKU: nero-zwart-42]
  "64899402203485": "57893251973455", // Zwart  [SKU: nero-zwart-43]
  "64899402236253": "57893252006223", // Zwart  [SKU: nero-zwart-44]
  "64899402269021": "57893252038991", // Zwart  [SKU: nero-zwart-45]
  "64899402301789": "57893252071759", // Zwart  [SKU: nero-zwart-46]
  "64899402400093": "57893252170063", // Zwart  [SKU: nero-zwart-49]
  "64899402432861": "57893252202831", // Wit  [SKU: nero-wit-40]
  "64899402465629": "57893252268367", // Wit  [SKU: nero-wit-41]
  "64899402498397": "57893252301135", // Wit  [SKU: nero-wit-42]
  "64899402531165": "57893252333903", // Wit  [SKU: nero-wit-43]
  "64899402563933": "57893252366671", // Wit  [SKU: nero-wit-44]
  "64899402596701": "57893252399439", // Wit  [SKU: nero-wit-45]
  "64899402629469": "57893252432207", // Wit  [SKU: nero-wit-46]
  "64899402727773": "57893252530511", // Wit  [SKU: nero-wit-49]
  "64899402760541": "57893252563279", // Bruin  [SKU: nero-bruin-40]
  "64899402793309": "57893252596047", // Bruin  [SKU: nero-bruin-41]
  "64899402826077": "57893252628815", // Bruin  [SKU: nero-bruin-42]
  "64899402858845": "57893252661583", // Bruin  [SKU: nero-bruin-43]
  "64899402891613": "57893252694351", // Bruin  [SKU: nero-bruin-44]
  "64899402924381": "57893252727119", // Bruin  [SKU: nero-bruin-45]
  "64899402957149": "57893252759887", // Bruin  [SKU: nero-bruin-46]
  "64899403055453": "57893252858191", // Bruin  [SKU: nero-bruin-49]
  // ─── New Buinme (18 variants) ───
  "64899403120989": "57893352276303", // 36  [SKU: new-buinme-36-bailan]
  "64899403153757": "57893352309071", // 36  [SKU: new-buinme-36-beige]
  "64899403186525": "57893352341839", // 37  [SKU: new-buinme-37-bailan]
  "64899403219293": "57893352374607", // 37  [SKU: new-buinme-37-beige]
  "64899403252061": "57893352407375", // 38  [SKU: new-buinme-38-bailan]
  "64899403284829": "57893352440143", // 38  [SKU: new-buinme-38-beige]
  "64899403317597": "57893352472911", // 39  [SKU: new-buinme-39-bailan]
  "64899403350365": "57893352505679", // 39  [SKU: new-buinme-39-beige]
  "64899403383133": "57893352538447", // 40  [SKU: new-buinme-40-bailan]
  "64899403415901": "57893352571215", // 40  [SKU: new-buinme-40-beige]
  "64899403448669": "57893352603983", // 41  [SKU: new-buinme-41-bailan]
  "64899403481437": "57893352636751", // 41  [SKU: new-buinme-41-beige]
  "64899403514205": "57893352669519", // 42  [SKU: new-buinme-42-bailan]
  "64899403546973": "57893352702287", // 42  [SKU: new-buinme-42-beige]
  "64899403579741": "57893352735055", // 43  [SKU: new-buinme-43-bailan]
  "64899403612509": "57893352767823", // 43  [SKU: new-buinme-43-beige]
  "64899403645277": "57893352800591", // 44  [SKU: new-buinme-44-bailan]
  "64899403678045": "57893352833359", // 44  [SKU: new-buinme-44-beige]
  // ─── Nieuw Sparren (11 variants) ───
  "64899403841885": "57893354045775", // 36  [SKU: nieuw-sparren-36]
  "64899403874653": "57893354078543", // 37  [SKU: nieuw-sparren-37]
  "64899403907421": "57893354111311", // 38  [SKU: nieuw-sparren-38]
  "64899403940189": "57893354144079", // 39.5  [SKU: nieuw-sparren-395]
  "64899403972957": "57893354176847", // 40  [SKU: nieuw-sparren-40]
  "64899404005725": "57893354209615", // 41  [SKU: nieuw-sparren-41]
  "64899404038493": "57893354242383", // 42  [SKU: nieuw-sparren-42]
  "64899404071261": "57893354275151", // 43  [SKU: nieuw-sparren-43]
  "64899404104029": "57893354307919", // 44  [SKU: nieuw-sparren-44]
  "64899404136797": "57893354340687", // 45  [SKU: nieuw-sparren-45]
  "64899404169565": "57893354373455", // 46.5  [SKU: nieuw-sparren-465]
  // ─── Olympic (11 variants) ───
  "64899404300637": "57893355422031", // 36  [SKU: olympic-36]
  "64899404333405": "57893355454799", // 37.5  [SKU: olympic-375]
  "64899404366173": "57893355487567", // 38  [SKU: olympic-38]
  "64899404398941": "57893355520335", // 39  [SKU: olympic-39]
  "64899404431709": "57893355553103", // 40  [SKU: olympic-40]
  "64899404464477": "57893355585871", // 41  [SKU: olympic-41]
  "64899404497245": "57893355618639", // 42  [SKU: olympic-42]
  "64899404530013": "57893355651407", // 43  [SKU: olympic-43]
  "64899404562781": "57893355684175", // 44  [SKU: olympic-44]
  "64899404595549": "57893355716943", // 45  [SKU: olympic-45]
  "64899404628317": "57893355749711", // 46  [SKU: olympic-46]
  // ─── Orange (10 variants) ───
  "64899423928669": "57893355913551", // 36  [SKU: orange-36]
  "64899423961437": "57893355946319", // 37.5  [SKU: orange-375]
  "64899423994205": "57893355979087", // 38  [SKU: orange-38]
  "64899424026973": "57893356011855", // 39  [SKU: orange-39]
  "64899424059741": "57893356044623", // 40  [SKU: orange-40]
  "64899424092509": "57893356110159", // 41  [SKU: orange-41]
  "64899424125277": "57893356142927", // 42  [SKU: orange-42]
  "64899424158045": "57893356175695", // 43  [SKU: orange-43]
  "64899424190813": "57893356208463", // 44  [SKU: orange-44]
  "64899424223581": "57893356273999", // 45  [SKU: orange-45]
  // ─── Orange Camo (10 variants) ───
  "64899442016605": "57893356929359", // 36  [SKU: orange-camo-36]
  "64899442049373": "57893356962127", // 37.5  [SKU: orange-camo-375]
  "64899442082141": "57893356994895", // 38  [SKU: orange-camo-38]
  "64899442114909": "57893357027663", // 39  [SKU: orange-camo-39]
  "64899442147677": "57893357060431", // 40  [SKU: orange-camo-40]
  "64899442180445": "57893357093199", // 41  [SKU: orange-camo-41]
  "64899442213213": "57893357125967", // 42  [SKU: orange-camo-42]
  "64899442245981": "57893357158735", // 43  [SKU: orange-camo-43]
  "64899442278749": "57893357191503", // 44  [SKU: orange-camo-44]
  "64899442311517": "57893357224271", // 45  [SKU: orange-camo-45]
  // ─── Orenas (24 variants) ───
  "64899444310365": "57893253644623", // Khaki  [SKU: orenas-khaki-39]
  "64899444343133": "57893253677391", // Khaki  [SKU: orenas-khaki-40]
  "64899444375901": "57893253710159", // Khaki  [SKU: orenas-khaki-41]
  "64899444408669": "57893253742927", // Khaki  [SKU: orenas-khaki-42]
  "64899444441437": "57893253775695", // Khaki  [SKU: orenas-khaki-43]
  "64899444474205": "57893253808463", // Khaki  [SKU: orenas-khaki-44]
  "64899444506973": "57893253841231", // Khaki  [SKU: orenas-khaki-45]
  "64899444539741": "57893253873999", // Khaki  [SKU: orenas-khaki-46]
  "64899444572509": "57893253906767", // Zwart  [SKU: orenas-zwart-39]
  "64899444605277": "57893253939535", // Zwart  [SKU: orenas-zwart-40]
  "64899444638045": "57893253972303", // Zwart  [SKU: orenas-zwart-41]
  "64899444670813": "57893254005071", // Zwart  [SKU: orenas-zwart-42]
  "64899444703581": "57893254037839", // Zwart  [SKU: orenas-zwart-43]
  "64899444736349": "57893254070607", // Zwart  [SKU: orenas-zwart-44]
  "64899444769117": "57893254103375", // Zwart  [SKU: orenas-zwart-45]
  "64899444801885": "57893254136143", // Zwart  [SKU: orenas-zwart-46]
  "64899444834653": "57893254168911", // Wit  [SKU: orenas-wit-39]
  "64899444867421": "57893254201679", // Wit  [SKU: orenas-wit-40]
  "64899444900189": "57893254234447", // Wit  [SKU: orenas-wit-41]
  "64899444932957": "57893254267215", // Wit  [SKU: orenas-wit-42]
  "64899444965725": "57893254299983", // Wit  [SKU: orenas-wit-43]
  "64899444998493": "57893254332751", // Wit  [SKU: orenas-wit-44]
  "64899445031261": "57893254365519", // Wit  [SKU: orenas-wit-45]
  "64899445064029": "57893254398287", // Wit  [SKU: orenas-wit-46]
  // ─── Outline Black (10 variants) ───
  "64899445490013": "57893357879631", // 36  [SKU: outline-black-36]
  "64899445522781": "57893357912399", // 37  [SKU: outline-black-37]
  "64899445555549": "57893357945167", // 38  [SKU: outline-black-38]
  "64899445588317": "57893357977935", // 39  [SKU: outline-black-39]
  "64899445621085": "57893358010703", // 40  [SKU: outline-black-40]
  "64899445653853": "57893358043471", // 41  [SKU: outline-black-41]
  "64899445686621": "57893358076239", // 42  [SKU: outline-black-42]
  "64899445719389": "57893358109007", // 43  [SKU: outline-black-43]
  "64899445752157": "57893358141775", // 44  [SKU: outline-black-44]
  "64899445784925": "57893358174543", // 45  [SKU: outline-black-45]
  // ─── Oyster White (11 variants) ───
  "64899446243677": "57893358240079", // 36  [SKU: oyster-white-36]
  "64899446276445": "57893358272847", // 37  [SKU: oyster-white-37]
  "64899446309213": "57893358305615", // 38  [SKU: oyster-white-38]
  "64899446341981": "57893358338383", // 39  [SKU: oyster-white-39]
  "64899446374749": "57893358371151", // 40  [SKU: oyster-white-40]
  "64899446407517": "57893358403919", // 41  [SKU: oyster-white-41]
  "64899446440285": "57893358436687", // 42  [SKU: oyster-white-42]
  "64899446473053": "57893358469455", // 43  [SKU: oyster-white-43]
  "64899446505821": "57893358502223", // 44  [SKU: oyster-white-44]
  "64899446538589": "57893358534991", // 45  [SKU: oyster-white-45]
  "64899446571357": "57893358567759", // 46  [SKU: oyster-white-46]
  // ─── Paddenstoelenbruin (11 variants) ───
  "64899446669661": "57893358666063", // 36  [SKU: paddenstoelenbruin-36]
  "64899446702429": "57893358698831", // 37  [SKU: paddenstoelenbruin-37]
  "64899446735197": "57893358731599", // 38  [SKU: paddenstoelenbruin-38]
  "64899446767965": "57893358764367", // 39.5  [SKU: paddenstoelenbruin-395]
  "64899446800733": "57893358797135", // 40  [SKU: paddenstoelenbruin-40]
  "64899446833501": "57893358829903", // 41.5  [SKU: paddenstoelenbruin-415]
  "64899446866269": "57893358862671", // 42  [SKU: paddenstoelenbruin-42]
  "64899446899037": "57893358895439", // 43  [SKU: paddenstoelenbruin-43]
  "64899446931805": "57893358928207", // 44  [SKU: paddenstoelenbruin-44]
  "64899446964573": "57893358960975", // 45  [SKU: paddenstoelenbruin-45]
  "64899446997341": "57893359026511", // 46.5  [SKU: paddenstoelenbruin-465]
  // ─── Panda (10 variants) ───
  "64899447128413": "57893359157583", // 36  [SKU: panda-36]
  "64899447161181": "57893359190351", // 37  [SKU: panda-37]
  "64899447193949": "57893359223119", // 38  [SKU: panda-38]
  "64899447226717": "57893359255887", // 39  [SKU: panda-39]
  "64899447259485": "57893359288655", // 40  [SKU: panda-40]
  "64899447292253": "57893359321423", // 41  [SKU: panda-41]
  "64899447325021": "57893359354191", // 42  [SKU: panda-42]
  "64899447357789": "57893359386959", // 43  [SKU: panda-43]
  "64899447390557": "57893359419727", // 44  [SKU: panda-44]
  "64899447423325": "57893359452495", // 45  [SKU: panda-45]
  // ─── Paris Saint (11 variants) ───
  "64899447488861": "57893359518031", // 36  [SKU: paris-saint-36]
  "64899447521629": "57893359550799", // 37.5  [SKU: paris-saint-375]
  "64899447554397": "57893359583567", // 38  [SKU: paris-saint-38]
  "64899447587165": "57893359616335", // 39  [SKU: paris-saint-39]
  "64899447619933": "57893359649103", // 40  [SKU: paris-saint-40]
  "64899447652701": "57893359681871", // 41  [SKU: paris-saint-41]
  "64899447685469": "57893359714639", // 42  [SKU: paris-saint-42]
  "64899447718237": "57893359747407", // 43  [SKU: paris-saint-43]
  "64899447751005": "57893359780175", // 44  [SKU: paris-saint-44]
  "64899447783773": "57893359812943", // 45  [SKU: paris-saint-45]
  "64899447816541": "57893359845711", // 46  [SKU: paris-saint-46]
  // ─── Persian Violet (11 variants) ───
  "64899450077533": "57893360468303", // 36  [SKU: persian-violet-36]
  "64899450110301": "57893360501071", // 37.5  [SKU: persian-violet-375]
  "64899450143069": "57893360533839", // 38  [SKU: persian-violet-38]
  "64899450175837": "57893360566607", // 39  [SKU: persian-violet-39]
  "64899450208605": "57893360599375", // 40  [SKU: persian-violet-40]
  "64899450241373": "57893360632143", // 41  [SKU: persian-violet-41]
  "64899450274141": "57893360664911", // 42  [SKU: persian-violet-42]
  "64899450306909": "57893360697679", // 43  [SKU: persian-violet-43]
  "64899450339677": "57893360730447", // 44  [SKU: persian-violet-44]
  "64899450372445": "57893360763215", // 45  [SKU: persian-violet-45]
  "64899450405213": "57893360795983", // 46  [SKU: persian-violet-46]
  // ─── Phantom Black (10 variants) ───
  "64899450536285": "57893361647951", // 36  [SKU: phantom-black-36]
  "64899450569053": "57893361680719", // 37  [SKU: phantom-black-37]
  "64899450601821": "57893361713487", // 38  [SKU: phantom-black-38]
  "64899450634589": "57893361746255", // 39  [SKU: phantom-black-39]
  "64899450667357": "57893361779023", // 40  [SKU: phantom-black-40]
  "64899450700125": "57893361811791", // 41  [SKU: phantom-black-41]
  "64899450732893": "57893361844559", // 42  [SKU: phantom-black-42]
  "64899450765661": "57893361877327", // 43  [SKU: phantom-black-43]
  "64899450798429": "57893361910095", // 44  [SKU: phantom-black-44]
  "64899450831197": "57893361942863", // 45  [SKU: phantom-black-45]
  // ─── Phantom/Rijk Eikenhout (11 variants) ───
  "64899450929501": "57893362008399", // 36  [SKU: phantomrijk-eikenhout-36]
  "64899450962269": "57893362041167", // 37  [SKU: phantomrijk-eikenhout-37]
  "64899450995037": "57893362073935", // 38  [SKU: phantomrijk-eikenhout-38]
  "64899451027805": "57893362106703", // 39.5  [SKU: phantomrijk-eikenhout-395]
  "64899451060573": "57893362139471", // 40  [SKU: phantomrijk-eikenhout-40]
  "64899451093341": "57893362172239", // 41.5  [SKU: phantomrijk-eikenhout-415]
  "64899451126109": "57893362205007", // 42  [SKU: phantomrijk-eikenhout-42]
  "64899451158877": "57893362237775", // 43  [SKU: phantomrijk-eikenhout-43]
  "64899451191645": "57893362270543", // 44  [SKU: phantomrijk-eikenhout-44]
  "64899451224413": "57893362303311", // 45  [SKU: phantomrijk-eikenhout-45]
  "64899451257181": "57893362336079", // 46.5  [SKU: phantomrijk-eikenhout-465]
  // ─── Photon Dust (4 variants) ───
  "64899660874077": "57893362401615", // 42  [SKU: photon-dust-42]
  "64899660906845": "57893362434383", // 43  [SKU: photon-dust-43]
  "64899660939613": "57893362467151", // 44  [SKU: photon-dust-44]
  "64899660972381": "57893362499919", // 45  [SKU: photon-dust-45]
  // ─── Piano (11 variants) ───
  "64899451453789": "57893362532687", // 36  [SKU: piano-36]
  "64899451486557": "57893362565455", // 37  [SKU: piano-37]
  "64899451519325": "57893362598223", // 38  [SKU: piano-38]
  "64899451552093": "57893362630991", // 39  [SKU: piano-39]
  "64899451584861": "57893362663759", // 40  [SKU: piano-40]
  "64899451617629": "57893362696527", // 41  [SKU: piano-41]
  "64899451650397": "57893362729295", // 42  [SKU: piano-42]
  "64899451683165": "57893362762063", // 43  [SKU: piano-43]
  "64899451715933": "57893362794831", // 44  [SKU: piano-44]
  "64899451748701": "57893362827599", // 45  [SKU: piano-45]
  "64899451781469": "57893362860367", // 46  [SKU: piano-46]
  // ─── Piquant Orange (11 variants) ───
  "64899451879773": "57893362925903", // 36  [SKU: piquant-orange-36]
  "64899451912541": "57893362958671", // 37  [SKU: piquant-orange-37]
  "64899451945309": "57893362991439", // 38  [SKU: piquant-orange-38]
  "64899451978077": "57893363024207", // 39  [SKU: piquant-orange-39]
  "64899452010845": "57893363056975", // 40  [SKU: piquant-orange-40]
  "64899452043613": "57893363089743", // 41  [SKU: piquant-orange-41]
  "64899452076381": "57893363122511", // 42  [SKU: piquant-orange-42]
  "64899452109149": "57893363155279", // 43  [SKU: piquant-orange-43]
  "64899452141917": "57893363188047", // 44  [SKU: piquant-orange-44]
  "64899452174685": "57893363220815", // 45  [SKU: piquant-orange-45]
  "64899452207453": "57893363253583", // 46  [SKU: piquant-orange-46]
  // ─── Platinum Tint (10 variants) ───
  "64899452436829": "57893363319119", // 36  [SKU: platinum-tint-36]
  "64899452469597": "57893363351887", // 37.5  [SKU: platinum-tint-375]
  "64899452502365": "57893363384655", // 38  [SKU: platinum-tint-38]
  "64899452535133": "57893363417423", // 39  [SKU: platinum-tint-39]
  "64899452567901": "57893363450191", // 40  [SKU: platinum-tint-40]
  "64899452600669": "57893363482959", // 41  [SKU: platinum-tint-41]
  "64899452633437": "57893363515727", // 42  [SKU: platinum-tint-42]
  "64899452666205": "57893363548495", // 43  [SKU: platinum-tint-43]
  "64899452698973": "57893363581263", // 44  [SKU: platinum-tint-44]
  "64899452731741": "57893363614031", // 45  [SKU: platinum-tint-45]
  // ─── Politics (11 variants) ───
  "64899454107997": "57893363745103", // 36  [SKU: politics-36]
  "64899454140765": "57893363777871", // 37  [SKU: politics-37]
  "64899454173533": "57893363810639", // 38  [SKU: politics-38]
  "64899454239069": "57893363843407", // 39  [SKU: politics-39]
  "64899454271837": "57893363876175", // 40  [SKU: politics-40]
  "64899454304605": "57893363908943", // 41  [SKU: politics-41]
  "64899454337373": "57893363941711", // 42  [SKU: politics-42]
  "64899454370141": "57893363974479", // 43  [SKU: politics-43]
  "64899454402909": "57893364007247", // 44  [SKU: politics-44]
  "64899454435677": "57893364040015", // 45  [SKU: politics-45]
  "64899454468445": "57893364072783", // 46  [SKU: politics-46]
  // ─── Powercourt Black (10 variants) ───
  "64899661103453": "57893365252431", // 36  [SKU: powercourt-black-36]
  "64899661136221": "57893365285199", // 37  [SKU: powercourt-black-37]
  "64899661168989": "57893365317967", // 38  [SKU: powercourt-black-38]
  "64899661201757": "57893365350735", // 39  [SKU: powercourt-black-39]
  "64899661234525": "57893365383503", // 40  [SKU: powercourt-black-40]
  "64899661267293": "57893365449039", // 41  [SKU: powercourt-black-41]
  "64899661300061": "57893365481807", // 42  [SKU: powercourt-black-42]
  "64899661332829": "57893365514575", // 43  [SKU: powercourt-black-43]
  "64899661365597": "57893365547343", // 44  [SKU: powercourt-black-44]
  "64899661398365": "57893365580111", // 45  [SKU: powercourt-black-45]
  // ─── Powercourt White (10 variants) ───
  "64899661627741": "57893365743951", // 36  [SKU: powercourt-white-36]
  "64899661660509": "57893365776719", // 37  [SKU: powercourt-white-37]
  "64899661693277": "57893365809487", // 38  [SKU: powercourt-white-38]
  "64899661726045": "57893365842255", // 39  [SKU: powercourt-white-39]
  "64899661758813": "57893365875023", // 40  [SKU: powercourt-white-40]
  "64899661791581": "57893365907791", // 41  [SKU: powercourt-white-41]
  "64899661824349": "57893365940559", // 42  [SKU: powercourt-white-42]
  "64899661857117": "57893365973327", // 43  [SKU: powercourt-white-43]
  "64899661889885": "57893366006095", // 44  [SKU: powercourt-white-44]
  "64899661922653": "57893366038863", // 45  [SKU: powercourt-white-45]
  // ─── Prisma Paars Levendige Lente (7 variants) ───
  "64899454796125": "57893367808335", // 36  [SKU: prisma-paars-levendige-lente-36]
  "64899454828893": "57893367841103", // 37  [SKU: prisma-paars-levendige-lente-37]
  "64899454861661": "57893367873871", // 38  [SKU: prisma-paars-levendige-lente-38]
  "64899454894429": "57893367906639", // 39.5  [SKU: prisma-paars-levendige-lente-395]
  "64899454927197": "57893367939407", // 40  [SKU: prisma-paars-levendige-lente-40]
  "64899454959965": "57893367972175", // 41.5  [SKU: prisma-paars-levendige-lente-415]
  "64899454992733": "57893368004943", // 42  [SKU: prisma-paars-levendige-lente-42]
  // ─── Pure Gold (11 variants) ───
  "64899455189341": "57893368037711", // 36  [SKU: pure-gold-36]
  "64899455222109": "57893368070479", // 37  [SKU: pure-gold-37]
  "64899455254877": "57893368103247", // 38  [SKU: pure-gold-38]
  "64899455287645": "57893368136015", // 39  [SKU: pure-gold-39]
  "64899455320413": "57893368168783", // 40  [SKU: pure-gold-40]
  "64899455353181": "57893368201551", // 41  [SKU: pure-gold-41]
  "64899455385949": "57893368234319", // 42  [SKU: pure-gold-42]
  "64899455418717": "57893368267087", // 43  [SKU: pure-gold-43]
  "64899455451485": "57893368299855", // 44  [SKU: pure-gold-44]
  "64899455484253": "57893368332623", // 45  [SKU: pure-gold-45]
  "64899455517021": "57893368365391", // 46  [SKU: pure-gold-46]
  // ─── Pure Platinum (11 variants) ───
  "64899455811933": "57893369741647", // 36  [SKU: pure-platinum-36]
  "64899455844701": "57893369774415", // 37.5  [SKU: pure-platinum-375]
  "64899455877469": "57893369807183", // 38  [SKU: pure-platinum-38]
  "64899455910237": "57893369839951", // 39  [SKU: pure-platinum-39]
  "64899455943005": "57893369872719", // 40  [SKU: pure-platinum-40]
  "64899455975773": "57893369905487", // 41  [SKU: pure-platinum-41]
  "64899456008541": "57893369938255", // 42  [SKU: pure-platinum-42]
  "64899456041309": "57893369971023", // 43  [SKU: pure-platinum-43]
  "64899456074077": "57893370003791", // 44  [SKU: pure-platinum-44]
  "64899456106845": "57893370036559", // 45  [SKU: pure-platinum-45]
  "64899456139613": "57893370069327", // 46  [SKU: pure-platinum-46]
  // ─── Rainbow (11 variants) ───
  "64899456598365": "57893349622095", // 36  [SKU: multikleur-36]
  "64899456631133": "57893349654863", // 37  [SKU: multikleur-37]
  "64899456663901": "57893349687631", // 38  [SKU: multikleur-38]
  "64899456696669": "57893349720399", // 39.5  [SKU: multikleur-395]
  "64899456729437": "57893349753167", // 40  [SKU: multikleur-40]
  "64899456762205": "57893349785935", // 41.5  [SKU: multikleur-415]
  "64899456794973": "57893349818703", // 42  [SKU: multikleur-42]
  "64899456827741": "57893349851471", // 43  [SKU: multikleur-43]
  "64899456860509": "57893349884239", // 44  [SKU: multikleur-44]
  "64899456893277": "57893349917007", // 45  [SKU: multikleur-45]
  "64899456926045": "57893349949775", // 46.5  [SKU: multikleur-465]
  // ─── Regal Blue (11 variants) ───
  "64899463741789": "57893371740495", // 36  [SKU: regal-blue-36]
  "64899463774557": "57893371773263", // 37.5  [SKU: regal-blue-375]
  "64899463807325": "57893371806031", // 38  [SKU: regal-blue-38]
  "64899463840093": "57893371838799", // 39  [SKU: regal-blue-39]
  "64899463872861": "57893371871567", // 40  [SKU: regal-blue-40]
  "64899463905629": "57893371904335", // 41  [SKU: regal-blue-41]
  "64899463938397": "57893371937103", // 42  [SKU: regal-blue-42]
  "64899463971165": "57893371969871", // 43  [SKU: regal-blue-43]
  "64899464003933": "57893372002639", // 44  [SKU: regal-blue-44]
  "64899464036701": "57893372035407", // 45  [SKU: regal-blue-45]
  "64899464069469": "57893372068175", // 46  [SKU: regal-blue-46]
  // ─── Regenwolk Quarry Blauw (11 variants) ───
  "64899465249117": "57893372166479", // 36  [SKU: regenwolk-quarry-blauw-36]
  "64899465281885": "57893372199247", // 37  [SKU: regenwolk-quarry-blauw-37]
  "64899465314653": "57893372232015", // 38  [SKU: regenwolk-quarry-blauw-38]
  "64899465347421": "57893372264783", // 39.5  [SKU: regenwolk-quarry-blauw-395]
  "64899465380189": "57893372297551", // 40  [SKU: regenwolk-quarry-blauw-40]
  "64899465412957": "57893372330319", // 41.5  [SKU: regenwolk-quarry-blauw-415]
  "64899465445725": "57893372363087", // 42  [SKU: regenwolk-quarry-blauw-42]
  "64899465478493": "57893372395855", // 43  [SKU: regenwolk-quarry-blauw-43]
  "64899465511261": "57893372428623", // 44  [SKU: regenwolk-quarry-blauw-44]
  "64899465544029": "57893372461391", // 45  [SKU: regenwolk-quarry-blauw-45]
  "64899465576797": "57893372494159", // 46.5  [SKU: regenwolk-quarry-blauw-465]
  // ─── Retrona (9 variants) ───
  "64899465675101": "57893254758735", // 35  [SKU: retrona-35]
  "64899465707869": "57893254791503", // 36  [SKU: retrona-36]
  "64899465740637": "57893254824271", // 37  [SKU: retrona-37]
  "64899465773405": "57893254857039", // 38  [SKU: retrona-38]
  "64899465806173": "57893254889807", // 39  [SKU: retrona-39]
  "64899465838941": "57893254922575", // 40  [SKU: retrona-40]
  "64899465871709": "57893254955343", // 41  [SKU: retrona-41]
  "64899465904477": "57893254988111", // 42  [SKU: retrona-42]
  "64899465937245": "57893255020879", // 43  [SKU: retrona-43]
  // ─── Reverse Panda (10 variants) ───
  "64899466264925": "57893372559695", // 36  [SKU: reverse-panda-36]
  "64899466297693": "57893372592463", // 37  [SKU: reverse-panda-37]
  "64899466330461": "57893372625231", // 38  [SKU: reverse-panda-38]
  "64899466363229": "57893372657999", // 39  [SKU: reverse-panda-39]
  "64899466395997": "57893372690767", // 40  [SKU: reverse-panda-40]
  "64899466428765": "57893372723535", // 41  [SKU: reverse-panda-41]
  "64899466461533": "57893372756303", // 42  [SKU: reverse-panda-42]
  "64899466494301": "57893372789071", // 43  [SKU: reverse-panda-43]
  "64899466527069": "57893372821839", // 44  [SKU: reverse-panda-44]
  "64899466559837": "57893372854607", // 45  [SKU: reverse-panda-45]
  // ─── Rose Gold (10 variants) ───
  "64899466658141": "57893373772111", // 36  [SKU: rose-gold-36]
  "64899466690909": "57893373804879", // 37  [SKU: rose-gold-37]
  "64899466723677": "57893373837647", // 38  [SKU: rose-gold-38]
  "64899466756445": "57893373870415", // 39  [SKU: rose-gold-39]
  "64899466789213": "57893373903183", // 40  [SKU: rose-gold-40]
  "64899466821981": "57893373935951", // 41  [SKU: rose-gold-41]
  "64899466854749": "57893373968719", // 42  [SKU: rose-gold-42]
  "64899466887517": "57893374001487", // 43  [SKU: rose-gold-43]
  "64899466920285": "57893374034255", // 44  [SKU: rose-gold-44]
  "64899466953053": "57893374067023", // 45  [SKU: rose-gold-45]
  // ─── Rotterdam (11 variants) ───
  "64899467247965": "57893374099791", // 36  [SKU: rotterdam-36]
  "64899467280733": "57893374132559", // 37.5  [SKU: rotterdam-375]
  "64899467313501": "57893374165327", // 38  [SKU: rotterdam-38]
  "64899467346269": "57893374198095", // 39  [SKU: rotterdam-39]
  "64899467379037": "57893374230863", // 40  [SKU: rotterdam-40]
  "64899467411805": "57893374263631", // 41  [SKU: rotterdam-41]
  "64899467444573": "57893374296399", // 42  [SKU: rotterdam-42]
  "64899467477341": "57893374329167", // 43  [SKU: rotterdam-43]
  "64899467510109": "57893374361935", // 44  [SKU: rotterdam-44]
  "64899467542877": "57893374394703", // 45  [SKU: rotterdam-45]
  "64899467575645": "57893374427471", // 46  [SKU: rotterdam-46]
  // ─── Royal (6 variants) ───
  "64899468099933": "57893374918991", // 41  [SKU: royal-41]
  "64899468132701": "57893374951759", // 42  [SKU: royal-42]
  "64899468165469": "57893374984527", // 43  [SKU: royal-43]
  "64899468198237": "57893375017295", // 44  [SKU: royal-44]
  "64899468231005": "57893375050063", // 45  [SKU: royal-45]
  "64899468263773": "57893375082831", // 46  [SKU: royal-46]
  // ─── Running Black (11 variants) ───
  "64899468329309": "57893375443279", // 36  [SKU: running-black-36]
  "64899468362077": "57893375476047", // 37.5  [SKU: running-black-37.5]
  "64899468394845": "57893375508815", // 38  [SKU: running-black-38]
  "64899468427613": "57893375541583", // 39  [SKU: running-black-39]
  "64899468460381": "57893375574351", // 40  [SKU: running-black-40]
  "64899468493149": "57893375607119", // 41  [SKU: running-black-41]
  "64899468525917": "57893375639887", // 42  [SKU: running-black-42]
  "64899468558685": "57893375672655", // 43  [SKU: running-black-43]
  "64899468591453": "57893375705423", // 44  [SKU: running-black-44]
  "64899468624221": "57893375738191", // 45  [SKU: running-black-45]
  "64899468656989": "57893375770959", // 46  [SKU: running-black-46]
  // ─── Running White (11 variants) ───
  "64899469246813": "57893375934799", // 36  [SKU: running-white-36]
  "64899469279581": "57893375967567", // 37.5  [SKU: running-white-37.5]
  "64899469312349": "57893376000335", // 38  [SKU: running-white-38]
  "64899469345117": "57893376033103", // 39  [SKU: running-white-39]
  "64899469377885": "57893376065871", // 40  [SKU: running-white-40]
  "64899469410653": "57893376098639", // 41  [SKU: running-white-41]
  "64899469443421": "57893376131407", // 42  [SKU: running-white-42]
  "64899469476189": "57893376164175", // 43  [SKU: running-white-43]
  "64899469508957": "57893376196943", // 44  [SKU: running-white-44]
  "64899469541725": "57893376229711", // 45  [SKU: running-white-45]
  "64899469574493": "57893376262479", // 46  [SKU: running-white-46]
  // ─── Rust Pink (10 variants) ───
  "64899469672797": "57893376524623", // 36  [SKU: rust-pink-36]
  "64899469705565": "57893376557391", // 37  [SKU: rust-pink-37]
  "64899469738333": "57893376590159", // 38  [SKU: rust-pink-38]
  "64899469771101": "57893376622927", // 39  [SKU: rust-pink-39]
  "64899469803869": "57893376655695", // 40  [SKU: rust-pink-40]
  "64899469836637": "57893376688463", // 41  [SKU: rust-pink-41]
  "64899469869405": "57893376721231", // 42  [SKU: rust-pink-42]
  "64899469902173": "57893376753999", // 43  [SKU: rust-pink-43]
  "64899469934941": "57893376786767", // 44  [SKU: rust-pink-44]
  "64899469967709": "57893376819535", // 45  [SKU: rust-pink-45]
  // ─── Sail (10 variants) ───
  "64899471638877": "57893376852303", // 36  [SKU: sail-36]
  "64899471671645": "57893376885071", // 37  [SKU: sail-37]
  "64899471704413": "57893376917839", // 38  [SKU: sail-38]
  "64899471737181": "57893376950607", // 39  [SKU: sail-39]
  "64899471769949": "57893376983375", // 40  [SKU: sail-40]
  "64899471802717": "57893377016143", // 41  [SKU: sail-41]
  "64899471835485": "57893377048911", // 42  [SKU: sail-42]
  "64899471868253": "57893377081679", // 43  [SKU: sail-43]
  "64899471901021": "57893377114447", // 44  [SKU: sail-44]
  "64899471933789": "57893377147215", // 45  [SKU: sail-45]
  // ─── Sail Malachite (10 variants) ───
  "64899472261469": "57893377245519", // 36  [SKU: sail-malachite-36]
  "64899472294237": "57893377278287", // 37  [SKU: sail-malachite-37]
  "64899472327005": "57893377311055", // 38  [SKU: sail-malachite-38]
  "64899472359773": "57893377343823", // 39  [SKU: sail-malachite-39]
  "64899472392541": "57893377376591", // 40  [SKU: sail-malachite-40]
  "64899472425309": "57893377409359", // 41  [SKU: sail-malachite-41]
  "64899472458077": "57893377442127", // 42  [SKU: sail-malachite-42]
  "64899472490845": "57893377474895", // 43  [SKU: sail-malachite-43]
  "64899472523613": "57893377507663", // 44  [SKU: sail-malachite-44]
  "64899472556381": "57893377540431", // 45  [SKU: sail-malachite-45]
  // ─── Sail Red (10 variants) ───
  "64899472589149": "57893377605967", // 36  [SKU: sail-red-36]
  "64899472621917": "57893377638735", // 37.5  [SKU: sail-red-375]
  "64899472654685": "57893377671503", // 38  [SKU: sail-red-38]
  "64899472687453": "57893377704271", // 39  [SKU: sail-red-39]
  "64899472720221": "57893377737039", // 40  [SKU: sail-red-40]
  "64899472752989": "57893377769807", // 41  [SKU: sail-red-41]
  "64899472785757": "57893377802575", // 42  [SKU: sail-red-42]
  "64899472818525": "57893377835343", // 43  [SKU: sail-red-43]
  "64899472851293": "57893377868111", // 44  [SKU: sail-red-44]
  "64899472884061": "57893377900879", // 45  [SKU: sail-red-45]
  // ─── Sand Grey (7 variants) ───
  "64899473801565": "57893378031951", // 40  [SKU: sand-grey-40]
  "64899473834333": "57893378064719", // 41  [SKU: sand-grey-41]
  "64899473867101": "57893378097487", // 42  [SKU: sand-grey-42]
  "64899473899869": "57893378130255", // 43  [SKU: sand-grey-43]
  "64899473932637": "57893378163023", // 44  [SKU: sand-grey-44]
  "64899473965405": "57893378195791", // 45  [SKU: sand-grey-45]
  "64899473998173": "57893378228559", // 46  [SKU: sand-grey-46]
  // ─── Schaduwgrijs Castlerock (11 variants) ───
  "64899475439965": "57893378326863", // 36  [SKU: schaduwgrijs-castlerock-36]
  "64899475472733": "57893378359631", // 37  [SKU: schaduwgrijs-castlerock-37]
  "64899475505501": "57893378392399", // 38  [SKU: schaduwgrijs-castlerock-38]
  "64899475538269": "57893378425167", // 39.5  [SKU: schaduwgrijs-castlerock-395]
  "64899475571037": "57893378457935", // 40  [SKU: schaduwgrijs-castlerock-40]
  "64899475603805": "57893378490703", // 41.5  [SKU: schaduwgrijs-castlerock-415]
  "64899475636573": "57893378523471", // 42  [SKU: schaduwgrijs-castlerock-42]
  "64899475669341": "57893378556239", // 43  [SKU: schaduwgrijs-castlerock-43]
  "64899475702109": "57893378589007", // 44  [SKU: schaduwgrijs-castlerock-44]
  "64899475734877": "57893378621775", // 45  [SKU: schaduwgrijs-castlerock-45]
  "64899475767645": "57893378654543", // 46.5  [SKU: schaduwgrijs-castlerock-465]
  // ─── Sea Salt (11 variants) ───
  "64899477832029": "57893378785615", // 36  [SKU: sea-salt-36]
  "64899477864797": "57893378818383", // 37  [SKU: sea-salt-37]
  "64899477897565": "57893378851151", // 38  [SKU: sea-salt-38]
  "64899477930333": "57893378883919", // 39.5  [SKU: sea-salt-395]
  "64899477963101": "57893378916687", // 40  [SKU: sea-salt-40]
  "64899477995869": "57893378949455", // 41.5  [SKU: sea-salt-415]
  "64899478028637": "57893378982223", // 42  [SKU: sea-salt-42]
  "64899478061405": "57893379014991", // 43  [SKU: sea-salt-43]
  "64899478094173": "57893379047759", // 44  [SKU: sea-salt-44]
  "64899478126941": "57893379080527", // 45  [SKU: sea-salt-45]
  "64899478159709": "57893379113295", // 46.5  [SKU: sea-salt-465]
  // ─── Sikteq (24 variants) ───
  "64899485892957": "57893257642319", // Zwart  [SKU: sikteq-zwart-39]
  "64899485925725": "57893257675087", // Zwart  [SKU: sikteq-zwart-40]
  "64899485958493": "57893257707855", // Zwart  [SKU: sikteq-zwart-41]
  "64899485991261": "57893257740623", // Zwart  [SKU: sikteq-zwart-42]
  "64899486024029": "57893257773391", // Zwart  [SKU: sikteq-zwart-43]
  "64899486056797": "57893257806159", // Zwart  [SKU: sikteq-zwart-44]
  "64899486089565": "57893257838927", // Zwart  [SKU: sikteq-zwart-45]
  "64899486122333": "57893257871695", // Zwart  [SKU: sikteq-zwart-46]
  "64899486155101": "57893257904463", // Geel  [SKU: sikteq-geel-39]
  "64899486187869": "57893257937231", // Geel  [SKU: sikteq-geel-40]
  "64899486220637": "57893257969999", // Geel  [SKU: sikteq-geel-41]
  "64899486253405": "57893258002767", // Geel  [SKU: sikteq-geel-42]
  "64899486286173": "57893258035535", // Geel  [SKU: sikteq-geel-43]
  "64899486318941": "57893258068303", // Geel  [SKU: sikteq-geel-44]
  "64899486351709": "57893258101071", // Geel  [SKU: sikteq-geel-45]
  "64899486384477": "57893258133839", // Geel  [SKU: sikteq-geel-46]
  "64899486417245": "57893258166607", // Grijs  [SKU: sikteq-grijs-39]
  "64899486450013": "57893258199375", // Grijs  [SKU: sikteq-grijs-40]
  "64899486482781": "57893258232143", // Grijs  [SKU: sikteq-grijs-41]
  "64899486515549": "57893258264911", // Grijs  [SKU: sikteq-grijs-42]
  "64899486548317": "57893258297679", // Grijs  [SKU: sikteq-grijs-43]
  "64899486581085": "57893258330447", // Grijs  [SKU: sikteq-grijs-44]
  "64899486613853": "57893258363215", // Grijs  [SKU: sikteq-grijs-45]
  "64899486646621": "57893258395983", // Grijs  [SKU: sikteq-grijs-46]
  // ─── Sisterhood (10 variants) ───
  "64899489333597": "57893379735887", // 36  [SKU: sisterhood-36]
  "64899489366365": "57893379768655", // 37  [SKU: sisterhood-37]
  "64899489399133": "57893379801423", // 38  [SKU: sisterhood-38]
  "64899489431901": "57893379834191", // 39  [SKU: sisterhood-39]
  "64899489464669": "57893379866959", // 40  [SKU: sisterhood-40]
  "64899489497437": "57893379899727", // 41  [SKU: sisterhood-41]
  "64899489530205": "57893379932495", // 42  [SKU: sisterhood-42]
  "64899489562973": "57893379965263", // 43  [SKU: sisterhood-43]
  "64899489595741": "57893379998031", // 44  [SKU: sisterhood-44]
  "64899489628509": "57893380030799", // 45  [SKU: sisterhood-45]
  // ─── Slate Grey (11 variants) ───
  "64899491397981": "57893381833039", // 36  [SKU: slate-grey-36]
  "64899491430749": "57893381865807", // 37  [SKU: slate-grey-37]
  "64899491463517": "57893381898575", // 38  [SKU: slate-grey-38]
  "64899491496285": "57893381931343", // 39  [SKU: slate-grey-39]
  "64899491529053": "57893381964111", // 40  [SKU: slate-grey-40]
  "64899491561821": "57893381996879", // 41  [SKU: slate-grey-41]
  "64899491594589": "57893382029647", // 42  [SKU: slate-grey-42]
  "64899491627357": "57893382062415", // 43  [SKU: slate-grey-43]
  "64899491660125": "57893382095183", // 44  [SKU: slate-grey-44]
  "64899491692893": "57893382127951", // 45  [SKU: slate-grey-45]
  "64899491725661": "57893382160719", // 46  [SKU: slate-grey-46]
  // ─── Slim (63 variants) ───
  "64899493757277": "57893259084111", // Grijs  [SKU: slim-grijs-35]
  "64899493790045": "57893259116879", // Grijs  [SKU: slim-grijs-36]
  "64899493822813": "57893259149647", // Grijs  [SKU: slim-grijs-37]
  "64899493855581": "57893259182415", // Grijs  [SKU: slim-grijs-38]
  "64899493888349": "57893259215183", // Grijs  [SKU: slim-grijs-39]
  "64899493921117": "57893259247951", // Grijs  [SKU: slim-grijs-40]
  "64899493953885": "57893259280719", // Grijs  [SKU: slim-grijs-41]
  "64899493986653": "57893259313487", // Grijs  [SKU: slim-grijs-42]
  "64899494019421": "57893259346255", // Grijs  [SKU: slim-grijs-43]
  "64899494052189": "57893259379023", // Wit Roze  [SKU: slim-wit-roze-35]
  "64899494084957": "57893259411791", // Wit Roze  [SKU: slim-wit-roze-36]
  "64899494117725": "57893259444559", // Wit Roze  [SKU: slim-wit-roze-37]
  "64899494150493": "57893259477327", // Wit Roze  [SKU: slim-wit-roze-38]
  "64899494183261": "57893259510095", // Wit Roze  [SKU: slim-wit-roze-39]
  "64899494216029": "57893259542863", // Wit Roze  [SKU: slim-wit-roze-40]
  "64899494248797": "57893259575631", // Wit Roze  [SKU: slim-wit-roze-41]
  "64899494281565": "57893259608399", // Wit Roze  [SKU: slim-wit-roze-42]
  "64899494314333": "57893259641167", // Wit Roze  [SKU: slim-wit-roze-43]
  "64899494347101": "57893259673935", // Blanco Goud  [SKU: slim-blanco-goud-35]
  "64899494379869": "57893259706703", // Blanco Goud  [SKU: slim-blanco-goud-36]
  "64899494412637": "57893259739471", // Blanco Goud  [SKU: slim-blanco-goud-37]
  "64899494445405": "57893259772239", // Blanco Goud  [SKU: slim-blanco-goud-38]
  "64899494478173": "57893259805007", // Blanco Goud  [SKU: slim-blanco-goud-39]
  "64899494510941": "57893259837775", // Blanco Goud  [SKU: slim-blanco-goud-40]
  "64899494543709": "57893259870543", // Blanco Goud  [SKU: slim-blanco-goud-41]
  "64899494609245": "57893259903311", // Blanco Goud  [SKU: slim-blanco-goud-42]
  "64899494642013": "57893259936079", // Blanco Goud  [SKU: slim-blanco-goud-43]
  "64899494674781": "57893259968847", // Roze Goud  [SKU: slim-roze-goud-35]
  "64899494707549": "57893260001615", // Roze Goud  [SKU: slim-roze-goud-36]
  "64899494740317": "57893260034383", // Roze Goud  [SKU: slim-roze-goud-37]
  "64899494773085": "57893260067151", // Roze Goud  [SKU: slim-roze-goud-38]
  "64899494805853": "57893260099919", // Roze Goud  [SKU: slim-roze-goud-39]
  "64899494838621": "57893260132687", // Roze Goud  [SKU: slim-roze-goud-40]
  "64899494871389": "57893260165455", // Roze Goud  [SKU: slim-roze-goud-41]
  "64899494904157": "57893260198223", // Roze Goud  [SKU: slim-roze-goud-42]
  "64899494936925": "57893260230991", // Roze Goud  [SKU: slim-roze-goud-43]
  "64899494969693": "57893260263759", // Wit Paars  [SKU: slim-wit-paars-35]
  "64899495002461": "57893260296527", // Wit Paars  [SKU: slim-wit-paars-36]
  "64899495035229": "57893260329295", // Wit Paars  [SKU: slim-wit-paars-37]
  "64899495067997": "57893260362063", // Wit Paars  [SKU: slim-wit-paars-38]
  "64899495100765": "57893260394831", // Wit Paars  [SKU: slim-wit-paars-39]
  "64899495133533": "57893260427599", // Wit Paars  [SKU: slim-wit-paars-40]
  "64899495166301": "57893260460367", // Wit Paars  [SKU: slim-wit-paars-41]
  "64899495199069": "57893260493135", // Wit Paars  [SKU: slim-wit-paars-42]
  "64899495231837": "57893260525903", // Wit Paars  [SKU: slim-wit-paars-43]
  "64899495264605": "57893260558671", // Rood Goud  [SKU: slim-rood-goud-35]
  "64899495297373": "57893260591439", // Rood Goud  [SKU: slim-rood-goud-36]
  "64899495330141": "57893260624207", // Rood Goud  [SKU: slim-rood-goud-37]
  "64899495362909": "57893260656975", // Rood Goud  [SKU: slim-rood-goud-38]
  "64899495395677": "57893260689743", // Rood Goud  [SKU: slim-rood-goud-39]
  "64899495428445": "57893260722511", // Rood Goud  [SKU: slim-rood-goud-40]
  "64899495461213": "57893260755279", // Rood Goud  [SKU: slim-rood-goud-41]
  "64899495493981": "57893260788047", // Rood Goud  [SKU: slim-rood-goud-42]
  "64899495526749": "57893260820815", // Rood Goud  [SKU: slim-rood-goud-43]
  "64899495559517": "57893260853583", // Beige Goud  [SKU: slim-beige-goud-35]
  "64899495592285": "57893260886351", // Beige Goud  [SKU: slim-beige-goud-36]
  "64899495625053": "57893260919119", // Beige Goud  [SKU: slim-beige-goud-37]
  "64899495657821": "57893260951887", // Beige Goud  [SKU: slim-beige-goud-38]
  "64899495690589": "57893260984655", // Beige Goud  [SKU: slim-beige-goud-39]
  "64899495723357": "57893261017423", // Beige Goud  [SKU: slim-beige-goud-40]
  "64899495756125": "57893261050191", // Beige Goud  [SKU: slim-beige-goud-41]
  "64899495788893": "57893261082959", // Beige Goud  [SKU: slim-beige-goud-42]
  "64899495821661": "57893261115727", // Beige Goud  [SKU: slim-beige-goud-43]
  // ─── Sparkle (21 variants) ───
  "64899499688285": "57893267669327", // Goud  [SKU: sparkle-goud-36]
  "64899499721053": "57893267702095", // Goud  [SKU: sparkle-goud-37]
  "64899499753821": "57893267734863", // Goud  [SKU: sparkle-goud-38]
  "64899499786589": "57893267767631", // Goud  [SKU: sparkle-goud-39]
  "64899499819357": "57893267800399", // Goud  [SKU: sparkle-goud-40]
  "64899499852125": "57893267833167", // Goud  [SKU: sparkle-goud-41]
  "64899499884893": "57893267865935", // Goud  [SKU: sparkle-goud-42]
  "64899499917661": "57893267898703", // roze  [SKU: sparkle-roze-36]
  "64899499950429": "57893267931471", // roze  [SKU: sparkle-roze-37]
  "64899499983197": "57893267964239", // roze  [SKU: sparkle-roze-38]
  "64899500015965": "57893267997007", // roze  [SKU: sparkle-roze-39]
  "64899500048733": "57893268029775", // roze  [SKU: sparkle-roze-40]
  "64899500081501": "57893268062543", // roze  [SKU: sparkle-roze-41]
  "64899500114269": "57893268095311", // roze  [SKU: sparkle-roze-42]
  "64899500147037": "57893268128079", // Silver  [SKU: sparkle-silver-36]
  "64899500179805": "57893268160847", // Silver  [SKU: sparkle-silver-37]
  "64899500212573": "57893268193615", // Silver  [SKU: sparkle-silver-38]
  "64899500245341": "57893268226383", // Silver  [SKU: sparkle-silver-39]
  "64899500278109": "57893268259151", // Silver  [SKU: sparkle-silver-40]
  "64899500310877": "57893268291919", // Silver  [SKU: sparkle-silver-41]
  "64899500343645": "57893268324687", // Silver  [SKU: sparkle-silver-42]
  // ─── Sport Red (11 variants) ───
  "64899503325533": "57893382259023", // 36  [SKU: sport-red-36]
  "64899503358301": "57893382291791", // 37.5  [SKU: sport-red-375]
  "64899503391069": "57893382324559", // 38  [SKU: sport-red-38]
  "64899503423837": "57893382357327", // 39  [SKU: sport-red-39]
  "64899503456605": "57893382390095", // 40  [SKU: sport-red-40]
  "64899503489373": "57893382422863", // 41  [SKU: sport-red-41]
  "64899503522141": "57893382455631", // 42  [SKU: sport-red-42]
  "64899503554909": "57893382488399", // 43  [SKU: sport-red-43]
  "64899503587677": "57893382521167", // 44  [SKU: sport-red-44]
  "64899503620445": "57893382553935", // 45  [SKU: sport-red-45]
  "64899503653213": "57893382586703", // 46  [SKU: sport-red-46]
  // ─── Star Classic (54 variants) ───
  "64899508928861": "57893382685007", // 35  [SKU: star-classic-35-zwart]
  "64899508961629": "57893382717775", // 35  [SKU: star-classic-35-wit]
  "64899508994397": "57893382750543", // 35  [SKU: star-classic-35-roze]
  "64899509027165": "57893382783311", // 35  [SKU: star-classic-35-lichtgroen]
  "64899509059933": "57893382816079", // 35  [SKU: star-classic-35-rood]
  "64899509092701": "57893382848847", // 35  [SKU: star-classic-35-geel]
  "64899509125469": "57893382881615", // 36  [SKU: star-classic-36-zwart]
  "64899509158237": "57893382914383", // 36  [SKU: star-classic-36-wit]
  "64899509191005": "57893382947151", // 36  [SKU: star-classic-36-roze]
  "64899509223773": "57893382979919", // 36  [SKU: star-classic-36-lichtgroen]
  "64899509256541": "57893383012687", // 36  [SKU: star-classic-36-rood]
  "64899509289309": "57893383045455", // 36  [SKU: star-classic-36-geel]
  "64899509322077": "57893383078223", // 37  [SKU: star-classic-37-zwart]
  "64899509354845": "57893383110991", // 37  [SKU: star-classic-37-wit]
  "64899509387613": "57893383143759", // 37  [SKU: star-classic-37-roze]
  "64899509420381": "57893383176527", // 37  [SKU: star-classic-37-lichtgroen]
  "64899509453149": "57893383209295", // 37  [SKU: star-classic-37-rood]
  "64899509485917": "57893383242063", // 37  [SKU: star-classic-37-geel]
  "64899509518685": "57893383274831", // 38  [SKU: star-classic-38-zwart]
  "64899509551453": "57893383307599", // 38  [SKU: star-classic-38-wit]
  "64899509584221": "57893383340367", // 38  [SKU: star-classic-38-roze]
  "64899509616989": "57893383373135", // 38  [SKU: star-classic-38-lichtgroen]
  "64899509649757": "57893383405903", // 38  [SKU: star-classic-38-rood]
  "64899509682525": "57893383438671", // 38  [SKU: star-classic-38-geel]
  "64899509715293": "57893383471439", // 39  [SKU: star-classic-39-zwart]
  "64899509748061": "57893383504207", // 39  [SKU: star-classic-39-wit]
  "64899509780829": "57893383569743", // 39  [SKU: star-classic-39-roze]
  "64899509813597": "57893383602511", // 39  [SKU: star-classic-39-lichtgroen]
  "64899509846365": "57893383635279", // 39  [SKU: star-classic-39-rood]
  "64899509879133": "57893383668047", // 39  [SKU: star-classic-39-geel]
  "64899509911901": "57893383700815", // 40  [SKU: star-classic-40-zwart]
  "64899509944669": "57893383733583", // 40  [SKU: star-classic-40-wit]
  "64899509977437": "57893383766351", // 40  [SKU: star-classic-40-roze]
  "64899510010205": "57893383799119", // 40  [SKU: star-classic-40-lichtgroen]
  "64899510042973": "57893383831887", // 40  [SKU: star-classic-40-rood]
  "64899510075741": "57893383864655", // 40  [SKU: star-classic-40-geel]
  "64899510108509": "57893383897423", // 41  [SKU: star-classic-41-zwart]
  "64899510141277": "57893383930191", // 41  [SKU: star-classic-41-wit]
  "64899510174045": "57893383962959", // 41  [SKU: star-classic-41-roze]
  "64899510206813": "57893383995727", // 41  [SKU: star-classic-41-lichtgroen]
  "64899510239581": "57893384028495", // 41  [SKU: star-classic-41-rood]
  "64899510272349": "57893384061263", // 41  [SKU: star-classic-41-geel]
  "64899510305117": "57893384094031", // 42  [SKU: star-classic-42-zwart]
  "64899510337885": "57893384126799", // 42  [SKU: star-classic-42-wit]
  "64899510370653": "57893384159567", // 42  [SKU: star-classic-42-roze]
  "64899510403421": "57893384192335", // 42  [SKU: star-classic-42-lichtgroen]
  "64899510436189": "57893384225103", // 42  [SKU: star-classic-42-rood]
  "64899510468957": "57893384257871", // 42  [SKU: star-classic-42-geel]
  "64899510501725": "57893384290639", // 43  [SKU: star-classic-43-zwart]
  "64899510534493": "57893384323407", // 43  [SKU: star-classic-43-wit]
  "64899510567261": "57893384356175", // 43  [SKU: star-classic-43-roze]
  "64899510600029": "57893384388943", // 43  [SKU: star-classic-43-lichtgroen]
  "64899510632797": "57893384421711", // 43  [SKU: star-classic-43-rood]
  "64899510665565": "57893384454479", // 43  [SKU: star-classic-43-geel]
  // ─── Street Vortex (36 variants) ───
  "64899662807389": "57893384487247", // 36  [SKU: street-vortex-36-zwart-goud]
  "64899662840157": "57893384520015", // 36  [SKU: street-vortex-36-wit-zwart]
  "64899662872925": "57893384552783", // 36  [SKU: street-vortex-36-wit-grijs]
  "64899662905693": "57893384585551", // 36  [SKU: street-vortex-36-wit-rood]
  "64899662938461": "57893384618319", // 37  [SKU: street-vortex-37-zwart-goud]
  "64899662971229": "57893384651087", // 37  [SKU: street-vortex-37-wit-zwart]
  "64899663003997": "57893384683855", // 37  [SKU: street-vortex-37-wit-grijs]
  "64899663036765": "57893384716623", // 37  [SKU: street-vortex-37-wit-rood]
  "64899663069533": "57893384749391", // 38  [SKU: street-vortex-38-zwart-goud]
  "64899663102301": "57893384782159", // 38  [SKU: street-vortex-38-wit-zwart]
  "64899663135069": "57893384814927", // 38  [SKU: street-vortex-38-wit-grijs]
  "64899663167837": "57893384847695", // 38  [SKU: street-vortex-38-wit-rood]
  "64899663200605": "57893384880463", // 39  [SKU: street-vortex-39-zwart-goud]
  "64899663233373": "57893384913231", // 39  [SKU: street-vortex-39-wit-zwart]
  "64899663266141": "57893384945999", // 39  [SKU: street-vortex-39-wit-grijs]
  "64899663298909": "57893384978767", // 39  [SKU: street-vortex-39-wit-rood]
  "64899663331677": "57893385011535", // 40  [SKU: street-vortex-40-zwart-goud]
  "64899663364445": "57893385044303", // 40  [SKU: street-vortex-40-wit-zwart]
  "64899663397213": "57893385077071", // 40  [SKU: street-vortex-40-wit-grijs]
  "64899663429981": "57893385109839", // 40  [SKU: street-vortex-40-wit-rood]
  "64899663462749": "57893385142607", // 41  [SKU: street-vortex-41-zwart-goud]
  "64899663495517": "57893385175375", // 41  [SKU: street-vortex-41-wit-zwart]
  "64899663528285": "57893385208143", // 41  [SKU: street-vortex-41-wit-grijs]
  "64899663561053": "57893385240911", // 41  [SKU: street-vortex-41-wit-rood]
  "64899663593821": "57893385273679", // 42  [SKU: street-vortex-42-zwart-goud]
  "64899663626589": "57893385306447", // 42  [SKU: street-vortex-42-wit-zwart]
  "64899663659357": "57893385339215", // 42  [SKU: street-vortex-42-wit-grijs]
  "64899663692125": "57893385371983", // 42  [SKU: street-vortex-42-wit-rood]
  "64899663724893": "57893385404751", // 43  [SKU: street-vortex-43-zwart-goud]
  "64899663757661": "57893385437519", // 43  [SKU: street-vortex-43-wit-zwart]
  "64899663790429": "57893385470287", // 43  [SKU: street-vortex-43-wit-grijs]
  "64899663823197": "57893385503055", // 43  [SKU: street-vortex-43-wit-rood]
  "64899663855965": "57893385535823", // 44  [SKU: street-vortex-44-zwart-goud]
  "64899663888733": "57893385568591", // 44  [SKU: street-vortex-44-wit-zwart]
  "64899663921501": "57893385601359", // 44  [SKU: street-vortex-44-wit-grijs]
  "64899663954269": "57893385634127", // 44  [SKU: street-vortex-44-wit-rood]
  // ─── Summit White (10 variants) ───
  "64899519414621": "57893386060111", // 36  [SKU: summit-white-36]
  "64899519447389": "57893386092879", // 37.5  [SKU: summit-white-375]
  "64899519480157": "57893386125647", // 38  [SKU: summit-white-38]
  "64899519512925": "57893386158415", // 39  [SKU: summit-white-39]
  "64899519545693": "57893386191183", // 40  [SKU: summit-white-40]
  "64899519578461": "57893386223951", // 41  [SKU: summit-white-41]
  "64899519611229": "57893386256719", // 42  [SKU: summit-white-42]
  "64899519643997": "57893386289487", // 43  [SKU: summit-white-43]
  "64899519676765": "57893386322255", // 44  [SKU: summit-white-44]
  "64899519709533": "57893386355023", // 45  [SKU: summit-white-45]
  // ─── Supreme White (10 variants) ───
  "64899665264989": "57893386387791", // 36  [SKU: supreme-white-36]
  "64899665297757": "57893386420559", // 37  [SKU: supreme-white-37]
  "64899665330525": "57893386453327", // 38  [SKU: supreme-white-38]
  "64899665363293": "57893386486095", // 39  [SKU: supreme-white-39]
  "64899665396061": "57893386518863", // 40  [SKU: supreme-white-40]
  "64899665428829": "57893386551631", // 41  [SKU: supreme-white-41]
  "64899665461597": "57893386584399", // 42  [SKU: supreme-white-42]
  "64899665494365": "57893386617167", // 43  [SKU: supreme-white-43]
  "64899665527133": "57893386649935", // 44  [SKU: supreme-white-44]
  "64899665559901": "57893386682703", // 45  [SKU: supreme-white-45]
  // ─── Suède Pakket – Zeezout (11 variants) ───
  "64899514597725": "57893385666895", // 36  [SKU: sude-pakket-zeezout-36]
  "64899514630493": "57893385699663", // 37  [SKU: sude-pakket-zeezout-37]
  "64899514663261": "57893385732431", // 38  [SKU: sude-pakket-zeezout-38]
  "64899514696029": "57893385765199", // 39.5  [SKU: sude-pakket-zeezout-395]
  "64899514728797": "57893385797967", // 40  [SKU: sude-pakket-zeezout-40]
  "64899514761565": "57893385830735", // 41.5  [SKU: sude-pakket-zeezout-415]
  "64899514794333": "57893385863503", // 42  [SKU: sude-pakket-zeezout-42]
  "64899514827101": "57893385896271", // 43  [SKU: sude-pakket-zeezout-43]
  "64899514859869": "57893385929039", // 44  [SKU: sude-pakket-zeezout-44]
  "64899514892637": "57893385961807", // 45  [SKU: sude-pakket-zeezout-45]
  "64899514925405": "57893385994575", // 46.5  [SKU: sude-pakket-zeezout-465]
  // ─── Tai-Chi Yellow (11 variants) ───
  "64899524133213": "57893386715471", // 36  [SKU: tai-chi-yellow-36]
  "64899524165981": "57893386748239", // 37  [SKU: tai-chi-yellow-37]
  "64899524198749": "57893386781007", // 38  [SKU: tai-chi-yellow-38]
  "64899524231517": "57893386813775", // 39  [SKU: tai-chi-yellow-39]
  "64899524264285": "57893386846543", // 40  [SKU: tai-chi-yellow-40]
  "64899524297053": "57893386879311", // 41  [SKU: tai-chi-yellow-41]
  "64899524329821": "57893386912079", // 42  [SKU: tai-chi-yellow-42]
  "64899524362589": "57893386944847", // 43  [SKU: tai-chi-yellow-43]
  "64899524395357": "57893386977615", // 44  [SKU: tai-chi-yellow-44]
  "64899524428125": "57893387010383", // 45  [SKU: tai-chi-yellow-45]
  "64899524460893": "57893387043151", // 46  [SKU: tai-chi-yellow-46]
  // ─── Team Orange (10 variants) ───
  "64899526459741": "57893387108687", // 36  [SKU: team-orange-36]
  "64899526492509": "57893387141455", // 37.5  [SKU: team-orange-375]
  "64899526525277": "57893387174223", // 38  [SKU: team-orange-38]
  "64899526558045": "57893387206991", // 39  [SKU: team-orange-39]
  "64899526590813": "57893387239759", // 40  [SKU: team-orange-40]
  "64899526623581": "57893387272527", // 41  [SKU: team-orange-41]
  "64899526656349": "57893387305295", // 42  [SKU: team-orange-42]
  "64899526951261": "57893387338063", // 43  [SKU: team-orange-43]
  "64899526984029": "57893387370831", // 44  [SKU: team-orange-44]
  "64899527016797": "57893387403599", // 45  [SKU: team-orange-45]
  // ─── Team Red (10 variants) ───
  "64899531145565": "57893387436367", // 36  [SKU: team-red-36]
  "64899531178333": "57893387469135", // 37  [SKU: team-red-37]
  "64899531211101": "57893387501903", // 38  [SKU: team-red-38]
  "64899531243869": "57893387534671", // 39  [SKU: team-red-39]
  "64899531276637": "57893387567439", // 40  [SKU: team-red-40]
  "64899531309405": "57893387600207", // 41  [SKU: team-red-41]
  "64899531342173": "57893387632975", // 42  [SKU: team-red-42]
  "64899531374941": "57893387665743", // 43  [SKU: team-red-43]
  "64899531407709": "57893387698511", // 44  [SKU: team-red-44]
  "64899531440477": "57893387731279", // 45  [SKU: team-red-45]
  // ─── Triple Black (11 variants) ───
  "64899535503709": "57893389140303", // 36  [SKU: triple-black-36]
  "64899535536477": "57893389173071", // 37.5  [SKU: triple-black-375]
  "64899535569245": "57893389205839", // 38  [SKU: triple-black-38]
  "64899535602013": "57893389238607", // 39  [SKU: triple-black-39]
  "64899535634781": "57893389271375", // 40  [SKU: triple-black-40]
  "64899535667549": "57893389304143", // 41  [SKU: triple-black-41]
  "64899535700317": "57893389336911", // 42  [SKU: triple-black-42]
  "64899535733085": "57893389369679", // 43  [SKU: triple-black-43]
  "64899535765853": "57893389402447", // 44  [SKU: triple-black-44]
  "64899535798621": "57893389435215", // 45  [SKU: triple-black-45]
  "64899535831389": "57893389467983", // 46  [SKU: triple-black-46]
  // ─── Triple Black (11 variants) ───
  "64899665822045": "57893389599055", // 36  [SKU: triple-black-v2-36]
  "64899665854813": "57893389631823", // 37  [SKU: triple-black-v2-37]
  "64899665887581": "57893389664591", // 38  [SKU: triple-black-v2-38]
  "64899665920349": "57893389697359", // 39.5  [SKU: triple-black-v2-395]
  "64899665953117": "57893389730127", // 40  [SKU: triple-black-v2-40]
  "64899665985885": "57893389762895", // 41.5  [SKU: triple-black-v2-415]
  "64899666018653": "57893389795663", // 42  [SKU: triple-black-v2-42]
  "64899666051421": "57893389828431", // 43  [SKU: triple-black-v2-43]
  "64899666084189": "57893389861199", // 44  [SKU: triple-black-v2-44]
  "64899666116957": "57893389893967", // 45  [SKU: triple-black-v2-45]
  "64899666149725": "57893389926735", // 46.5  [SKU: triple-black-v2-465]
  // ─── Turf (11 variants) ───
  "64899539534173": "57893390647631", // 36  [SKU: turf-36]
  "64899539566941": "57893390680399", // 37.5  [SKU: turf-375]
  "64899539599709": "57893390713167", // 38  [SKU: turf-38]
  "64899539632477": "57893390745935", // 39  [SKU: turf-39]
  "64899539665245": "57893390778703", // 40  [SKU: turf-40]
  "64899539698013": "57893390811471", // 41  [SKU: turf-41]
  "64899539730781": "57893390844239", // 42  [SKU: turf-42]
  "64899539763549": "57893390877007", // 43  [SKU: turf-43]
  "64899539829085": "57893390909775", // 44  [SKU: turf-44]
  "64899539861853": "57893390942543", // 45  [SKU: turf-45]
  "64899539894621": "57893390975311", // 46  [SKU: turf-46]
  // ─── Turtledove (11 variants) ───
  "64899542155613": "57893391008079", // 36  [SKU: turtledove-36]
  "64899542188381": "57893391040847", // 37  [SKU: turtledove-37]
  "64899542221149": "57893391073615", // 38  [SKU: turtledove-38]
  "64899542253917": "57893391106383", // 39.5  [SKU: turtledove-395]
  "64899542286685": "57893391139151", // 40  [SKU: turtledove-40]
  "64899542319453": "57893391171919", // 41.5  [SKU: turtledove-415]
  "64899542352221": "57893391204687", // 42  [SKU: turtledove-42]
  "64899542384989": "57893391237455", // 43  [SKU: turtledove-43]
  "64899542417757": "57893391270223", // 44  [SKU: turtledove-44]
  "64899542450525": "57893391302991", // 45  [SKU: turtledove-45]
  "64899542483293": "57893391335759", // 46.5  [SKU: turtledove-465]
  // ─── UNC (10 variants) ───
  "64899547922781": "57893391728975", // 36  [SKU: unc-36]
  "64899547955549": "57893391761743", // 37  [SKU: unc-37]
  "64899547988317": "57893391794511", // 38  [SKU: unc-38]
  "64899548021085": "57893391827279", // 39  [SKU: unc-39]
  "64899548053853": "57893391860047", // 40  [SKU: unc-40]
  "64899548086621": "57893391892815", // 41  [SKU: unc-41]
  "64899548119389": "57893391925583", // 42  [SKU: unc-42]
  "64899548152157": "57893391958351", // 43  [SKU: unc-43]
  "64899548184925": "57893391991119", // 44  [SKU: unc-44]
  "64899548217693": "57893392023887", // 45  [SKU: unc-45]
  // ─── USA (11 variants) ───
  "64899564110173": "57893395857743", // 36  [SKU: usa-36]
  "64899564142941": "57893395890511", // 37.5  [SKU: usa-37.5]
  "64899564175709": "57893395923279", // 38  [SKU: usa-38]
  "64899564208477": "57893395956047", // 39  [SKU: usa-39]
  "64899564241245": "57893395988815", // 40  [SKU: usa-40]
  "64899564274013": "57893396021583", // 41  [SKU: usa-41]
  "64899564306781": "57893396054351", // 42  [SKU: usa-42]
  "64899564339549": "57893396087119", // 43  [SKU: usa-43]
  "64899564372317": "57893396119887", // 44  [SKU: usa-44]
  "64899564405085": "57893396152655", // 45  [SKU: usa-45]
  "64899564437853": "57893396185423", // 46  [SKU: usa-46]
  // ─── Unisex Winter Veterlaarsjes (60 variants) ───
  "64899549757789": "57893392122191", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-35]
  "64899549790557": "57893392154959", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-36]
  "64899549823325": "57893392187727", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-37]
  "64899549856093": "57893392220495", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-38]
  "64899549888861": "57893392253263", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-39]
  "64899549921629": "57893392286031", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-40]
  "64899549954397": "57893392318799", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-41]
  "64899549987165": "57893392351567", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-42]
  "64899550019933": "57893392384335", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-43]
  "64899550052701": "57893392417103", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-44]
  "64899550085469": "57893392449871", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-45]
  "64899550118237": "57893392482639", // Zwart  [SKU: unisex-winter-veterlaarsjes-zwart-46]
  "64899550216541": "57893392580943", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-35]
  "64899550249309": "57893392613711", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-36]
  "64899550282077": "57893392646479", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-37]
  "64899550314845": "57893392679247", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-38]
  "64899550347613": "57893392712015", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-39]
  "64899550380381": "57893392744783", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-40]
  "64899550413149": "57893392777551", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-41]
  "64899550445917": "57893392810319", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-42]
  "64899550478685": "57893392843087", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-43]
  "64899550511453": "57893392875855", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-44]
  "64899550544221": "57893392908623", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-45]
  "64899550576989": "57893392941391", // Groen  [SKU: unisex-winter-veterlaarsjes-groen-46]
  "64899550675293": "57893393039695", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-35]
  "64899550708061": "57893393072463", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-36]
  "64899550740829": "57893393105231", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-37]
  "64899550773597": "57893393137999", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-38]
  "64899550806365": "57893393170767", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-39]
  "64899550839133": "57893393203535", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-40]
  "64899550871901": "57893393236303", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-41]
  "64899550904669": "57893393269071", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-42]
  "64899550937437": "57893393301839", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-43]
  "64899550970205": "57893393334607", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-44]
  "64899551002973": "57893393367375", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-45]
  "64899551035741": "57893393400143", // Blauw  [SKU: unisex-winter-veterlaarsjes-blauw-46]
  "64899551134045": "57893393498447", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-35]
  "64899551166813": "57893393531215", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-36]
  "64899551199581": "57893393563983", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-37]
  "64899551232349": "57893393596751", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-38]
  "64899551265117": "57893393629519", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-39]
  "64899551297885": "57893393662287", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-40]
  "64899551330653": "57893393695055", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-41]
  "64899551363421": "57893393727823", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-42]
  "64899551396189": "57893393760591", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-43]
  "64899551428957": "57893393793359", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-44]
  "64899551461725": "57893393826127", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-45]
  "64899551494493": "57893393858895", // Wit  [SKU: unisex-winter-veterlaarsjes-wit-46]
  "64899551592797": "57893393957199", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-35]
  "64899551625565": "57893393989967", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-36]
  "64899551658333": "57893394022735", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-37]
  "64899551691101": "57893394055503", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-38]
  "64899551723869": "57893394088271", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-39]
  "64899551756637": "57893394121039", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-40]
  "64899551789405": "57893394153807", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-41]
  "64899551822173": "57893394186575", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-42]
  "64899551854941": "57893394219343", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-43]
  "64899551887709": "57893394252111", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-44]
  "64899551920477": "57893394284879", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-45]
  "64899551953245": "57893394317647", // Rood  [SKU: unisex-winter-veterlaarsjes-rood-46]
  // ─── University (11 variants) ───
  "64899556409693": "57893394448719", // 36  [SKU: university-36]
  "64899556442461": "57893394481487", // 37.5  [SKU: university-375]
  "64899556475229": "57893394514255", // 38  [SKU: university-38]
  "64899556507997": "57893394547023", // 39  [SKU: university-39]
  "64899556540765": "57893394579791", // 40  [SKU: university-40]
  "64899556573533": "57893394612559", // 41  [SKU: university-41]
  "64899556606301": "57893394645327", // 42  [SKU: university-42]
  "64899556639069": "57893394678095", // 43  [SKU: university-43]
  "64899556671837": "57893394710863", // 44  [SKU: university-44]
  "64899556704605": "57893394743631", // 45  [SKU: university-45]
  "64899556737373": "57893394776399", // 46  [SKU: university-46]
  // ─── University Red (10 variants) ───
  "64899559883101": "57893395464527", // 36  [SKU: university-red-36]
  "64899559915869": "57893395497295", // 37.5  [SKU: university-red-375]
  "64899559948637": "57893395530063", // 38  [SKU: university-red-38]
  "64899559981405": "57893395562831", // 39  [SKU: university-red-39]
  "64899560014173": "57893395595599", // 40  [SKU: university-red-40]
  "64899560046941": "57893395628367", // 41  [SKU: university-red-41]
  "64899560079709": "57893395661135", // 42  [SKU: university-red-42]
  "64899560112477": "57893395693903", // 43  [SKU: university-red-43]
  "64899560145245": "57893395726671", // 44  [SKU: university-red-44]
  "64899560178013": "57893395759439", // 45  [SKU: university-red-45]
  // ─── Utility White (10 variants) ───
  "64899568468317": "57893396316495", // 36  [SKU: utility-white-36]
  "64899568501085": "57893396349263", // 37  [SKU: utility-white-37]
  "64899568533853": "57893396382031", // 38  [SKU: utility-white-38]
  "64899568566621": "57893396414799", // 39  [SKU: utility-white-39]
  "64899568599389": "57893396447567", // 40  [SKU: utility-white-40]
  "64899568632157": "57893396480335", // 41  [SKU: utility-white-41]
  "64899568664925": "57893396545871", // 42  [SKU: utility-white-42]
  "64899568697693": "57893396578639", // 43  [SKU: utility-white-43]
  "64899568730461": "57893396611407", // 44  [SKU: utility-white-44]
  "64899568763229": "57893396644175", // 45  [SKU: utility-white-45]
  // ─── Vachetta (11 variants) ───
  "64899572891997": "57893397102927", // 36  [SKU: vachetta-36]
  "64899572924765": "57893397135695", // 37.5  [SKU: vachetta-375]
  "64899572957533": "57893397233999", // 38  [SKU: vachetta-38]
  "64899572990301": "57893397266767", // 39  [SKU: vachetta-39]
  "64899573023069": "57893397299535", // 40  [SKU: vachetta-40]
  "64899573055837": "57893397332303", // 41  [SKU: vachetta-41]
  "64899573088605": "57893397365071", // 42  [SKU: vachetta-42]
  "64899573121373": "57893397397839", // 43  [SKU: vachetta-43]
  "64899573154141": "57893397430607", // 44  [SKU: vachetta-44]
  "64899573186909": "57893397463375", // 45  [SKU: vachetta-45]
  "64899573219677": "57893397496143", // 46  [SKU: vachetta-46]
  // ─── Valentine (9 variants) ───
  "64899575415133": "57893397594447", // 36  [SKU: valentine-36]
  "64899575447901": "57893397627215", // 37  [SKU: valentine-37]
  "64899575480669": "57893397659983", // 38  [SKU: valentine-38]
  "64899575513437": "57893397692751", // 39  [SKU: valentine-39]
  "64899575546205": "57893397725519", // 40  [SKU: valentine-40]
  "64899575578973": "57893397758287", // 41  [SKU: valentine-41]
  "64899575611741": "57893397791055", // 42  [SKU: valentine-42]
  "64899575644509": "57893397823823", // 43  [SKU: valentine-43]
  "64899575677277": "57893397856591", // 44  [SKU: valentine-44]
  // ─── Veiligheidschoenen (22 variants) ───
  "64899579314525": "57893271732559", // Zwart  [SKU: safestepper-zwart-36]
  "64899579347293": "57893271765327", // Zwart  [SKU: safestepper-zwart-37]
  "64899579380061": "57893271798095", // Zwart  [SKU: safestepper-zwart-38]
  "64899579412829": "57893271830863", // Zwart  [SKU: safestepper-zwart-39]
  "64899579445597": "57893271863631", // Zwart  [SKU: safestepper-zwart-40]
  "64899579478365": "57893271896399", // Zwart  [SKU: safestepper-zwart-41]
  "64899579511133": "57893271929167", // Zwart  [SKU: safestepper-zwart-42]
  "64899579543901": "57893271961935", // Zwart  [SKU: safestepper-zwart-43]
  "64899579576669": "57893271994703", // Zwart  [SKU: safestepper-zwart-44]
  "64899579609437": "57893272027471", // Zwart  [SKU: safestepper-zwart-45]
  "64899579642205": "57893272060239", // Zwart  [SKU: safestepper-zwart-46]
  "64899579740509": "57893272158543", // Grijs  [SKU: safestepper-grijs-36]
  "64899579773277": "57893272191311", // Grijs  [SKU: safestepper-grijs-37]
  "64899579806045": "57893272224079", // Grijs  [SKU: safestepper-grijs-38]
  "64899579838813": "57893272256847", // Grijs  [SKU: safestepper-grijs-39]
  "64899579871581": "57893272289615", // Grijs  [SKU: safestepper-grijs-40]
  "64899579904349": "57893272322383", // Grijs  [SKU: safestepper-grijs-41]
  "64899579937117": "57893272355151", // Grijs  [SKU: safestepper-grijs-42]
  "64899579969885": "57893272387919", // Grijs  [SKU: safestepper-grijs-43]
  "64899580002653": "57893272420687", // Grijs  [SKU: safestepper-grijs-44]
  "64899580035421": "57893272453455", // Grijs  [SKU: safestepper-grijs-45]
  "64899580068189": "57893272486223", // Grijs  [SKU: safestepper-grijs-46]
  // ─── Velocity Arc (20 variants) ───
  "64899666805085": "57893398020431", // 40  [SKU: velocity-arc-40-wit]
  "64899666837853": "57893398053199", // 40  [SKU: velocity-arc-40-blauw]
  "64899666870621": "57893398085967", // 41  [SKU: velocity-arc-41-zwart]
  "64899666903389": "57893398118735", // 41  [SKU: velocity-arc-41-wit]
  "64899666936157": "57893398151503", // 41  [SKU: velocity-arc-41-blauw]
  "64899666968925": "57893398184271", // 42  [SKU: velocity-arc-42-zwart]
  "64899667001693": "57893398217039", // 42  [SKU: velocity-arc-42-wit]
  "64899667034461": "57893398249807", // 42  [SKU: velocity-arc-42-blauw]
  "64899667067229": "57893398282575", // 43  [SKU: velocity-arc-43-zwart]
  "64899667099997": "57893398315343", // 43  [SKU: velocity-arc-43-wit]
  "64899667132765": "57893398348111", // 43  [SKU: velocity-arc-43-blauw]
  "64899667165533": "57893398380879", // 44  [SKU: velocity-arc-44-zwart]
  "64899667198301": "57893398413647", // 44  [SKU: velocity-arc-44-wit]
  "64899667231069": "57893398446415", // 44  [SKU: velocity-arc-44-blauw]
  "64899667263837": "57893398479183", // 45  [SKU: velocity-arc-45-zwart]
  "64899667296605": "57893398511951", // 45  [SKU: velocity-arc-45-wit]
  "64899667329373": "57893398544719", // 45  [SKU: velocity-arc-45-blauw]
  "64899667362141": "57893398577487", // 46  [SKU: velocity-arc-46-zwart]
  "64899667394909": "57893398610255", // 46  [SKU: velocity-arc-46-wit]
  "64899667427677": "57893398643023", // 46  [SKU: velocity-arc-46-blauw]
  // ─── Velora Noir (18 variants) ───
  "64899585638749": "57893398774095", // 35  [SKU: velora-noir-35-zwart]
  "64899585671517": "57893398806863", // 35  [SKU: velora-noir-35-wit]
  "64899585704285": "57893398839631", // 36  [SKU: velora-noir-36-zwart]
  "64899585737053": "57893398872399", // 36  [SKU: velora-noir-36-wit]
  "64899585769821": "57893398905167", // 37  [SKU: velora-noir-37-zwart]
  "64899585802589": "57893398937935", // 37  [SKU: velora-noir-37-wit]
  "64899585835357": "57893398970703", // 38  [SKU: velora-noir-38-zwart]
  "64899585868125": "57893399003471", // 38  [SKU: velora-noir-38-wit]
  "64899585900893": "57893399036239", // 39  [SKU: velora-noir-39-zwart]
  "64899585933661": "57893399069007", // 39  [SKU: velora-noir-39-wit]
  "64899585966429": "57893399101775", // 40  [SKU: velora-noir-40-zwart]
  "64899585999197": "57893399134543", // 40  [SKU: velora-noir-40-wit]
  "64899586031965": "57893399167311", // 41  [SKU: velora-noir-41-zwart]
  "64899586064733": "57893399200079", // 41  [SKU: velora-noir-41-wit]
  "64899586097501": "57893399232847", // 42  [SKU: velora-noir-42-zwart]
  "64899586130269": "57893399265615", // 42  [SKU: velora-noir-42-wit]
  "64899586163037": "57893399298383", // 43  [SKU: velora-noir-43-zwart]
  "64899586195805": "57893399331151", // 43  [SKU: velora-noir-43-wit]
  // ─── Velour (11 variants) ───
  "64899587473757": "57893399363919", // 36  [SKU: velour-36]
  "64899587506525": "57893399396687", // 37.5  [SKU: velour-37.5]
  "64899587539293": "57893399429455", // 38  [SKU: velour-38]
  "64899587572061": "57893399462223", // 39  [SKU: velour-39]
  "64899587604829": "57893399494991", // 40  [SKU: velour-40]
  "64899587637597": "57893399527759", // 41  [SKU: velour-41]
  "64899587670365": "57893399560527", // 42  [SKU: velour-42]
  "64899587703133": "57893399593295", // 43  [SKU: velour-43]
  "64899587735901": "57893399626063", // 44  [SKU: velour-44]
  "64899587768669": "57893399658831", // 45  [SKU: velour-45]
  "64899587801437": "57893399691599", // 46  [SKU: velour-46]
  // ─── Vigo (40 variants) ───
  "64899587899741": "57893272977743", // Zwart  [SKU: vigo-zwart-40]
  "64899587932509": "57893273010511", // Zwart  [SKU: vigo-zwart-41]
  "64899587965277": "57893273043279", // Zwart  [SKU: vigo-zwart-41.5]
  "64899587998045": "57893273076047", // Zwart  [SKU: vigo-zwart-42]
  "64899588030813": "57893273108815", // Zwart  [SKU: vigo-zwart-43]
  "64899588063581": "57893273141583", // Zwart  [SKU: vigo-zwart-44]
  "64899588096349": "57893273174351", // Zwart  [SKU: vigo-zwart-45]
  "64899588129117": "57893273207119", // Zwart  [SKU: vigo-zwart-45.5]
  "64899588161885": "57893273239887", // Zwart  [SKU: vigo-zwart-46]
  "64899588194653": "57893273272655", // Zwart  [SKU: vigo-zwart-46.5]
  "64899588260189": "57893273338191", // Bruin  [SKU: vigo-bruin-40]
  "64899588292957": "57893273370959", // Bruin  [SKU: vigo-bruin-41]
  "64899588325725": "57893273403727", // Bruin  [SKU: vigo-bruin-41.5]
  "64899588358493": "57893273436495", // Bruin  [SKU: vigo-bruin-42]
  "64899588391261": "57893273469263", // Bruin  [SKU: vigo-bruin-43]
  "64899588424029": "57893273502031", // Bruin  [SKU: vigo-bruin-44]
  "64899588456797": "57893273534799", // Bruin  [SKU: vigo-bruin-45]
  "64899588489565": "57893273567567", // Bruin  [SKU: vigo-bruin-45.5]
  "64899588522333": "57893273600335", // Bruin  [SKU: vigo-bruin-46]
  "64899588555101": "57893273633103", // Bruin  [SKU: vigo-bruin-46.5]
  "64899588620637": "57893273698639", // Blauw  [SKU: vigo-blauw-40]
  "64899588653405": "57893273731407", // Blauw  [SKU: vigo-blauw-41]
  "64899588686173": "57893273764175", // Blauw  [SKU: vigo-blauw-41.5]
  "64899588718941": "57893273796943", // Blauw  [SKU: vigo-blauw-42]
  "64899588751709": "57893273829711", // Blauw  [SKU: vigo-blauw-43]
  "64899588784477": "57893273862479", // Blauw  [SKU: vigo-blauw-44]
  "64899588817245": "57893273895247", // Blauw  [SKU: vigo-blauw-45]
  "64899588850013": "57893273928015", // Blauw  [SKU: vigo-blauw-45.5]
  "64899588882781": "57893273960783", // Blauw  [SKU: vigo-blauw-46]
  "64899588915549": "57893273993551", // Blauw  [SKU: vigo-blauw-46.5]
  "64899588981085": "57893274059087", // Wit  [SKU: vigo-wit-40]
  "64899589013853": "57893274091855", // Wit  [SKU: vigo-wit-41]
  "64899589046621": "57893274124623", // Wit  [SKU: vigo-wit-41.5]
  "64899589079389": "57893274157391", // Wit  [SKU: vigo-wit-42]
  "64899589112157": "57893274190159", // Wit  [SKU: vigo-wit-43]
  "64899589144925": "57893274222927", // Wit  [SKU: vigo-wit-44]
  "64899589177693": "57893274255695", // Wit  [SKU: vigo-wit-45]
  "64899589210461": "57893274288463", // Wit  [SKU: vigo-wit-45.5]
  "64899589243229": "57893274321231", // Wit  [SKU: vigo-wit-46]
  "64899589275997": "57893274353999", // Wit  [SKU: vigo-wit-46.5]
  // ─── Vio (11 variants) ───
  "64899590193501": "57893399855439", // 36  [SKU: vio-36]
  "64899590226269": "57893399888207", // 37.5  [SKU: vio-375]
  "64899590259037": "57893399920975", // 38  [SKU: vio-38]
  "64899590291805": "57893399953743", // 39  [SKU: vio-39]
  "64899590324573": "57893399986511", // 40  [SKU: vio-40]
  "64899590357341": "57893400019279", // 41  [SKU: vio-41]
  "64899590422877": "57893400052047", // 42  [SKU: vio-42]
  "64899590455645": "57893400084815", // 43  [SKU: vio-43]
  "64899590488413": "57893400117583", // 44  [SKU: vio-44]
  "64899590521181": "57893400150351", // 45  [SKU: vio-45]
  "64899590553949": "57893400183119", // 46  [SKU: vio-46]
  // ─── Volt (11 variants) ───
  "64899591078237": "57893400314191", // 36  [SKU: volt-36]
  "64899591111005": "57893400346959", // 37.5  [SKU: volt-375]
  "64899591143773": "57893400379727", // 38  [SKU: volt-38]
  "64899591176541": "57893400412495", // 39  [SKU: volt-39]
  "64899591209309": "57893400445263", // 40  [SKU: volt-40]
  "64899591242077": "57893400478031", // 41  [SKU: volt-41]
  "64899591274845": "57893400510799", // 42  [SKU: volt-42]
  "64899591307613": "57893400543567", // 43  [SKU: volt-43]
  "64899591340381": "57893400576335", // 44  [SKU: volt-44]
  "64899591373149": "57893400609103", // 45  [SKU: volt-45]
  "64899591405917": "57893400641871", // 46  [SKU: volt-46]
  // ─── Warm Blue (11 variants) ───
  "64899591864669": "57893400772943", // 36  [SKU: warm-blue-36]
  "64899591897437": "57893400805711", // 37  [SKU: warm-blue-37]
  "64899591930205": "57893400838479", // 38  [SKU: warm-blue-38]
  "64899591962973": "57893400871247", // 39  [SKU: warm-blue-39]
  "64899591995741": "57893400904015", // 40  [SKU: warm-blue-40]
  "64899592028509": "57893400936783", // 41  [SKU: warm-blue-41]
  "64899592061277": "57893400969551", // 42  [SKU: warm-blue-42]
  "64899592094045": "57893401002319", // 43  [SKU: warm-blue-43]
  "64899592126813": "57893401035087", // 44  [SKU: warm-blue-44]
  "64899592159581": "57893401067855", // 45  [SKU: warm-blue-45]
  "64899592192349": "57893401100623", // 46  [SKU: warm-blue-46]
  // ─── Werkleding (11 variants) ───
  "64899592552797": "57893401198927", // 36  [SKU: werkleding-36]
  "64899592585565": "57893401231695", // 37  [SKU: werkleding-37]
  "64899592618333": "57893401264463", // 38  [SKU: werkleding-38]
  "64899592651101": "57893401297231", // 39.5  [SKU: werkleding-395]
  "64899592683869": "57893401329999", // 40  [SKU: werkleding-40]
  "64899592716637": "57893401362767", // 41.5  [SKU: werkleding-415]
  "64899592749405": "57893401395535", // 42  [SKU: werkleding-42]
  "64899592782173": "57893401428303", // 43  [SKU: werkleding-43]
  "64899592814941": "57893401461071", // 44  [SKU: werkleding-44]
  "64899592847709": "57893401493839", // 45  [SKU: werkleding-45]
  "64899592880477": "57893401526607", // 46.5  [SKU: werkleding-465]
  // ─── Wheat (11 variants) ───
  "64899667689821": "57893401723215", // 36  [SKU: wheat-36]
  "64899667722589": "57893401755983", // 37.5  [SKU: wheat-375]
  "64899667755357": "57893401788751", // 38  [SKU: wheat-38]
  "64899667788125": "57893401821519", // 39  [SKU: wheat-39]
  "64899667820893": "57893401854287", // 40  [SKU: wheat-40]
  "64899667853661": "57893401887055", // 41  [SKU: wheat-41]
  "64899667886429": "57893401919823", // 42  [SKU: wheat-42]
  "64899667919197": "57893401952591", // 43  [SKU: wheat-43]
  "64899667951965": "57893401985359", // 44  [SKU: wheat-44]
  "64899667984733": "57893402018127", // 45  [SKU: wheat-45]
  "64899668017501": "57893402050895", // 46  [SKU: wheat-46]
  // ─── Wheat Black (7 variants) ───
  "64899593830749": "57893402345807", // 40  [SKU: wheat-black-40]
  "64899593863517": "57893402378575", // 41  [SKU: wheat-black-41]
  "64899593896285": "57893402411343", // 42  [SKU: wheat-black-42]
  "64899593929053": "57893402444111", // 43  [SKU: wheat-black-43]
  "64899593961821": "57893402476879", // 44  [SKU: wheat-black-44]
  "64899593994589": "57893402509647", // 45  [SKU: wheat-black-45]
  "64899594027357": "57893402542415", // 46  [SKU: wheat-black-46]
  // ─── Wheat Gum (10 variants) ───
  "64899595305309": "57893402607951", // 36  [SKU: wheat-gum-36]
  "64899595338077": "57893402640719", // 37  [SKU: wheat-gum-37]
  "64899595370845": "57893402673487", // 38  [SKU: wheat-gum-38]
  "64899595403613": "57893402706255", // 39  [SKU: wheat-gum-39]
  "64899595436381": "57893402739023", // 40  [SKU: wheat-gum-40]
  "64899595469149": "57893402771791", // 41  [SKU: wheat-gum-41]
  "64899595501917": "57893402804559", // 42  [SKU: wheat-gum-42]
  "64899595534685": "57893402837327", // 43  [SKU: wheat-gum-43]
  "64899595567453": "57893402870095", // 44  [SKU: wheat-gum-44]
  "64899595600221": "57893402902863", // 45  [SKU: wheat-gum-45]
  // ─── White Glacier (11 variants) ───
  "64899595764061": "57893402935631", // 36  [SKU: white-glacier-36]
  "64899595796829": "57893402968399", // 37  [SKU: white-glacier-37]
  "64899595829597": "57893403001167", // 38  [SKU: white-glacier-38]
  "64899595862365": "57893403033935", // 39  [SKU: white-glacier-39]
  "64899595895133": "57893403066703", // 40  [SKU: white-glacier-40]
  "64899595927901": "57893403099471", // 41  [SKU: white-glacier-41]
  "64899595960669": "57893403132239", // 42  [SKU: white-glacier-42]
  "64899595993437": "57893403165007", // 43  [SKU: white-glacier-43]
  "64899596026205": "57893403197775", // 44  [SKU: white-glacier-44]
  "64899596058973": "57893403230543", // 45  [SKU: white-glacier-45]
  "64899596091741": "57893403263311", // 46  [SKU: white-glacier-46]
  // ─── White Jewel (11 variants) ───
  "64899600089437": "57893403328847", // 36  [SKU: white-jewel-36]
  "64899600122205": "57893403361615", // 37  [SKU: white-jewel-37]
  "64899600154973": "57893403394383", // 38  [SKU: white-jewel-38]
  "64899600187741": "57893403427151", // 39  [SKU: white-jewel-39]
  "64899600220509": "57893403459919", // 40  [SKU: white-jewel-40]
  "64899600253277": "57893403492687", // 41  [SKU: white-jewel-41]
  "64899600286045": "57893403525455", // 42  [SKU: white-jewel-42]
  "64899600318813": "57893403558223", // 43  [SKU: white-jewel-43]
  "64899600351581": "57893403590991", // 44  [SKU: white-jewel-44]
  "64899600384349": "57893403623759", // 45  [SKU: white-jewel-45]
  "64899600417117": "57893403656527", // 46  [SKU: white-jewel-46]
  // ─── White Light (10 variants) ───
  "64899607265629": "57893403820367", // 36  [SKU: white-light-36]
  "64899607298397": "57893403853135", // 37  [SKU: white-light-37]
  "64899607331165": "57893403885903", // 38  [SKU: white-light-38]
  "64899607363933": "57893403918671", // 39  [SKU: white-light-39]
  "64899607396701": "57893403951439", // 40  [SKU: white-light-40]
  "64899607429469": "57893403984207", // 41  [SKU: white-light-41]
  "64899607462237": "57893404016975", // 42  [SKU: white-light-42]
  "64899607495005": "57893404049743", // 43  [SKU: white-light-43]
  "64899607527773": "57893404082511", // 44  [SKU: white-light-44]
  "64899607560541": "57893404115279", // 45  [SKU: white-light-45]
  // ─── White Persian (11 variants) ───
  "64899613917533": "57893404180815", // 36  [SKU: white-persian-36]
  "64899613950301": "57893404213583", // 37.5  [SKU: white-persian-375]
  "64899613983069": "57893404246351", // 38  [SKU: white-persian-38]
  "64899614015837": "57893404279119", // 39  [SKU: white-persian-39]
  "64899614048605": "57893404311887", // 40  [SKU: white-persian-40]
  "64899614081373": "57893404344655", // 41  [SKU: white-persian-41]
  "64899614114141": "57893404377423", // 42  [SKU: white-persian-42]
  "64899614146909": "57893404410191", // 43  [SKU: white-persian-43]
  "64899614179677": "57893404442959", // 44  [SKU: white-persian-44]
  "64899614212445": "57893404475727", // 45  [SKU: white-persian-45]
  "64899614245213": "57893404508495", // 46  [SKU: white-persian-46]
  // ─── White Rattan (10 variants) ───
  "64899626336605": "57893404606799", // 36  [SKU: white-rattan-36]
  "64899626369373": "57893404639567", // 37  [SKU: white-rattan-37]
  "64899626402141": "57893404672335", // 38  [SKU: white-rattan-38]
  "64899626434909": "57893404705103", // 39  [SKU: white-rattan-39]
  "64899626467677": "57893404737871", // 40  [SKU: white-rattan-40]
  "64899626500445": "57893404770639", // 41  [SKU: white-rattan-41]
  "64899626533213": "57893404803407", // 42  [SKU: white-rattan-42]
  "64899626565981": "57893404836175", // 43  [SKU: white-rattan-43]
  "64899626598749": "57893404868943", // 44  [SKU: white-rattan-44]
  "64899626631517": "57893404901711", // 45  [SKU: white-rattan-45]
  // ─── Wolf (11 variants) ───
  "64899630825821": "57893404934479", // 36  [SKU: wolf-36]
  "64899630858589": "57893404967247", // 37  [SKU: wolf-37]
  "64899630891357": "57893405000015", // 38  [SKU: wolf-38]
  "64899630924125": "57893405032783", // 39  [SKU: wolf-39]
  "64899630956893": "57893405065551", // 40  [SKU: wolf-40]
  "64899630989661": "57893405098319", // 41  [SKU: wolf-41]
  "64899631022429": "57893405131087", // 42  [SKU: wolf-42]
  "64899631055197": "57893405163855", // 43  [SKU: wolf-43]
  "64899631087965": "57893405196623", // 44  [SKU: wolf-44]
  "64899631120733": "57893405229391", // 45  [SKU: wolf-45]
  "64899631153501": "57893405262159", // 46  [SKU: wolf-46]
  // ─── Wolf Grey (10 variants) ───
  "64899636789597": "57893405393231", // 36  [SKU: wolf-grey-36]
  "64899636822365": "57893405425999", // 37  [SKU: wolf-grey-37]
  "64899636855133": "57893405458767", // 38  [SKU: wolf-grey-38]
  "64899636887901": "57893405491535", // 39  [SKU: wolf-grey-39]
  "64899636920669": "57893405524303", // 40  [SKU: wolf-grey-40]
  "64899636953437": "57893405557071", // 41  [SKU: wolf-grey-41]
  "64899636986205": "57893405589839", // 42  [SKU: wolf-grey-42]
  "64899637018973": "57893405622607", // 43  [SKU: wolf-grey-43]
  "64899637051741": "57893405655375", // 44  [SKU: wolf-grey-44]
  "64899637084509": "57893405688143", // 45  [SKU: wolf-grey-45]
  // ─── YOT Snake (10 variants) ───
  "64899668214109": "57893405720911", // 36  [SKU: yot-snake-36]
  "64899668246877": "57893405753679", // 37.5  [SKU: yot-snake-375]
  "64899668279645": "57893405786447", // 38  [SKU: yot-snake-38]
  "64899668312413": "57893405819215", // 39  [SKU: yot-snake-39]
  "64899668345181": "57893405851983", // 40  [SKU: yot-snake-40]
  "64899668377949": "57893405884751", // 41  [SKU: yot-snake-41]
  "64899668410717": "57893405917519", // 42  [SKU: yot-snake-42]
  "64899668443485": "57893405950287", // 43  [SKU: yot-snake-43]
  "64899668476253": "57893405983055", // 44  [SKU: yot-snake-44]
  "64899668509021": "57893406015823", // 45  [SKU: yot-snake-45]
  // ─── Youth Sports (12 variants) ───
  "64899642261853": "57893406048591", // Milan  [SKU: youth-sports-39-milan]
  "64899642294621": "57893406114127", // Milan  [SKU: youth-sports-40-milan]
  "64899642327389": "57893406179663", // Milan  [SKU: youth-sports-41-milan]
  "64899642360157": "57893406245199", // Milan  [SKU: youth-sports-42-milan]
  "64899642392925": "57893406310735", // Milan  [SKU: youth-sports-43-milan]
  "64899642425693": "57893406376271", // Milan  [SKU: youth-sports-44-milan]
  "64899642458461": "57893406081359", // Mika  [SKU: youth-sports-39-mika]
  "64899642491229": "57893406146895", // Mika  [SKU: youth-sports-40-mika]
  "64899642523997": "57893406212431", // Mika  [SKU: youth-sports-41-mika]
  "64899642556765": "57893406277967", // Mika  [SKU: youth-sports-42-mika]
  "64899642589533": "57893406343503", // Mika  [SKU: youth-sports-43-mika]
  "64899642622301": "57893406409039", // Mika  [SKU: youth-sports-44-mika]
  // ─── Zeezout Regenwolk (11 variants) ───
  "64899650027869": "57893406736719", // 36  [SKU: zeezout-regenwolk-36]
  "64899650060637": "57893406769487", // 37  [SKU: zeezout-regenwolk-37]
  "64899650093405": "57893406802255", // 38  [SKU: zeezout-regenwolk-38]
  "64899650126173": "57893406835023", // 39.5  [SKU: zeezout-regenwolk-395]
  "64899650158941": "57893406867791", // 40  [SKU: zeezout-regenwolk-40]
  "64899650191709": "57893406900559", // 41.5  [SKU: zeezout-regenwolk-415]
  "64899650224477": "57893406933327", // 42  [SKU: zeezout-regenwolk-42]
  "64899650257245": "57893406966095", // 43  [SKU: zeezout-regenwolk-43]
  "64899650290013": "57893406998863", // 44  [SKU: zeezout-regenwolk-44]
  "64899650322781": "57893407031631", // 45  [SKU: zeezout-regenwolk-45]
  "64899650355549": "57893407064399", // 46.5  [SKU: zeezout-regenwolk-465]
};
